<!-- eslint-disable no-irregular-whitespace -->
<!--公开发售协议-->
<template>
  <div class="publicofferingagreement">
    <div class="chinese" v-show="this.language=='zh_CN'">
      <table width="645" border="0" cellpadding="0" cellspacing="0" style='width:483.75pt;border-collapse:collapse;table-layout:fixed;'>
        <col width="645" class="xl65" style='mso-width-source:userset;mso-width-alt:20640;'/>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl66" height="36" width="645" style='height:27.00pt;width:483.75pt;'>使用协议</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>本协议旨在管辖所有者（以下简称管理部门或 <font class="font25">KORDICEPSAS</font><font class="font3">）与网站用户之间的关系。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>使用本网站即表示用户同意本协议的以下条款。</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>主管部门有权随时单方面变更本协议，恕不另行通知。</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>未经主管部门事先同意，禁止复制、转载和以其他方式使用本网站的资料。</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl66" height="36" style='height:27.00pt;'>协议内容：</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1. <font class="font3">忠诚度计划条款。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>2. <font class="font3">订单流程。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3. <font class="font3">个人数据处理政策</font></td>
        </tr>
        <tr height="37" style='height:27.75pt;'>
          <td class="xl70" height="37" style='height:27.75pt;'>1.<font class="font2">忠诚计划条款</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>术语和表示法</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>此要约中使用的术语和名称列表在网站上。</td>
        </tr>
        <tr height="32" style='height:24.00pt;'>
          <td class="xl67" height="32" style='height:24.00pt;'>忠诚度计划是 Internet 上的一项免费电子服务，网址为 https://www.whieda.org/#/，它为用户提供服务，使他们能够返还在在线商店购买时花费的部分资金。</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>用户<font class="font1"> - </font><font class="font3">在线商店的访问者，在网站上注册的个人。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>现金返还<font class="font1"> - </font><font class="font3">退还在线商店购物所花费的部分资金。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>帐户<font class="font1"> - </font><font class="font3">一个用户帐户，可以访问在线商店的所有功能，包括返现记入的内部帐户。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>管理<font class="font1"> - </font><font class="font3">授权在线商店的员工根据此优惠使用用户帐户执行任何操作。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>内部账户<font class="font1"> - </font><font class="font3">在线商店用户的账户，确定应计返现及其状态。</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl67" height="33" style='height:24.75pt;'>广告材料<font class="font1">——</font><font class="font3">横幅、推荐链接和其他吸引新用户的工具，有可能因推荐和注册推荐的积极行动（购买）而获得奖励。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>欺诈行为是任何形式的欺诈，其目的是非法获得返现。</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>垃圾邮件<font class="font1"> - </font><font class="font3">不考虑收件人的意愿而大量发送具有广告性质的信息或其他类型的消息。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.1. <font class="font3">总则</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.1.1. <font class="font3">通过在网站上注册，用户确认：</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>a) <font class="font3">用户年满</font><font class="font1"> 18 </font><font class="font3">周岁；</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>b) <font class="font3">用户具有法律行为能力，根据其所在国家的法律具有法律能力；</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>c) <font class="font3">用户承诺不允许</font><font class="font1">18</font><font class="font3">岁以下的人使用忠诚度计划；</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>d) <font class="font3">用户承诺不允许无行为能力、不称职的人使用忠诚度计划，并对不允许此类人使用忠诚度计划负个人责任；</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>e) <font class="font3">该帐户将仅用于帐户持有人进行购买；</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>f) <font class="font3">用户确认已收到管理员通知并同意在必要时由管理员更改本报价内容；</font><font class="font1"> - </font><font class="font3">用户确认已阅读本要约，并无条件接受其条款；</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>g) <font class="font3">用户确认完全理解自己的所有权利和义务。</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.1.2. <font class="font3">管理员根据忠诚度计划向用户支付现金返还，该现金返还由忠诚度计划</font><font class="font1">“</font><font class="font3">在线商店现金返还系统</font><font class="font1">”</font><font class="font3">的奖金形成一定数额，前提是用户遵守所有规则和建议，商品不退还给卖方（全部或部分），或拒绝服务</font></td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>1.1.3. <font class="font3">参与忠诚度计划时，将在订单确认后立即收到现金返还。</font><font class="font1"> </font><font class="font3">通常这会在</font><font class="font1"> 1 </font><font class="font3">分钟内发生，但在某些情况下，存入资金的期限最长可达</font><font class="font1"> 24 </font><font class="font3">小时。</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.1.4. <font class="font3">在系统故障、拒绝进行支付操作的情况下，现金返还将不会被记入贷方。</font><font class="font1"> </font><font class="font3">在这种情况下，您需要联系公司的热线。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.2. <font class="font3">现金返还累积规则</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.2.1. <font class="font3">要累积现金返还，用户必须在网站上注册并获得授权，参与忠诚度计划并满足其条件。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.3. <font class="font3">现金返还支付</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.3.1. <font class="font3">用户可在账户金额达到最低提现门槛后提出提现请求。</font><font class="font1"> </font><font class="font3">有关现金返还提款方式以及最低提款金额的信息可在用户帐户中找到。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.3.2. <font class="font3">一次性取款金额不少于</font><font class="font1">150</font><font class="font3">欧元。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.3.3. <font class="font3">资金支付申请将在</font><font class="font1"> 24 </font><font class="font3">小时内处理。</font><font class="font1"> </font><font class="font3">最长期限为</font><font class="font1"> 72 </font><font class="font3">小时。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.3.4. <font class="font3">如果怀疑用户有欺诈行为，或怀疑未经授权访问账户和第三方账户，资金支付申请可能会被拒绝或延迟。</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.3.5. <font class="font3">支付现金返还年度累计不超过</font><font class="font1">1800</font><font class="font3">欧时，不收取用户居住国家</font><font class="font1">/</font><font class="font3">地区的税费。</font><font class="font1"> </font><font class="font26">用户有义务自行采取行动缴纳税款。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.3.6. <font class="font3">支付返现时，收款方（用户）银行账户收取或扣除的手续费由用户自行承担。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.3.7. “<font class="font3">管理方</font><font class="font1">”</font><font class="font3">有权随时单方更改返现支付条款。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.4. <font class="font3">推荐计划</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.4.1. <font class="font3">在网站上注册后，用户会收到一个单独的推荐链接，以吸引新用户以获得奖励。</font></td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>1.4.2. <font class="font3">广告材料，包括推荐链接和横幅，用户有权将其放置在他的网站或社交网络的页面上，并发送给他的朋友。</font><font class="font1"> </font><font class="font3">点击用户推荐链接的访问者将被视为他的推荐。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.4.3. <font class="font3">吸引推荐的奖励是根据忠诚度计划</font><font class="font1">“</font><font class="font3">在线商店的现金返还系统</font><font class="font1">”</font><font class="font3">及其条件的满足情况而定。</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.4.4. <font class="font3">允许用户使用他的推荐链接注册多个帐户。</font><font class="font1"> </font><font class="font3">此类行为不会被视为欺诈，也不会导致所有多账户在未支付余额资金的情况下被冻结。</font></td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>1.4.5. <font class="font26">禁止用户吸引以前注册的用户，这些用户在网站</font><font class="font1"> https://www.whieda.org/#/ </font><font class="font26">上以不同的结构注册了一个帐户。</font><font class="font1"> </font><font class="font26">如果发现此类行为，管理员有权限制用户访问帐户，无需从用户帐户中支付资金。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.4.6. <font class="font3">严禁通过发送垃圾邮件或上下文广告来吸引推荐。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.5. <font class="font3">各方责任</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.5.1. <font class="font3">禁止用户吸引先前注册的用户，这些用户在网站</font><font class="font1"> https://www.whieda.org/#/ </font><font class="font3">上以不同的结构注册了帐户。</font><font class="font1"> </font><font class="font3">如果发现此类行为，管理员有权限制用户访问帐户，无需从用户帐户中支付资金。</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.5.2. <font class="font3">用户个人对访问其帐户的数据安全负责（登录名、密码、电子邮件等）。</font><font class="font1"> </font><font class="font3">禁止向第三方提供帐户访问权限或在第三方资源上公开访问帐户。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.5.3. <font class="font3">如果用户怀疑第三方未经授权访问帐户，他有义务通过技术支持服务通知管理部门。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.5.4. <font class="font3">对于第三方未经授权访问用户帐户可能造成的损害，管理员概不负责。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.5.5.<span style='mso-spacerun:yes;'>&nbsp; </span><font class="font3">管理员不对网站的平稳运行负责。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.5.6. <font class="font3">用户承认并同意，使用忠诚度计划的最终结果可能不符合用户的预期。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.5.7. <font class="font3">在任何情况下，管理员均不对因使用本网站或无法使用本网站而造成的任何损害承担责任。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.5.8.<span style='mso-spacerun:yes;'>&nbsp; </span><font class="font3">如果发现用户有欺诈行为，管理员有权限制用户访问帐户，而无需从用户帐户中支付资金。</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.5.9. <font class="font3">如果用户的行为导致公司商业信誉下降（或损失），管理员有权限制用户访问帐户，而无需从用户帐户中支付资金。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.6. <font class="font3">返现服务的功能</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.6.1. <font class="font3">考虑到可能出现的技术问题、计划内或计划外的网站维护工作，管理部门不保证用户可以永久访问忠诚度计划数据。</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.6.2. <font class="font3">不排除因第三方恶意操作或技术问题导致系统故障的可能性。</font><font class="font1"> </font><font class="font3">在这种情况下，主管部门保留暂停服务的权利，直到完全消除技术问题或各种威胁。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.6.3. <font class="font3">主管部门承诺采取一切必要措施以确保网站的稳定运行。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.6.4. <font class="font3">管理部门承诺及时消除所有已出现的影响网站正常运行的技术问题。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.7. <font class="font3">个人信息</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.7.1. <font class="font3">通过在网站上注册，用户同意该网站使用和处理他的个人数据。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.7.2. <font class="font3">管理员保证用户仅根据个人数据保护法使用其个人数据。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.7.3. <font class="font3">管理员不会将用户的个人数据传输给合作伙伴商店或第三方。</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.7.4. <font class="font3">如果用户通过联系技术支持服务传输其个人数据，则不会存储此类数据，并且仅将其用于解决用户提出的问题。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.8. <font class="font3">电邮通讯</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.8.1. <font class="font3">通过在网站上注册，用户同意通过注册时指定的电子邮箱接收公司的信件。</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.8.2. <font class="font3">如果有必要拒绝信件，用户可以通过反馈表联系管理部门，要求删除帐户或更改用户帐户设置中接收信件的可能性。</font></td>
        </tr>
        <tr height="37" style='height:27.75pt;'>
          <td class="xl70" height="37" style='height:27.75pt;'>2. <font class="font2">订购流程</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>2.1.<font class="font3">订购：</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>2.1.1. <font class="font3">选择您要购买的商品。</font><font class="font1"> </font><font class="font3">点击</font><font class="font1">“</font><font class="font3">加入购物车</font><font class="font1">”</font><font class="font3">，产品将自动加入您的购物车。</font></td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>2.1.2. <font class="font3">在您确定购物车中的购买清单正确无误后，单击</font><font class="font1">“</font><font class="font3">结帐</font><font class="font1">”</font><font class="font3">按钮。</font><font class="font1"> </font><font class="font3">输入有关买家的信息：姓氏、联系电话和电子邮件。</font><font class="font1"> </font><font class="font3">选择送货方式。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>2.1.3. <font class="font3">我们的经理将与您联系以确认订单和交货日期。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>2.2. <font class="font3">订单支付</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>2.2.1. <font class="font3">订单支付方式：</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>a) <font class="font3">取货时以现金或</font><font class="font1"> VISA</font><font class="font3">、</font><font class="font1">MASTERCARD </font><font class="font3">或</font><font class="font1"> PAYSREA </font><font class="font3">付款。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· <font class="font3">以现金或</font><font class="font1"> VISA</font><font class="font3">、</font><font class="font1">MASTERCARD </font><font class="font3">或</font><font class="font1"> PAYSERA</font><font class="font3">卡支付（欧盟区域）。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· <font class="font3">使用</font><font class="font1"> VISA</font><font class="font3">、</font><font class="font1">MASTERCARD</font><font class="font3">卡</font><font class="font1"> </font><font class="font3">或</font><font class="font1"> PAYSERA </font><font class="font3">在网站上通过银行转账在线付款。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>2.2.2. <font class="font3">银行卡支付规则</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>2.2.2.1. <font class="font3">使用银行卡支付商品，在网店下单时，选择支付方式：银行卡支付。</font><font class="font1"> </font><font class="font3">当使用银行卡支付订单时，支付处理发生在银行的授权页面，您需要在该页面输入您的银行卡详细信息：</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.<font class="font3">卡片类型</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>2.<font class="font3">卡号</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.<font class="font3">卡片有效期（在卡片正面注明）</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>4. <font class="font3">持卡人姓名（拉丁字母，与卡片上的姓名完全一致）</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>5.CVC2/CVV2<font class="font3">码</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl67" height="33" style='height:24.75pt;'>如果您的卡连接到<font class="font1"> 3D-Secure </font><font class="font3">服务，您将被自动重定向到发卡银行的页面以完成身份验证程序。</font><font class="font1"> </font><font class="font3">有关附加身份识别的规则和方法，请向您的银行卡发卡行查询。</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl67" height="33" style='height:24.75pt;'>通过银行支付网关处理互联网支付的安全性由<font class="font1">PCI DSS</font><font class="font3">国际安全证书保证。</font><font class="font1"> </font><font class="font3">信息使用</font><font class="font1"> TLS </font><font class="font3">加密技术传输。</font><font class="font1"> </font><font class="font3">第三方无法获得此信息。</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>2.3. <font class="font3">用户出于商业目的购买产品，与个人、家庭、家居或其他需求无关。</font><font class="font1"> </font><font class="font3">不允许退回质量合格的商品。</font><font class="font1"> </font><font class="font3">质量不合格货物的退货将根据购买货物所在州的现行立法规定的程序进行。</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>2.4. <font class="font3">禁止以与官网价格不同的价格在其他市场转售商品。</font><font class="font1"> </font><font class="font3">如果出现此类先例，</font><font class="font1">“</font><font class="font3">用户</font><font class="font1">”</font><font class="font3">的个人帐户将被停用。</font><font class="font1"> </font><font class="font3">如有必要，政府保留在法庭上解决这些情况的可能性。</font></td>
        </tr>
        <tr height="37" style='height:27.75pt;'>
          <td class="xl70" height="37" style='height:27.75pt;'>3.<font class="font2">隐私政策</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.1. <font class="font3">基本概念</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>个人数据<font class="font1"> - </font><font class="font3">与用户有关的任何信息。</font><font class="font1"> </font><font class="font3">用户</font><font class="font1">——</font><font class="font3">使用本网站的个人。</font></td>
        </tr>
        <tr height="32" style='height:24.00pt;'>
          <td class="xl67" height="32" style='height:24.00pt;'>网站 - 属于主管部门的一组自动化信息系统和信息，无论其呈现形式如何，可在以下域（包括子域）的网络地址上的互联网上访问：https://www.whieda.org/# /.</td>
        </tr>
        <tr height="49" style='height:36.75pt;'>
          <td class="xl67" height="49" style='height:36.75pt;'>个人数据处理<font class="font1">-</font><font class="font3">使用自动化工具或不使用此类工具对个人数据执行的任何动作（操作）或一组动作（操作），包括收集、记录、系统化、积累、存储、澄清（更新、更改）、提取、使用、传输（分发、提供、访问）、去个性化、阻止、删除、销毁个人数据。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>个人数据的自动处理<font class="font1">——</font><font class="font3">借助计算机技术处理个人数据。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>社交网络<font class="font1"> - </font><font class="font3">信息和电信网络</font><font class="font1"> Internet </font><font class="font3">中的站点，由第三方拥有，用于人们的远程通信。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>服务<font class="font1"> - </font><font class="font3">产品、服务、版权对象由主管部门提供给相关方购买，根据民法合同条款通过网站使用。</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl67" height="33" style='height:24.75pt;'>个人帐户<font class="font1"> - </font><font class="font3">网站的个人部分和网站的附加功能，用户在网站上注册和</font><font class="font1">/</font><font class="font3">或授权后获得访问权限。</font><font class="font1"> </font><font class="font3">个人帐户旨在存储用户的个人数据、查看和管理网站的可用功能以及网站的相关使用条款、管理通过网站进行的交易。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>用户协议<font class="font1"> - </font><font class="font3">使用本网站的民法合同。</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl67" height="33" style='height:24.75pt;'>订单<font class="font1"> - </font><font class="font3">一组自动生成的关于用户旨在与主管部门就使用服务签订民法合同的行为的数据，包括有关用户选择的服务的信息、服务的费用、日期和时间形成这样的命令。</font></td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;'>现金收据是用户和管理部门之间就服务使用合同的签订、执行和终止进行结算时生成的主要会计凭证。<font class="font1"> </font><font class="font3">结算的概念在法律</font><font class="font1">“</font><font class="font3">关于在现金结算和（或）使用电子支付方式的结算中使用收银机</font><font class="font1">”</font><font class="font3">中定义的意义上使用。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>支付方式<font class="font1"> - </font><font class="font3">有关银行、支付系统、用户为服务支付所使用的支付方式的信息。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.2 <font class="font3">同意处理个人数据</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>3.2.1 <font class="font3">用户决定向主管部门提供其个人资料，接受用户协议的条款，并同意根据自己的意愿和自身利益自由处理其个人资料。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.2.1 <font class="font3">如果用户同意处理其个人数据，则视为已提供给主管部门：</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>a) <font class="font3">在点击</font><font class="font1">“</font><font class="font3">注册</font><font class="font1">”</font><font class="font3">按钮后填写网站上提供的表格在网站上注册时。</font><font class="font1"> </font><font class="font3">在点击</font><font class="font1">“</font><font class="font3">继续</font><font class="font1">”</font><font class="font3">按钮时，用户被视为同意处理其个人数据。</font></td>
        </tr>
        <tr height="50" style='height:37.50pt;'>
          <td class="xl69" height="50" style='height:37.50pt;'>b) <font class="font3">在</font><font class="font1">“</font><font class="font3">更改联系信息</font><font class="font1">”</font><font class="font3">、</font><font class="font1">“</font><font class="font3">联系人列表</font><font class="font1">”</font><font class="font3">、</font><font class="font1">“</font><font class="font3">密码</font><font class="font1">”</font><font class="font3">、</font><font class="font1">“</font><font class="font3">交易密码</font><font class="font1">”</font><font class="font3">、</font><font class="font1">“</font><font class="font3">电子邮件通讯</font><font class="font1">”</font><font class="font3">小节的</font><font class="font1">“</font><font class="font3">配置文件设置</font><font class="font1">”</font><font class="font3">部分输入或更改个人数据时</font><font class="font1"> - </font><font class="font3">对于个人数据，用户在个人账户中编辑信息时提供。</font><font class="font1"> </font><font class="font3">在按下</font><font class="font1">“</font><font class="font3">保存</font><font class="font1">”</font><font class="font3">或</font><font class="font1">“</font><font class="font3">更改</font><font class="font1">”</font><font class="font3">按钮时，或在按下界面按钮时，用户被视为已同意处理其新输入或更改的个人数据，明确表示澄清，更改、删除、更正个人数据。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.3. <font class="font3">管理部门处理的个人数据</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.3.1 <font class="font3">管理员处理用户的以下个人数据：</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>a) <font class="font3">在网站上注册用户时：</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·名</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·姓</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·电子邮箱</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·联系电话</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· Cookie <font class="font3">文件</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>b) <font class="font3">向主管部门发送信息性消息、问题、反馈时：</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·电子邮箱</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·名</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·姓</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·联系电话</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· Cookie <font class="font3">文件</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>c) <font class="font3">在</font><font class="font1">“</font><font class="font3">配置文件设置</font><font class="font1">”</font><font class="font3">部分输入或更改个人数据时：</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·  名</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·  姓</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·  电子邮箱</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·  联系电话</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>·  <font class="font3">邮寄地址</font><font class="font1">;</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· Cookie <font class="font3">文件</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>e) <font class="font3">当注册用户为服务付费时：</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·收货地址；</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· <font class="font3">电子邮件地址</font><font class="font1">;</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·名</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·姓</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· <font class="font3">订单；</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·用户履行金融义务的日期、时间和金额；</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·用户未履行的财务义务的金额和履行条款；</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· <font class="font3">购物小票及购物小票资料；</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· <font class="font3">付款方式</font><font class="font1">;</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·向用户提供的折扣和折扣理由；</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· Cookie <font class="font3">文件</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>f) <font class="font3">报名参加由主管部门举办的活动、直播活动时：</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·名</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·姓</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· <font class="font3">电子邮件地址</font><font class="font1">;</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· Cookie <font class="font3">文件</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>g) <font class="font3">主管机关进行统计和（或）研究调查时：</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·名</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·年龄</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·职业和（或）兴趣爱好；</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· <font class="font3">电子邮件地址</font><font class="font1">;</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· Cookie <font class="font3">文件</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>h) <font class="font3">当通过电话接受咨询服务时：用户拨打的电话号码；</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·名</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·姓</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·用户在网站上的注册数据；</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·用户根据其意愿并出于自身利益向管理部门报告的其他个人数据。</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>i) <font class="font3">在收集有关用户的信息以向用户展示个性化信息和广告信息时：</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· Cookie <font class="font3">标识符；</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· <font class="font3">浏览器用户代理术语；</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·使用广告拦截器；</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·截断的<font class="font1"> IP </font><font class="font3">地址；</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·浏览记录<font class="font1">;</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·互联网访问数据；</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·担任职位<font class="font1">/</font><font class="font3">劳动职能；</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·有关已查看产品、价格、查看日期和时间的数据；</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·化名的电子邮件地址；</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· <font class="font3">地理定位</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·有关浏览器、设备、设置的技术数据；</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·关于与广告的互动（点击、拒绝、转换等）</td>
        </tr>
        <tr height="50" style='height:37.50pt;'>
          <td class="xl67" height="50" style='height:37.50pt;'>在收集这些信息时，它与唯一标识符相关联，即<font class="font1"> cookie </font><font class="font3">标识符和其他类似技术，并且不允许直接识别用户（数据匿名化）。</font><font class="font1"> </font><font class="font3">用户可以按照用户浏览器制造商描述的方式，在其浏览器中禁用收集这些信息。</font><font class="font1"> </font><font class="font3">管理员有权将按照本款规定收到的信息转给第三方。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.4. <font class="font3">个人数据处理的目的</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.4.2. <font class="font3">主管部门仅出于以下目的处理用户的个人数据：</font></td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>a) <font class="font3">当用户使用网站时，无论是在用户在网站上注册期间还是在没有注册的情况下，管理部门都会处理用户的个人数据，以履行网站使用合同（用户协议）</font><font class="font1"> . </font><font class="font3">为此，主管部门在第</font><font class="font1"> 3.3 </font><font class="font3">条中处理个人数据。</font><font class="font1"> </font><font class="font3">现协议。</font></td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>b) <font class="font3">为履行用户使用本网站功能时用户自愿引入、修改、澄清、删除用户个人数据的功能。</font><font class="font1"> </font><font class="font3">为此，主管部门在第</font><font class="font1"> 3.3.1 </font><font class="font3">条中处理个人数据。</font><font class="font1"> </font><font class="font3">现协议。</font></td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>c) <font class="font3">为了在用户未事先在网站上注册的情况下订立和执行用户使用服务的合同，主管部门处理第</font><font class="font1"> 3.3.1 </font><font class="font3">条中的个人数据。</font><font class="font1"> </font><font class="font3">现协议。</font></td>
        </tr>
        <tr height="50" style='height:37.50pt;'>
          <td class="xl69" height="50" style='height:37.50pt;'>d) <font class="font3">为了让用户从管理部门接收有关网站功能、服务的信息，以便用户向管理部门发送信息消息、问题、反馈，接收建议并向用户提供其他信息支持在执行用户协议以及服务使用合同时，主管部门处理个人数据，第</font><font class="font1"> 3.3.1 </font><font class="font3">条。</font><font class="font1"> </font><font class="font3">现协议。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>e) <font class="font3">为了满足用户接收时事通讯的请求，主管部门处理个人数据，第</font><font class="font1"> 3.3.1 </font><font class="font3">条。</font><font class="font1"> </font><font class="font3">现协议。</font></td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>f) <font class="font3">为了提高服务质量、改进网站、根据用户的非个性化信息进行统计和其他研究，管理部门处理个人数据，第</font><font class="font1"> 3.3.1 </font><font class="font3">条。</font><font class="font1"> </font><font class="font3">现协议。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>g) <font class="font3">为了签订和执行使用服务的合同，主管部门处理个人数据，第</font><font class="font1"> 3.3.1 </font><font class="font3">条。</font><font class="font1"> </font><font class="font3">现协议。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>h) <font class="font3">为履行用户与主管部门之间举行比赛的合同，主管部门的个人数据，第</font><font class="font1"> 3.3.1 </font><font class="font3">条。</font><font class="font1"> </font><font class="font3">现协议。</font></td>
        </tr>
        <tr height="37" style='height:27.75pt;'>
          <td class="xl70" height="37" style='height:27.75pt;'>3.5. <font class="font2">处理个人数据的条件</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.5.1. <font class="font3">主管部门基于用户的善意推定，从以下事实出发：在网站上提供个人数据时，用户：</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>3.5.1.1<font class="font3">。</font><font class="font1"> </font><font class="font3">是一个称职的人。</font><font class="font1"> </font><font class="font3">如果此人无行为能力，则同意处理个人数据的用户法定代表已阅读并同意本政策中规定的处理个人数据的条件。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.5.1.2. <font class="font3">在使用本网站所必需的范围内表明有关他自己的可靠信息，并使所提供的个人数据保持最新。</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>3.5.1.3. <font class="font3">如果通过个人帐户上传他的图像</font><font class="font1">​​</font><font class="font3">，他同意免费使用此图像用于与用户身份无关的目的。</font><font class="font1"> </font><font class="font3">用户承诺不提供第三方照片作为用户形象。</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>3.5.1.4<font class="font3">。</font><font class="font1"> </font><font class="font3">知道用户在网站上发布的关于他自己的信息可能会被网站的其他用户使用，这些用户可能会复制和分发；</font></td>
        </tr>
        <tr height="50" style='height:37.50pt;'>
          <td class="xl69" height="50" style='height:37.50pt;'>3.5.1.5<font class="font3">。</font><font class="font1"> </font><font class="font3">意识到网站的功能允许用户独立地为其他用户建立对部分个人数据的公共访问权限（可见模式）。</font><font class="font1"> </font><font class="font3">用户建立对其个人数据的公共访问权限被解释为用户出于其意愿并出于自身利益披露个人数据。</font><font class="font1"> </font><font class="font3">用户保证他知道向其他用户披露他的个人数据的后果，并且不会向管理部门提出索赔。</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>3.5.1.6. <font class="font3">意识到某些个人数据的处理是基于现行法律的要求，并且为了履行与此类用户的合同，有必要处理个人数据。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.5.3. <font class="font3">澄清，个人数据的更改可以由用户使用个人帐户独立进行。</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>3.5.4. <font class="font3">用户知道，为了他自己和自己的利益，他必须独立检查个人数据的相关性，并对个人账户中的个人数据进行必要的澄清和更改。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.5.5. <font class="font3">只有在以下情况下才能分发个人数据：</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>3.5.5.1<font class="font3">。</font><font class="font1"> </font><font class="font3">根据用户的意愿，用户建立其个人数据的公共访问权限（可见模式）以显示用户的个人资料，以及网站其他用户的部分个人数据。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.5.6. <font class="font3">主管部门有权出于以下目的将个人数据传输给第三方：</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.5.6.1. <font class="font3">第三方参与执行用户与主管部门之间达成的协议，以提高这些协议的执行质量；</font></td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>3.5.7. <font class="font3">主管部门有权将个人数据传输给第三方，前提是此类第三方在处理过程中确保个人数据的机密性，并遵守确保个人数据安全的措施。</font><font class="font1"> </font><font class="font3">禁止第三方传输和分发用户的个人数据。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.5.8. <font class="font3">在以下情况下，将终止处理用户的个人数据、阻止和销毁个人数据：</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>a) <font class="font3">用户删除个人账户中的个人数据；</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>b) <font class="font3">主管部门收到用户撤回处理个人数据的同意书；</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>c) <font class="font3">主管部门收到用户销毁或封锁个人数据的请求；</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>d) <font class="font3">用户同意处理其个人数据的期限届满。</font></td>
        </tr>
        <tr height="100" style='height:75.00pt;'>
          <td class="xl69" height="100" style='height:75.00pt;'>3.5.9. <font class="font3">主管部门采取必要和充分的法律、组织和技术措施来保护个人数据免遭未经授权或意外访问、破坏、修改、阻止、复制、分发以及第三方针对个人数据采取的其他非法行为。</font><font class="font1"> </font><font class="font3">特别是，主管部门采取组织和技术措施确保个人数据在处理过程中的安全，控制未经授权访问个人数据的事实并采取措施防止将来发生此类事件，控制为确保个人数据的安全性和个人数据的保护级别。</font><font class="font1"> </font><font class="font3">为了授权访问个人帐户，用户使用用户的登录名（电子邮件地址）和密码。</font><font class="font1"> </font><font class="font3">用户负责此信息的安全。</font><font class="font1"> </font><font class="font3">用户无权将自己的登录名和密码转让给第三方，也有义务采取措施确保其机密性。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.6. <font class="font3">用户享有以下权利：</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>3.6.1. <font class="font3">根据本协议规定的条款，根据自己的意愿并出于自身利益，自行决定向主管部门提供个人数据以供其处理；</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.6.2. <font class="font3">独立提供、更改和删除个人帐户中的个人数据，前提是此类更改和更正包含最新且可靠的信息；</font></td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>3.6.3. <font class="font3">联系管理部门提出请求，包括销毁个人数据、撤销对处理的同意、阻止个人数据。</font><font class="font1"> </font><font class="font3">按照第</font><font class="font1"> 3.6.2 </font><font class="font3">条规定的方式提出请求。</font><font class="font1"> </font><font class="font3">现协议。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.6.4. <font class="font3">自行删除个人账号或要求管理员按照</font><font class="font1">3.6.2</font><font class="font3">条规定的方式删除个人账号。</font><font class="font1"> </font><font class="font3">现有协议；</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.6.5. <font class="font3">独立建立部分个人数据的公开访问模式（可见模式），取消该模式。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.6.6. <font class="font3">用户有权通过以下方式向主管机关提出要求和要求：</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.6.7. <font class="font3">以书面形式发送至网站上指定的主管部门的邮政地址；</font></td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>3.6.8. <font class="font3">该文件必须从用户在网站上注册时或在服务使用协议中指定的电子邮件地址发送到管理部门的电子邮件地址</font><font class="font1"> eu-info@foherb.com</font><font class="font3">。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.6.9. <font class="font3">用户发送的请求和请求必须包含以下信息：</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>A) <font class="font3">用户的姓氏、名字、父名；</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>B) <font class="font3">用户在网站上的注册数据（如果用户在发送请求或请求时已经注册）；</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>c) <font class="font3">用户要求或要求的实质；</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>D) <font class="font3">用户签名。</font></td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl69" height="51" style='height:38.25pt;'>3.6.10 <font class="font3">主管部门考虑从用户那里收到的关于强制性详细信息的可用性、请求或上诉的有效性的要求和请求。</font><font class="font1"> </font><font class="font3">用户请求成立的，本站自收到之日起</font><font class="font1">30</font><font class="font3">日内予以满足。</font><font class="font1"> </font><font class="font3">在任何情况下，主管部门都会在收到请求或申诉之日起不超过</font><font class="font1"> 30 </font><font class="font3">天内向用户发送回复。</font><font class="font1"> </font><font class="font3">答复以与用户请求或申诉的形式相对应的形式发送给用户。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.7. <font class="font3">变更政策</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.7.1. <font class="font3">管理员保留更改用户协议的权利。</font><font class="font1"> </font><font class="font3">每次使用本网站时，用户有义务熟悉用户协议的内容。</font></td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>3.7.2. <font class="font3">新版用户协议自发布在网站相关部分之时起生效。</font><font class="font1"> </font><font class="font3">在发布新版用户协议后继续使用本网站或其服务即表示用户接受用户协议及其条款。</font><font class="font1"> </font><font class="font3">如果不同意用户协议的条款，用户必须立即停止使用本网站。</font></td>
        </tr>
      </table>
    </div>
    <div class="chinese" v-show="this.language=='he_IL'">
      <table width="645" border="0" cellpadding="0" cellspacing="0" style='width:483.75pt;border-collapse:collapse;table-layout:fixed;'>
        <col width="645" class="xl65" style='mso-width-source:userset;mso-width-alt:20640;'/>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl66" height="36" width="645" style='height:27.00pt;width:483.75pt;'>הסכם שימוש</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>
            הסכם שימוש זה מסדיר את היחסים בין הבעלים (להלן - ההנהלה ו(או) KORDICEPSAS) מצד אחד לבין משתמשי האתר מצד שני.
          </td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>
            השימוש באתר מהווה את הסכמת המשתמש לתנאים של הסכם זה המפורטים להלן
          </td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>
            להנהלה שמורה הזכות לשנות הסכם זה באופן חד צדדי בכל עת וללא התראה.
          </td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>
            העתקה, הדפסה וכל שימוש אחר בחומרים של האתר ללא תיאום מראש עם ההנהלה אסורים.
          </td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl66" height="36" style='height:27.00pt;'>תוכן ההסכם:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1. תנאי תוכנית הנאמנות</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>2. סדר ביצוע ההזמנות</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3. מדיניות עיבוד הפרטים האישיים.</td>
        </tr>
        <tr height="37" style='height:27.75pt;'>
          <td class="xl70" height="37" style='height:27.75pt;'>1. תנאי תוכנית הנאמנות</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>מונחים ומושגים</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>רשימת מונחים ומושגים, המיושמת בהצעה זו, באתר</td>
        </tr>
        <tr height="32" style='height:24.00pt;'>
          <td class="xl67" height="32" style='height:24.00pt;'>
            תכנית נאמנות - שירות דיגיטלי חינמי ברשת אינטרנט, מצוי בכתובת:  https://www.whieda.org/#/, ומעניק למשתמשים אפשרות לקבל בחזרה חלק מהכספים שהוצאו על רכישות בחנות האינטרנט.
          </td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>
            משתמש - גולש בחנות האינטרנט, ישות פיזית הרשומה באתר
          </td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>
            קאשבק - השבה חלקית של הכספים המשולמים בגין רכישות בחנות האינטרנט
          </td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>
            חשבון - רישום מעקב משתמש, המעניק גישה לכלל התכונות של חנות האינטרנט, לרבות לחשבון הפנימי אליו מועבר הקאשבק.
          </td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>
            ההנהלה - עובדי חנות האינטרנט המורשים לביצוע כל הפעולות בחשבונו של המשתמש במסגרת הצעה זו.
          </td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>
            חשבון פנימי - חשבון המשתמש של חנות האינטרנט, המתעד את צבירת הקאשבק והסטטוס שלו
          </td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl67" height="33" style='height:24.75pt;'>
            חומרי פרסום - באנרים, קישורי הזמנה ויתר הכלים למשיכת משתמשים חדשים, עם אפשרות קבלת תגמול בגין פעולות (רכישות) של משתמשים חדשים אשר נרשמו בעקבות חשיפה לחומרי פרסום</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>
            פעולת כזב - תרמית מכל סוג שמטרתה - לקבל קאשבק באופן בלתי חוקי
          </td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>
            ספאם - שליחה המונית של מידע פרסומי או הודעות אחרות ללא התחשבות ברצון הנמענים</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.1 הוראות כלליות</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>
            1.1.1 בהרשמו באתר המשתמש מאשר כי:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>
            א) מלאו למשתמש 18 שנים לפחות;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>
            ב) המשתמש הינו בעל כשרות משפטית בהתאם לחקיקת מדינתו;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>
            ג) המשתמש מתחייב לא לאפשר שימוש בתוכנית הנאמנות ע"י אדם שטרם מלאו לו 18 שנים;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>
            ד) המשתמש מתחייב לא לאפשר שימוש בתוכנית הנאמנות ע"י אדם שאינו בעל כשרות משפטית ונושא באחריות אישית בגין מניעת שימוש בתוכנית הנאמנות ע"י אדם כאמור;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>ה) החשבון ישמש אך ורק לביצוע הרכישות בשם בעליו</td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>ו) המשתמש מאשר כי הוא מודע ומסכים לשינוי תוכנה של הצעה זו ע"י ההנהלה במידת הצורך; המשתמש מאשר שהוא עיין בהצעה זו ומקבל את תנאיה ללא סייג;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>ז) המשתמש מאשר כי כל זכויותיו וחובותיו ברורים לו לחלוטין.</td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.1.2 המנהל משלם למשתמש קאשבק, אשר נוצר על חשבון הטבות תוכנית הנאמנות "שיטת קאשבק של חנות האינטרנט" בסכום מוגדר, בכפוף לעמידה בכל הכללים וההמלצות, וכן בתנאי של היעדר החזרת מוצר למוכר (באופן מלא או חלקי) או סירוב לשירות</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>1.1.3 קבלת קאשבק מתרחשת מיד לאחר אישור הזמנה ע"י המשתתף בתוכנית הנאמנות. ככלל מתבצע הדבר תוך דקה 1, אולם במקרים אחדים תיתכן העברת כספים תוך פרק זמן של עד 24 שעות.</td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.1.4 במקרים של תקלה במערכת, סירוב לביצוע פעולת תשלום, לא יזוכה קאשבק, במצבים כאמור יש לפנות למוקד של החברה.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.2 כללי זיכוי קאשבק</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.2.1 כתנאי לזיכוי קאשבק על המשתמש להיות רשום ומזוהה באתר, להשתתף בתוכנית הנאמנות ולקיים את תנאיה.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.3 תשלומי קאשבק</td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.3.1 המשתמש רשאי להגיש בקשה למשיכת קאשבק לאחר שהסכום בחשבון יחצה את הרף התחתון לתשלום. מידע אודות דרכי משיכת קאשבק וכן אודות רף תחתון למשיכה מצוי בחשבון</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.3.2 סכום מינימום חד פעמי למשיכת כספים עומד על 150 יורו לכל הפחות.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.3.3 בקשה לתשלום הכספים מטופלת תוך 24 שעות. זמן מירבי 72 שעות</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.3.4 ניתן לדחות או לעכב את הבקשה לתשלום כספים במידה וקיים חשד לביצוע פעולות כזב ע"י המשתמש, או חשד לגישה בלתי מורשית של צד שלישי לחשבון ולחשבון הפנימי</td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.3.5 בתשלום קאשבק בסיכום צבירה שנתי בסך שאינו עולה על 1800 יורו לא ינוקה מס לטובת מדינת המשתמש. על המשתמש לנקוט באופן עצמאי את צעדי הסדרת חבות המס ותשלומה.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.3.6 בתשלום קאשבק נושא המשתמש בעלות העמלה בגין טיפול, אשר נגבית או מנוכה מחשבון הבנק של המקבל (המשתמש) </td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.3.7 ההנהלה רשאית לשנות באופן חד צדדי את התנאים והמועדים של תשלומי קאשבק, וזאת בכל עת.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.4 תוכנית קידום</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.4.1 לאחר ההרשמה באתר מקבל המשתמש קישור קידום אישי לגיוס משתמשים חדשים לצורך קבלת תגמולים</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>1.4.2 את חומרי הפרסום, לרבות קישור קידום ובאנרים, רשאי המשתמש להציב באתר שלו או בעמודים שלו ברשתות החברתיות, לשלוח לחבריו. הגולשים המגיעים דרך קישור הקידום של המשתמש, יחושבו כמקודמים שלו.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.4.3 תגמול בגין גיוס משתמשים חדשים מתבצע בהתאם לתוכנית נאמנות "שיטת קאשבק של חנות האינטרנט" ובכפוף לעמידה בתנאיה.</td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.4.4 המשתמש רשאי לרשום חשבונות מרובים עפ"י קישור הקידום שלו. פעולות כאמור לא ייחשבו לפעולות כזב ולא יגררו את חסימת כל החשבונות המרובים ללא תשלום כספים הצבורים ביתרותיהם.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>1.4.5 המשתמש אינו רשאי לגייס משתמשים שכבר רשומים ומחזיקים בחשבון רשום באתר  https://www.whieda.org/#/, במסגרת אחרת. במידה ויתגלו פעולות כאמור, רשאית ההנהלה להגביל את גישת המשתמש לחשבון ללא תשלום כספים מחשבון המשתמש.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.4.6 אסור בהחלט לגייס משתמשים מקודמים באמצעות הפצת הודעות ספאם או דרך פרסום עקיף.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.5  אחריות הצדדים</td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.5.1 המשתמש אינו רשאי לגייס משתמשים שכבר רשומים ומחזיקים בחשבון רשום באתר  https://www.whieda.org/#/, במסגרת אחרת. במידה ויתגלו פעולות כאמור, רשאית ההנהלה להגביל את גישת המשתמש לחשבון ללא תשלום כספים מחשבון המשתמש.</td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.5.2 המשתמש נושא באחריות אישית על אבטחת נתוני גישה לחשבונו (שם משתמש, סיסמא, דוא"ל וכד'). חל איסור לאפשר גישת אדם אחר לחשבון או לפרסם את נתוני הגישה לידיעת הכלל במקורות חיצוניים.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.5.3. חובה על המשתמש ליידע את ההנהלה, דרך שירות התמיכה הטכנית, במידה ומתעורר אצלו חשד בנוגע לגישה בלתי מורשית של אדם אחר לחשבון.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.5.4 המנהל אינו נושא באחריות בגין נזק אפשרי הנגרם בעקבות גישה בלתי מורשית של אדם אחר לחשבון המשתמש.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.5.5 המנהל אינו אחראי על עבודה תקינה ורציפה של האתר.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.5.6 המשתמש מודע ומסכים כי התוצאה הסופית של שימוש בתוכנית הנאמנות לא בהכרח תהא בהתאם לציפיות המשתמש.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.5.7 המנהל אינו נושא באחריות, בכל מצב שהוא, בגין כל נזק הנגרם בקשר לשימוש באתר או להיעדר אפשרות של שימוש בו.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.5.8 ככל שיתגלו פעולות כזב מצד המשתמש, רשאית ההנהלה להגביל את גישת המשתמש לחשבון ללא תשלום כספים מחשבונו של המשתמש.</td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.5.9 באם יבצע המשתמש פעולה שגרמה פגיעה (או אובדן) במוניטין העסקי של החברה, רשאי המנהל להגביל את גישת המשתמש לחשבון ללא תשלום כספים מחשבונו של המשתמש. </td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.6 פעילות שירות הקאשבק</td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.6.1. לאור תקלות טכניות אפשריות, טיפולי שגרה או חרום בתוכנות האתר, ההנהלה אינה מתחייבת לספק למשתמש גישה רציפה לנתוני תוכנית הנאמנות.</td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.6.2 לא ניתן לשלול שיבושים בפעולת המערכת כתוצאה ממעשי זדון של צדדים שלישיים או מתקלות טכניות. במקרים כאמור ההנהלה שומרת לעצמה את הזכות להקפיא את פעילות השירות עד להסרה מלאה של תקלות טכניות או של איומים מסוגים שונים.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.6.3 ההנהלה מתחייבת לנקוט את כל הצעדים הנדרשים להבטחת פעילות תקינה ויציבה של האתר.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.6.4 ההנהלה מתחייבת להסיר בהקדם האפשרי כל תקלה טכנית מתרחשת, אשר משפיעה על פעילות תקינה של האתר.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.7  פרטים אישיים</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.7.1 ההרשמה באתר מהווה את הסכמת המשתמש לשימוש האתר בפרטיו האישיים ולעיבודם ע"י האתר.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.7.2 המנהל מתחייב כלפי המשתמש לשימוש בפרטיו האישיים אך ורק בהתאם להוראות החוק להגנה על מידע אישי.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.7.3 המנהל אינו מוסר את פרטיו האישיים של המשתמש לחנויות השותפות או לצד שלישי כלשהו.</td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.7.4 במידה ומוסר המשתמש את פרטיו האישיים בדרך של פניה לתמיכה הטכנית, הפרטים האמורים לא יישמרו והשימוש בהם ייעשה אך ורק לטיפול בפניית המשתמש.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.8 דיוור דוא"ל</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.8.1 ההרשמה באתר מהווה את הסכמת המשתמש לקבלת מכתבים מהחברה לכתובת הדוא"ל אשר צוינה במהלך ההרשמה.</td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.8.2 ככל שהמשתמש מעוניין להפסיק את קבלת המכתבים, באפשרותו לפנות להנהלה באמצעות טופס יצירת קשר בבקשה להסיר את חשבונו מרשימת הדיוור או לשנות את אפשרות קבלת המכתבים בהגדרות חשבון המשתמש.</td>
        </tr>
        <tr height="37" style='height:27.75pt;'>
          <td class="xl70" height="37" style='height:27.75pt;'>2. כללי ביצוע ההזמנות</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>2.1 ביצוע הזמנה</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>2.1.1 בחרו מוצר אותו ברצונכם לרכוש. לחצו "להוסיף לסל". המוצר יתווסף באופן אוטומטי לסל הקניות.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>2.1.2 לאחר שווידאתם שהרשימה בסל הקניות נכונה, לחצו על כפתור "לבצע הזמנה". הזינו את פרטי הרוכש: שם, מס' טלפון וכתובת דוא"ל. בחרו את אופן המסירה.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>2.1.3 נציגנו ייצור עימכם קשר לצורך אישור ההזמנה ותיאום מועד מסירה.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>2.2 תשלום עבור ההזמנה</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>2.2.1 אופן התשלום:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'> - תשלום במזומן או בכרטיסי  VISA, MASTERCARD או PAYSERA באיסוף עצמי.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'> - תשלום במזומן או בכרטיסי  VISA, MASTERCARD או PAYSERA (במסירה ברחבי האיחוד האירופי)</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'> - תשלום מקוון באתר בכרטיסי  VISA, MASTERCARD או PAYSERA</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>2.2.2. כללי תשלום בכרטיס אשראי</td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>2.2.2.1 לצורך תשלום עבור מוצר בעזרת כרטיס בנקאי במהלך ביצוע הזמנה בחנות האינטרנט אנא בחרו באופן התשלום: כרטיס בנקאי. במצב זה הטיפול בתשלום מתבצע בעמוד ההזדהות של הבנק, שם תתבקשו להזין את פרטי הכרטיס הבנקאי שלכם. </td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1. סוג הכרטיס</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>2. מספר הכרטיס</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3. תוקף הכרטיס (מצוין על גבי חזית הכרטיס)</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>4. שם בעל הכרטיס (באותיות לטיניות, כפי שמופיע על גבי הכרטיס)</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>5. קוד CVC2/CVV2</td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl67" height="33" style='height:24.75pt;'>במידה וכרטיסכם מוגן ע"י שירות 3D-Secure, תועברו באופן אוטומטי לעמוד הבנק מנפיק הכרטיס לצורך ביצוע תהליך אימות זהות. פרטים על כללים ושיטות של הזיהוי הנוסף ניתן לקבל בבנק אשר הנפיק את הכרטיס הבנקאי שלכם.</td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl67" height="33" style='height:24.75pt;'>הגנת תשלומי האינטרנט דרך שירות התשלומים של הבנק מובטחת ע"י רישיון האבטחה הבינלאומי PCI DSS. מסירת המידע מתבצעת תוך שימוש בטכנולוגיית הצפנה TLS. המידע האמור אינו נגיש לצד ג' כלשהו.</td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>2.3 המוצר נרכש ע"י המשתמש למטרות עסקיות, שאינן קשורות לצרכיו אישיים, משפחתיים, ביתיים או אחרים. לא תתאפשר החזרת מוצר באיכות הולמת. החזרת מוצר באיכות שאינה הולמת מתבצעת לפי הנוהל הנקבע בחקיקה התקפה של המדינה בה נרכש המוצר.</td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>2.4 חל איסור על מכירה חוזרת של מוצרים באתרי מסחר אחרים במחיר שונה ממחיר האתר הרשמי. בהתרחש תקדימים כאמור האזורים האישיים של המשתמשים יושבתו מפעילות. לפי הצורך שמורה להנהלה האפשרות לפנות לפתרון משפטי של מצבים כאמור.</td>
        </tr>
        <tr height="37" style='height:27.75pt;'>
          <td class="xl70" height="37" style='height:27.75pt;'>3. מדיניות הסודיות</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.1  הגדרות כלליות</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>פרטים אישיים - כל מידע הנוגע למשתמש. משתמש - ישות פיזית המשתמשת באתר.</td>
        </tr>
        <tr height="32" style='height:24.00pt;'>
          <td class="xl67" height="32" style='height:24.00pt;'>האתר - מכלול מערכות מידע אוטומטיות ומידע, השייכים להנהלה, ללא קשר לאופן הצגתו, נגישים ברשת האינטרנט בכתובות רשת הבאות (לרבות כתובות משנה): https://www.whieda.org/#/</td>
        </tr>
        <tr height="49" style='height:36.75pt;'>
          <td class="xl67" height="49" style='height:36.75pt;'>עיבוד פרטים אישיים - כל פעולה או סדרת פעולות עם פרטים אישיים, המתבצעות תוך שימוש בכלי אוטומציה או ללא שימוש בכלים כאמור, כולל איסוף, רישום, סידור שיטתי, צבירה, שמירה, שכתוב (עדכון, שינוי), שליפה, שימוש, מסירה (הפצה, הצגה, גישה), ניתוק מזהות, חסימה, הסרה, השמדת פרטים אישיים.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>עיבוד פרטים אישיים ממוכן - עיבוד פרטים אישיים בעזרת עצמאים ממוחשבים.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>רשת חברתית - אתר ברשת מידע ותקשורת אינטרנט, השייך לצד ג' ומיועד לתקשורת מרחוק בין בני אדם.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>שירות - מוצרים, שירותים, תוצרי זכויות יוצרים, המוצעים ע"י ההנהלה למעוניינים לצורך רכישה, שימוש באמצעות האתר בהתאם לתנאי חוזה משפטי אזרחי.</td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl67" height="33" style='height:24.75pt;'>אזור אישי - מדור אישי של האתר וכן תכונות אתר נוספות, אליהם מקבל המשתמש גישה לאחר ביצוע תהליך הרשמה ו/או הזדהות באתר. אזור אישי מיועד לשמירת פרטיו האישיים של משתמש, עיון ושימוש באפשרויות שימוש נגישות של האתר והתנאים הרלוונטיים של שימוש באתר, ניהול עסקאות המתבצעות באמצעות האתר.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>הסכם שימוש - חוזה משפטי אזרחי לשימוש באתר.</td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl67" height="33" style='height:24.75pt;'>הזמנה - אוסף נתונים המופק אוטומטית על פעולות המשתמש, המכוונות לעריכת הסכם משפטי אזרחי מול ההנהלה לשימוש בשירות, ומכיל מידע על השירות הנבחר ע"י המשתמש, עלות השירות, תאריך ושעה של הפקת הזמנה כאמור.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;'>חשבונית קופה - מסמך מעקב ראשוני המופק במסגרת ביצוע התחשבנות בין המשתמש לבין ההנהלה בקשר לחתימה, ביצוע וביטול של חוזים לשימוש בשירות. מונח התחשבנות מיושם בהתאם למשמעותו המוגדרת בחוק "על שימוש במכשירי קופה וביקורת אגב ביצוע התחשבנות כספית במזומנים ו(או) התחשבנות תוך שימוש באמצעי תשלום דיגיטליים".</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>אופן תשלום - מידע על בנק, מערכת תשלומים, אמצעי תשלום, המופעלים ע"י המשתמש לתשלום בגין השירות.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.2 הסכמה לעיבוד פרטים אישיים</td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>3.2.1 המשתמש מקבל החלטה על מסירת פרטיו האישיים להנהלה, מקבל את תנאי הסכם השימוש ונותן הסכמה לעיבוד פרטיו האישיים, וזאת ללא כפיה, מרצונו החופשי ועפ"י מניעיו.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.2.1 הסכמת המשתמש לעיבוד פרטיו האישיים נחשבת כאילו ניתנה להנהלה במידה והיא נשלחה:</td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>א) במהלך הרשמה לאתר ע"י מילוי טופס, המוצג באתר לאחר לחיצה על כפתור "הרשמה", רואים את המשתמש כנותן הסכמה לעיבוד פרטיו האישיים ברגע הלחיצה על כפתור "להמשיך"</td>
        </tr>
        <tr height="50" style='height:37.50pt;'>
          <td class="xl69" height="50" style='height:37.50pt;'>ב) עם הזנה או שינוי הפרטים האישיים בעמוד "הגדרות פרופיל" במדורים "לשנות פרטי יצירת קשר", "רשימת אנשי קשר", "סיסמא", "סיסמא להעברות", "דיוור דוא"ל" - עבור פרטים אישיים אותם מוסר המשתמש אגב עריכת מידע באזור האישי, רואים את המשתמש כנותן הסכמה לעיבוד פרטיו האישיים שהוזנו או שונו ברגע הלחיצה על כפתור "לשמור" או "להחליף", או ברגע לחיצה על אחד מכפתורי הממשק המסמנים באופן מובהק עדכון, שינוי, הסרה, תיקון של פרטים אישיים.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.3 פרטים אישיים המעובדים ע"י ההנהלה</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.3.1 ההנהלה מעבדת את הפרטים האישיים הבאים של המשתמשים:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>א) בעת הרשמת המשתמש באתר:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·שם</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·שם משפחה</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·כתובת דוא"ל</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·מספר טלפון</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· Cookie קובצי קוקיס</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>ב) בעת שליחת הודעות מידע, שאלות, תגובות להנהלה:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·כתובת דוא"ל</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·שם</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·שם משפחה</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·מספר טלפון</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· Cookie קבצי קוקיס</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>ג) בעת הזנה או שינוי פרטים אישיים בעמוד "הגדרות פרופיל":</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·  שם</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·  שם משפחה</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·  כתובת דוא"ל</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·  מספר טלפון</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>·  כתובת</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· Cookie קבצי קוקיס</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>ד) בעת תשלום בגין שירות ע"י משתמש רשום:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·כתובת המקבל；</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· כתובת דוא"ל;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·שם</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·שם משפחה</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· הזמנה；</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·תאריך, שעה וסכום של הוראת תשלום שבוצעה ע"י המשתמש；</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·גובה ותאריך פירעון של הוראת תשלום נדחית של המשתמש；</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· <font class="font3">חשבונית קופה ופרטי חשבונית קופה；</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· <font class="font3">אופן התשלום</font><font class="font1">;</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·הנחות המוענקות למשתמש והנימוקים להענקתן;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· Cookie <font class="font3">קבצי קוקיס</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>ה) בעת הרשמה לאירועים, שידור אירועים הנערכים ע"י ההנהלה</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·שם</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·שם משפחה</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· <font class="font3">כתובת דוא"ל</font><font class="font1">;</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· Cookie <font class="font3">קבצי קוקס</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>ו) בעת עריכת סקרי סטטיסטיקה או מחקר ע"י ההנהלה:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·שם</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·גיל</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·מקצוע ו/או תחביב；</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· <font class="font3">כתובת דוא"ל</font><font class="font1">;</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· Cookie <font class="font3">קבצי קוקיס</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>ז) בעת קבלת שרותי יעוץ באמצעות תקשורת טלפונית: מס' הטלפון ממנו מתקשר המשתמש;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·שם</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·שם משפחה</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·פרטי הרשמת משתמש באתר；</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·פרטים אישיים נוספים אותם מוסר המשתמש להנהלה מרצונו החופשי ומתוך מניעיו</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>ח) בעת איסוף מידע אודות המשתמש לצורך התאמה אישית של הודעות מידע ופרסום למשתמש</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· Cookie <font class="font3">כלי זיהוי קבצי קוקיס；</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· <font class="font3">תקופת הזדהות של משתמש בדפדפן；</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·שימוש בחוסם פרסומות；</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·כתובת IP מצומצמת；</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·היסטורית צפיות</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·נתוני גלישה；</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·תפקיד/אופי העבודה</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·נתוני המוצרים הנצפים, מחיריהם, תאריך ושעת צפיה；</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·כתובות דוא"ל תחת שמות בדויים；</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· <font class="font3">מיקום</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·נתונים טכניים של דפדפן, מכשיר, הגדרות；</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·תגובות לפרסומת (לחיצות, דחיות, מעברים וכד')</td>
        </tr>
        <tr height="50" style='height:37.50pt;'>
          <td class="xl67" height="50" style='height:37.50pt;'>המידע הנאסף כאמור משויך לכלי זיהוי יחידים במינם, ובפרט לכלי זיהוי של קבצי קוקיס ולטכנולוגיות דומות נוספות ואינו מאפשר לזהות את המשתמש ישירות (ניתוק נתונים מזהות). המשתמש יכול לחסום אפשרות של איסוף המידע האמור בדפדפן שלו באופן המתואר ע"י יצרן דפדפן המשתמש. ההנהלה רשאית להעביר את המידע המתקבל בהתאם להוראות סעיף זה לצד ג'.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.4 מטרות עיבוד הפרטים האישיים</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.4.2 ההנהלה מעבדת פרטים אישיים של משתמשים אך ורק למטרות הבאות:</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>א) בעת גלישת המשתמש באתר, הן בהרשמת משתמש לאתר והן בהיעדר הרשמה כאמור, ההנהלה מעבדת את פרטיו האישיים של משתמש לצרכי ביצוע החוזה לשימוש באתר (הסכם שימוש). לצורך כך מעבדת ההנהלה את הפרטים האישיים, סע' 3.3 להסכם זה.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>ב) למטרות ביצוע הסכם שימוש, כאשר מפעיל המשתמש את תכונות האתר השונות, הקשורות להזנה, שינוי, עדכון, הסרה של פרטים אישיים ע"י המשתמש מרצונו החופשי. לצורך כך מעבדת ההנהלה את הפרטים האישיים, סע' 3.3.1 להסכם זה.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>ג) למטרות כריתה וביצוע חוזים לשימוש המשתמש בשירות, ללא הרשמה מוקדמת של המשתמש באתר מעבדת ההנהלה את הפרטים האישיים, סע' 3.3.1 להסכם זה.</td>
        </tr>
        <tr height="50" style='height:37.50pt;'>
          <td class="xl69" height="50" style='height:37.50pt;'>ד) במטרה לאפשר למשתמש לקבל מההנהלה מידע אודות תכונות ואפשרויות של האתר, שירותים שונים, שליחת הודעות, שאלות, תגובות מהמשתמש להנהלה, הענקת יעוץ ותמיכה אחרת למשתמש, לצורך קיום הסכם השימוש, וכן חוזים לשימוש באתר, מעבדת ההנהלה את הפרטים האישיים, סע' 3.3.1 להסכם זה. </td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>ה) למטרת מענה לבקשת משתמש לקבל דיוורי מידע מעבדת ההנהלה את הפרטים האישיים, סע' 3.3.1 להסכם זה.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>ו) למטרות שיפור איכות השירות, עריכת מחקרים סטטיסטיים ואחרים על יסוד מידע בלתי מזוהה אודות משתמשים מעבדת ההנהלה את הפרטים האישיים, סע' 3.3.1 להסכם זה.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>ח) למטרות כריתה וביצוע חוזים לשימוש בשירות מעבדת ההנהלה את הפרטים האישיים, סע' 3.3.1 להסכם זה.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>ט) למטרות קיום ההסכם בין המשתמש לבין ההנהלה לעריכת מכרז מעבדת ההנהלה את הפרטים האישיים, סע' 3.3.1 להסכם זה.</td>
        </tr>
        <tr height="37" style='height:27.75pt;'>
          <td class="xl70" height="37" style='height:27.75pt;'>3.5 תנאי עיבוד פרטים אישיים</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.5.1 ההנהלה, בהסתמך על חזקת תום הלב של המשתמש, מניחה כי בעת מסירת פרטיו האישיים באתר המשתמש:</td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>3.5.1.1 בעל כשרות משפטית. בהיעדר כשרות המשתמש כאמור ההסכמה לעיבוד הפרטים האישיים תינתן ע"י נציגו החוקי לאחר שזה קרא והסכים לתנאי עיבוד פרטים אישיים המפורטים במסמך מדיניות זה.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.5.1.2 מציג מידע מהימן אודותיו בהיקפים הדרושים לצורך שימוש באתר, ומעדכן באופן שוטף את הפרטים האישיים אותם הציג.</td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>3.5.1.3 במידה והעלה את תמונתו דרך האזור האישי - נותן ללא תמורה את הסכמתו לשימוש בתמונה כאמור למטרות שאינן קשורות לאימות זהותו של המשתמש. המשתמש מתחייב שלא להציג תמונה של אדם שלישי כלשהו כתמונתו.</td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>3.5.1.4 יודע ומבין שהמידע האישי המועלה ע"י המשתמש לאתר, עשוי להיות נגיש למשתמשי האתר האחרים, ניתן להעתקה והפצה ע"י משתמשים כאמור; </td>
        </tr>
        <tr height="50" style='height:37.50pt;'>
          <td class="xl69" height="50" style='height:37.50pt;'>3.5.1.5 יודע ומבין שתכונות ואפשרויות של האתר מאפשרות למשתמש להגדיר באופן עצמאי את הגישה החופשית (מצב נראות) לחלק מפרטיו האישיים עבור משתמשים אחרים. במידה והגדיר המשתמש גישה חופשית לפרטיו האישיים, מתפרש הדבר כחשיפת הפרטים האישיים ע"י המשתמש מרצונו החופשי ולצרכיו. המשתמש מצהיר שהוא מודע להשלכות חשיפת פרטיו האישיים למשתמשים אחרים ולא יהיו לו טענות כלפי ההנהלה.</td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>3.5.1.6  יודע ומבין שעיבוד חלק מהפרטים האישיים מבוסס על דרישות החקיקה הרלוונטית, כמו כן עיבוד הפרטים האישיים נחוץ לצורך קיום ההסכם מול המשתמש כאמור.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.5.3 עדכון, שינוי הפרטים האישיים ניתן לביצוע ע"י המשתמש באופן עצמאי באמצעות האזור האישי.</td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>3.5.4 המשתמש מודע שחלה עליו החובה לבדוק בעצמו, בכוחותיו ולצרכיו, את עדכניות פרטיו האישיים ולבצע במידת הצורך עדכונים, שינויים בפרטיו האישיים באמצעות האזור האישי.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.5.5 הפרת הפרטים האישיים יכולה להתבצע אך ורק במקרים הבאים:</td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>3.5.5.1 על יסוד הבעת רצונו של המשתמש, הניתנת ע"י הגדרת גישה חופשית (מצב נראות) ע"י המשתמש לפרטיו האישיים במטרה להציג את פרופיל המשתמש, חלק מפרטיו האישיים בפני משתמשי האתר האחרים.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.5.6 ההנהלה רשאית למסור פרטים אישיים לצד ג' למטרות הבאות:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.5.6.1 צירוף צד ג' לתהליך קיום ההסכמים שנכרתו בין משתמש לבין ההנהלה, לצורך שיפור האיכות של קיום ההסכמים כאמור;</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>3.5.7 ההנהלה רשאית למסור פרטים אישיים לצד ג' בתנאי שצד ג' כאמור דואג לחסיון הפרטים האישיים במהלך עיבודם, נוקט צעדים לאבטחת הפרטים האישיים. צד ג' אינו רשאי למסור ולהפיץ פרטים אישיים של המשתמשים. </td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.5.8 הפסקת עיבוד פרטים אישיים של משתמש, חסימה והשמדה של פרטים אישיים תתבצע במקרים הבאים:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>א) הסרת פרטים אישיים ע"י המשתמש באזור האישי;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>ב) ההנהלה קיבלה מהמשתמש הודעת ביטול הסכמה לעיבוד פרטיו האישיים;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>ג) ההנהלה קיבלה מהמשתמש דרישה להשמדה או חסימה של פרטיו האישיים;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>ד) פקיעת תוקף הסכמת המשתמש לעיבוד פרטיו האישיים.</td>
        </tr>
        <tr height="100" style='height:75.00pt;'>
          <td class="xl69" height="100" style='height:75.00pt;'>3.5.9 ההנהלה נוקטת אמצעים דרושים ומספקים, משפטיים, ארגוניים וטכניים, לאבטחת פרטים אישיים בפני חשיפה בלתי חוקית או מקרית, השמדה, שינוי, חסימה, העתקה, הפצה, וכן בפני פעולות בלתי חוקיות אחרות של צד ג' כלשהו כלפי פרטים אישיים. בפרט, נוקטת ההנהלה אמצעים ארגוניים וטכניים לאבטחת פרטים אישיים במהלך עיבודם, בקרת מקרי חשיפה בלתי מורשית של פרטים אישיים ונקיטת צעדים למניעת תקריות דומות בעתיד, מעקב אחר הצעדים הננקטים לאבטחת פרטים אישיים ורמת מוגנות של פרטים אישיים. להזדהות בגישה לאזור האישי של המשתמש נעשה שימוש בשם משתמש (כתובת דוא"ל) וסיסמת משתמש. האחריות על שמירת מידע זה חלה על המשתמש. משתמש אינו רשאי למסור את שם המשתמש והסיסמא לצד ג' כלשהו וכן חובה עליו לנקוט צעדים להבטחת חסיונם.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.6 משתמש רשאי:</td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>3.6.1 עפ"י שיקול דעתו, מרצונו החופשי ולפי צרכיו לספק להנהלה את פרטיו האישיים לצורך עיבודם, בתנאים המפורטים בהסכם זה;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.6.2 באופן עצמאי לספק, לשנות ולהסיר פרטים אישיים באזור האישי, וזאת בתנאי ששינויים ותיקונים כאמור מכילים מידע עדכני ומהימן;</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>3.6.3 לפנות להנהלה בדרישות, לרבות להשמדת פרטים אישיים, ביטול הסכמה לעיבודם, חסימת פרטים אישיים. דרישה כאמור תוגש לפי ההסדר הקבוע בסע' 3.6.2 של הסכם זה.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.6.4 להסיר את האזור האישי באופן עצמאי או לדרוש מההנהלה לעשות כן, לפי ההסדר הקבוע בסע' 3.6.2 של הסכם זה.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.6.5 לקבוע באופן עצמאי הגדרת גישה חופשית (מצב נראות) של חלק מפרטיו האישיים, לבטל את ההגדרה האמורה.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.6.6 המשתמש רשאי לשלוח להנהלה את דרישותיו ושאלותיו בדרכים הבאות:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.6.7 בכתב לכתובת ההנהלה המופיעה באתר;</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>3.6.8 יש לשלוח מסמך מכתובת דוא"ל של המשתמש שצוינה על ידיו עם ההרשמה לאתר או בחוזה לשימוש בשירות, לכתובת דוא"ל של ההנהלה eu-info@foherb.com.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.6.9 על דרישות ושאלות הנשלחות ע"י המשתמש להכיל את המידע הבא:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>א) שם משפחה, שם פרטי ושם האב של המשתמש</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>ב) פרטי הרשמת המשתמש באתר (במידה והמשתמש רשום נכון למועד משלוח דרישה או שאלה);</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>מהות הדרישה או השאלה של המשתמש;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>ד) חתימת המשתמש</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl69" height="51" style='height:38.25pt;'>3.6.10 ההנהלה בוחנת את הדרישות והשאלות המתקבלות מהמשתמש בהיבט קיום פרטי החובה, ביסוס הדרישה או הפניה. ככל שדרישת המשתמש מבוססת, ההנהלה נענית לה תוך 30 ימים מתאריך קבלתה. בכל מקרה תשיב ההנהלה למשתמש תוך פרק זמן שלא יעלה על 30 ימים מתאריך קבלת דרישה או פניה. התשובה נשלחת למשתמש באותו אופן בו נשלחה דרישה או פניה של המשתמש.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.7 שינוי מדיניות</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.7.1 ההנהלה שומרת לעצמה זכות לערוך שינויים בהסכם השימוש. חובה על המשתמש לעיין בתוכן הסכם השימוש בכל שימוש באתר.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>3.7.2 נוסח חדש של הסכם שימוש נכנס לתוקף מרגע פרסומו במדור הרלוונטי של האתר. המשך שימוש באתר או בשירותיו לאחר פרסום נוסח חדש של הסכם שימוש מהווה את קבלת הסכם שימוש ותנאיו ע"י המשתמש. משתמש שאינו מסכים עם תנאי הסכם שימוש חייב להפסיק את השימוש באתר באופן מיידי.</td>
        </tr>
      </table>
    </div>
    <div class="english" v-show="this.language=='en_GB'">
      <table width="645" border="0" cellpadding="0" cellspacing="0" style='width:483.75pt;border-collapse:collapse;table-layout:fixed;'>
        <col width="645" class="xl65" style='mso-width-source:userset;mso-width-alt:20640;'/>
        <col width="805" span="16383" style='mso-width-source:userset;mso-width-alt:25760;'/>
        <tr height="37" style='height:27.75pt;'>
          <td class="xl66" height="37" width="645" style='height:27.75pt;width:483.75pt;'>TERMS OF USE</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;'>This User Agreement regulates the relationship between the owner (hereinafter - Administration and/or KORDICEPSAS) and the user of the website, on the other hand.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>When using the website, the User agrees to the terms of this agreement as below.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>The administration has the right to change this contract unilaterally at any time and without notice.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>It is forbidden to copy, reprint and other purpose for using material from the website without the prior consent of the administration.</td>
        </tr>
        <tr height="37" style='height:27.75pt;'>
          <td class="xl70" height="37" style='height:27.75pt;'>CONTENTS OF THE AGREEMENT:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>1. Loyalty Program Terms and Conditions.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>2. Order submission procedure.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>3. Personal data processing policy</td>
        </tr>
        <tr height="37" style='height:27.75pt;'>
          <td class="xl66" height="37" style='height:27.75pt;'>1. TERMS OF THE LOYALTY PROGRAM</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>Terms and Notation</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>A list of terms and titles used in this proposal is available on the website.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>Loyalty program - a free electronic service on the Internet located at https://www.whieda.org/#/, which gives Users the opportunity to return part of the funds spent on purchases in the online store.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>User - a visitor of the online store, a person registered on the website.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>Cashback - part of the funds spent on purchases in the online store is returned.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl68" height="34" style='height:25.50pt;'>Account - User account that provides access to all functions of the online store, including the internal account to which the refund is credited.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;'>Administration - employees of the online store authorized to perform any operations with the User's account in accordance with this Offer.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>Internal account - the User's account of the online store, which records the accumulated refund and its status.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl68" height="34" style='height:25.50pt;'>Promotional material - banners, referral links and other means for attracting new Users, with the possibility of receiving rewards for active actions (purchases) of directed and registered referrals.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>Fraudulent acts are any type of fraud intended to illegally obtain a refund.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl68" height="34" style='height:25.50pt;'>SPAM - mass sending of promotional information or other types of messages without taking into account the preferences of the recipients.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>1.1. General provisions</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl72" height="18" style='height:13.50pt;'>1.1.1. By registering on the website, the User confirms that:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>a) The user should be at least 18 years old;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>b) The User is capable, legally capable under the laws of his/her country;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>c) The user undertakes not to allow persons under the age of 18 to use the Loyalty program;</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl73" height="34" style='height:25.50pt;'>d) The user undertakes to prevent disabled, incompetent persons from using the Loyalty Program and is personally responsible for preventing such persons from using the Loyalty Program;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl74" height="18" style='height:13.50pt;'>e) The Account will be used for purchases only on behalf of the Account Holder;</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl72" height="51" style='height:38.25pt;'>f) The User confirms that he has been notified and agrees that the Administration will change the content of this Offer if necessary; - The user confirms that he has familiarized himself with this offer and unconditionally agrees to its terms;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl72" height="18" style='height:13.50pt;'>g) The user confirms that he fully understands all his rights and obligations.</td>
        </tr>
        <tr height="68" style='height:51.00pt;'>
          <td class="xl67" height="68" style='height:51.00pt;'>1.1.2. According to the Loyalty Program, the Administrator pays the User a refund, which is formed from the Loyalty Program &quot;Online Store Refund System&quot;. Refunds are made if the user follows all the rules and recommendations and provided that the product has not been returned to the Seller (in whole or in part) or the service has been refused.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;'>1.1.3. Cash will be received immediately after confirmation of the order by participating in the loyalty program. This usually happens within 1 minute, but in some cases, the terms of crediting funds can last up to 24 hours.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;'>1.1.4. In the event of a system failure, the refund will not be credited if the payment transaction is refused. In such cases, contact the company's contact person.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>1.2. CASHBACK rules</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl72" height="34" style='height:25.50pt;'>1.2.1. To receive a refund, the User must be registered on the website, participate in the loyalty program and fulfill its conditions.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>1.3. CASHBACK payouts</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl72" height="51" style='height:38.25pt;'>1.3.1. The user can leave a cashback request when the amount in the account reaches the minimum withdrawal limit. You can find information about cashback methods, as well as the minimum withdrawal amount, in the User account.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl73" height="18" style='height:13.50pt;'>1.3.2. The minmum amount of one-time withdrawal should be at least 150Euro.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>1.3.3. The request for disbursement of funds is processed within 24 hours. The maximum period is 72 hours.</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl67" height="51" style='height:38.25pt;'>1.3.4. The request to withdraw funds may be rejected or delayed if there are suspicions that the User has committed fraudulent actions or there is a suspicion of illegal access to the Account or the account of third parties.</td>
        </tr>
        <tr height="68" style='height:51.00pt;'>
          <td class="xl67" height="68" style='height:51.00pt;'>1.3.5. When paying a cashback, the User's country of residence is not subject to taxes within accumulative amount 1800Euro/per yearly. When the cashback accumulative amount is over 1800euro/yearly, the user must register individual tax ID in residence country,and Administrator will deduct income tax to government obligated.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>1.3.6. After paying a cash refund, the receptor will bear the bank charge/commission<span style='mso-spacerun:yes;'>&nbsp; </span>when the refund arrived.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>1.3.7. The administrator has the right to unilaterally change the refund conditions at any time.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>1.4. Referral program</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl72" height="34" style='height:25.50pt;'>1.4.1. After registering on the<span style='mso-spacerun:yes;'>&nbsp; </span>website, the User receives a personalized referral link to attract new Users to receive rewards.</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl68" height="51" style='height:38.25pt;'>1.4.2. The User has the right to place advertising materials, including referral links and banners, on his website or page in social networks, and send them to his friends. Visitors who follow a User's referral link will be counted as their referrals.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl72" height="34" style='height:25.50pt;'>1.4.3. Remuneration for attracted referrals is paid in accordance with the Loyalty program &quot;Online Store Cashback System&quot; and the fulfillment of its conditions.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;'>1.4.4. A user is allowed to register multiple accounts using their own referral link. Such actions will not be considered unfair.</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl72" height="51" style='height:38.25pt;'>1.4.5. The user is forbidden to attract previously registered users who have a different account structure with registration on the website https://www.whieda.org/#/. Upon detection of such actions, the Administration has the right to restrict the user's access to the Account without paying funds from the User's account.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl72" height="18" style='height:13.50pt;'>1.4.6. Attracting referrals by sending SPAM messages or through contextual advertising is strictly prohibited.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>1.5. Responsibility of the parties</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl72" height="51" style='height:38.25pt;'>1.5.1. The user is forbidden to attract previously registered users who have a different account structure with registration on the website https://www.whieda.org/#/. Upon detection of such actions, the Administration has the right to restrict the user's access to the Account without paying funds from the User's account.</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl73" height="51" style='height:38.25pt;'>1.5.2. The User is personally responsible for the security of access to his Account data (login, password, e-mail, etc.). It is prohibited to provide access of the Account to third parties or to make it publicly available on third-party resources.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl72" height="34" style='height:25.50pt;'>1.5.3. The User must inform the Administration through the technical support service if he has any suspicions about unauthorized access to the Account by third parties.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl72" height="34" style='height:25.50pt;'>1.5.4. The administrator is not responsible for possible damage caused by third parties' unauthorized access to the User's account.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl72" height="18" style='height:13.50pt;'>1.5.5. The administrator is not responsible for the smooth operation of the website.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl72" height="34" style='height:25.50pt;'>1.5.6. The User acknowledges and agrees that the final result of using the Loyalty Program may not meet the User's expectations.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl72" height="34" style='height:25.50pt;'>1.5.7. The administrator is not responsible under any circumstances for damage caused by the use of the website or the inability to use it.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl72" height="34" style='height:25.50pt;'>1.5.8. If fraudulent actions of the user are detected, the Administrator has the right to restrict the user's access to the Account without paying funds from the User's account.</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl72" height="51" style='height:38.25pt;'>1.5.9. If the User performs actions that lead to deterioration (or loss) of the business reputation of the company, the Administrator has the right to restrict the user's access to the Account without paying funds from the User's account.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>1.6. Functioning of the refund service</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl68" height="34" style='height:25.50pt;'>1.6.1. Taking into account possible technical malfunctions, planned or unplanned technical service updates, the Administration does not guarantee the User permanent access to Loyalty Program data.</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl67" height="51" style='height:38.25pt;'>1.6.2. System failures due to third-party malicious actions or technical problems cannot be ruled out. In such cases, the Administration reserves the right to suspend the provision of the service until the complete elimination of technical problems or various types of threats.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>1.6.3. The administration undertakes to take all necessary steps to ensure the stable operation of the website.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl72" height="34" style='height:25.50pt;'>1.6.4. The administration undertakes to eliminate all technical problems that affect the correct functioning of the website as soon as possible.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>1.7. Personal information</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl72" height="34" style='height:25.50pt;'>1.7.1. By registering on the<span style='mso-spacerun:yes;'>&nbsp; </span>website, the User consents to the use and processing of his personal data by the<span style='mso-spacerun:yes;'>&nbsp; </span>website.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl72" height="34" style='height:25.50pt;'>1.7.2. The Administrator guarantees the User that his personal data will be used only in accordance with the Personal Data Protection Law.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>1.7.3. The administrator does not transfer the user's personal data to partner stores or third parties.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;'>1.7.4. In the event that the User transmits his personal data when contacting the technical support service, such data will not be stored and will only be used to solve the problem raised by the User.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>1.8. E-MAIL referrals</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl72" height="34" style='height:25.50pt;'>1.8.1. By registering on the website, the User agrees to receive letters from the company at the e-mail specified during registration.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl72" height="34" style='height:25.50pt;'>1.8.2. If the user wants to refuse receiving letters, he can contact the Administration with a request to delete the Account or change the function of receiving letters in the User Account settings.</td>
        </tr>
        <tr height="40" style='height:30.00pt;'>
          <td class="xl75" height="40" style='height:30.00pt;'>1. RULES FOR FULFILLING ORDERS</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>2.1. Order submission:</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;'>2.1.1. Select the product you want to purchase. Click &quot;Add to Cart&quot;, the item will be automatically added to the cart.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;'>2.1.2. After making sure that the shopping list in the cart is correct, click the &quot;Buy&quot; button. Enter information about the Buyer: First name, last name, contact phone number and e-mail. Choose a delivery method.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>2.1.3. Our manager will contact you to confirm the order and its delivery date.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>2.2. Order payment</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>2.2.1. Order payment methods:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·<span style='mso-spacerun:yes;'>&nbsp; </span>Payment by cash or VISA, MASTERCARD or Paysera<span style='mso-spacerun:yes;'>&nbsp; </span>on collection.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>· Payment in cash or by VISA, MASTERCARD or Paysera (upon delivery in the European Union).</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·<span style='mso-spacerun:yes;'>&nbsp; </span>Payment by bank transfer online on the website with VISA, MASTERCARD or Paysera.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>2.2.2. Bank card payment rules</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl67" height="51" style='height:38.25pt;'>2.2.2.1. To pay for goods by bank card, select the payment method: bank card when placing an order in the online store. When paying for an order by bank card, payment processing takes place on the bank authorization page, where you need to enter your bank card details:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>1. card type</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>2. card number</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>3. Card validity period (indicated on the front side of the card)</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>4. Name and surname of the card holder (in Latin letters, exactly as indicated on the card)</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>5. CVC2/CVV2 code</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl68" height="51" style='height:38.25pt;'>If your card is connected to the 3D-Secure service, you will be automatically redirected to the page of the bank that issued the card to complete the authentication procedure. For information on the rules and methods of additional identification, ask the bank that issued the bank card.</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl68" height="51" style='height:38.25pt;'>The security of online payment processing through the bank's payment gateway is guaranteed by the PCI DSS international security certificate. Information is transmitted using TLS encryption technology. This information is not available to third parties.</td>
        </tr>
        <tr height="68" style='height:51.00pt;'>
          <td class="xl68" height="68" style='height:51.00pt;'>2.3. The consumer purchases the product for commercial purposes that are not related to personal, family, home or other needs. Returns are not allowed on goods of good quality. The return of goods of inappropriate quality is carried out in accordance with the procedure established by the legal acts of the country where the goods were purchased.</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl67" height="51" style='height:38.25pt;'>2.4. It is forbidden to resell goods in other marketplaces at a price that differs from the official website price. In the event of such precedents, the personal accounts of &quot;Users&quot; will be disabled. If necessary, the administration reserves the right to resolve these situations in court.</td>
        </tr>
        <tr height="40" style='height:30.00pt;'>
          <td class="xl75" height="40" style='height:30.00pt;'>3. PRIVACY POLICY</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>3.1. Basic concepts</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>Personal data - any information related to the User. User - a person using the Website.</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl68" height="51" style='height:38.25pt;'>Website - a set of automated information systems and information belonging to the Administration, regardless of the form of its presentation, is available on the Internet at the following network addresses (including subdomains): https://www.whieda.org/# /.</td>
        </tr>
        <tr height="68" style='height:51.00pt;'>
          <td class="xl67" height="68" style='height:51.00pt;'>Processing of personal data - any action (operation) or set of actions (operations) performed using automation tools or without using such tools with personal data, including collection, recording, systematization, accumulation, storage, interpretation (updating), changing), extraction, use, transmission (distribution, provision, access), depersonalization, blocking, deletion, destruction of personal data.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>Automated processing of personal data - processing of personal data with the help of computer technologies.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;'>Social network - a website owned by third parties in an information and telecommunications network on the Internet, intended for remote human communication.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl72" height="34" style='height:25.50pt;'>Service - products, services, copyright objects that the Administration provides for interested parties to purchase and use through the Website under the terms of civil law contracts.</td>
        </tr>
        <tr height="68" style='height:51.00pt;'>
          <td class="xl67" height="68" style='height:51.00pt;'>Personal account - a personal part of the Website and additional functions of the Website, to which the User gains access after registering and/or authorizing on the Website. The personal account is intended to store the User's personal data, to view and manage the available functions of the Website and the corresponding terms of use of the Website, to manage the operations performed through the Website.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>User agreement - a civil law agreement regarding the use of the Website.</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl67" height="51" style='height:38.25pt;'>Order - an automatically generated set of data about the User's actions aimed at concluding a civil contract with the Administration for the use of the Service, including information about the Service chosen by the User, the price of the Service, date and time.</td>
        </tr>
        <tr height="68" style='height:51.00pt;'>
          <td class="xl67" height="68" style='height:51.00pt;'>Cash register receipt is the primary accounting document generated by the User and the Administration during settlement, related to the conclusion, execution and termination of contracts for the use of the Service. The concept of payments is used in the sense in which it is defined in the federal law &quot;On the use of cash registers for cash payments and/or payments using electronic means of payment&quot;.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl68" height="34" style='height:25.50pt;'>Payment method - information about the bank, payment system, means of payment with which the User pays for the Service.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>3.2 Consent to the processing of personal data</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;'>3.2.1 The User decides to submit his personal data to the Administration, agrees to the terms of the User Agreement and agrees that his personal data will be processed freely, voluntarily and in his interests.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;'>3.2.1 The user's consent to process his personal data is considered submitted to the Administration if it is sent:</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl67" height="51" style='height:38.25pt;'>a) Registering on the Website by filling out the form on the Website by clicking the &quot;Registration&quot; button. The user is considered to have given his consent to the processing of his personal data at the time he clicks the &quot;Continue&quot; button.</td>
        </tr>
        <tr height="102" style='height:76.50pt;'>
          <td class="xl72" height="102" style='height:76.50pt;'>b) When entering or changing personal data in the section &quot;Profile settings&quot; in the subsections &quot;Change contact information&quot;, &quot;Contact list&quot;, &quot;Password&quot;, &quot;Operation password&quot;, &quot;Newsletter e-mail&quot;. by mail&quot; - regarding personal data provided by the User when editing information in the personal account. It is considered that the user has given his consent to the processing of his newly entered or changed personal data by clicking the button &quot;Save&quot; or &quot;Change&quot; or at the moment of clicking the button of the interface, which clearly indicates the explanation, changing, deleting, correcting personal data.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>3.3. Personal data processed by the administration</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>3.3.1 The Administration processes the following personal data of Users:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>a) When registering a user on the website:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Name;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Surname;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Email address;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Telephone number;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Cookies.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>b) When sending information messages, questions, feedback to the Administration:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Email address;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Name;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Surname;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Telephone number;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Cookies.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>c) When entering or changing personal data in the &quot;Profile Settings&quot; section:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Name;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Surname;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Email address;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Telephone number;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Mail adress;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Cookies.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>e) When the registered user pays for the Service:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Recipient's address;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Email address;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Name;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Surname;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Order;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>· Date, time and amount of the financial obligation fulfilled by the User;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>· Amount of the user's unfulfilled financial obligation and terms of fulfillment;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Cashier's check and cashier's check data;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Payment method;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>· The basis of discounts and discounts provided to the user;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Cookies.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>f) When registering for events organized by the administration, broadcast events:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Name;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Surname;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Email address;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Cookies.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>g) when the Administration conducts statistical surveys:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Name;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Age;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Responsibilities;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Email address;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Cookies.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>h) After receiving counseling services by phone: the phone number from which the User is calling;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Name;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Surname;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>User registration data on the Website;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>Other personal data that the User informs the Administration of his own will and interests.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Cookie identifiers;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Browser user agent term;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Using an ad blocker;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Abbreviated IP address;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Browsing history;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Internet visit data;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Current position/job function;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>· Data on viewed goods, their price, date and time of viewing;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Pseudonymized e-mail addresses;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>· Geolocation;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>· Technical data about the browser, device, settings;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>· About interactions with advertising (clicks, bounces, transitions, etc.)</td>
        </tr>
        <tr height="85" style='height:63.75pt;'>
          <td class="xl68" height="85" style='height:63.75pt;'>When this information is collected, it is linked to unique identifiers, namely cookie identifiers and other similar technologies, and does not allow direct identification of the User (data anonymization). The User can disable the collection of this information in his browser in the manner described by the manufacturer of the User's browser. The administrator has the right to transfer the information obtained in accordance with this part to third parties.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>3.4. Purposes of processing personal data</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>3.4.2. The Administration processes Users' personal data only for the following purposes:</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl72" height="51" style='height:38.25pt;'>a) When the User uses the Website, both when registering on the Website and in absentia, the Administration processes the User's personal data in order to fulfill the Agreement for the use of the Website (User Agreement). . For this purpose, the Administration processes personal data 3.3. Current Agreement.</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl72" height="51" style='height:38.25pt;'>b) In order to fulfill the User Agreement, when the User uses the Website functions related to the User's voluntary entry, change, clarification, deletion of personal data. For this purpose, the Administration processes personal data in accordance with Rule 3.3.1. Current Agreement.</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl67" height="51" style='height:38.25pt;'>c) In order to conclude and execute contracts for the User's use of the Service without the User's prior registration on the Website, the Administration processes personal data in accordance with 3.3.1. Current Agreement.</td>
        </tr>
        <tr height="85" style='height:63.75pt;'>
          <td class="xl67" height="85" style='height:63.75pt;'>d) In order for the User to receive information from the Administration about the functionality of the Website and Services, so that the User can send information messages, questions, feedback to the Administration, receive advice and provide other informational assistance to the User, in the execution of the User Agreement, as well as the agreement on the use of the Service, the Administration processes personal data , p. 3.3.1 Current Agreement</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;'>e) In order to fulfill the User's request to receive the newsletter, the Administration processes personal data, p. 3.3.1. Current Agreement.</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl67" height="51" style='height:38.25pt;'>f) In order to improve the quality of the Service, to improve the Website, to conduct statistical and other researches based on depersonalized information of Users, the Administration processes personal data, p. 3.3.1. Current Agreement.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;'>g) The Administration processes personal data in order to conclude and execute Service usage contracts, p. 3.3.1. Current Agreement.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;'>h) In order to fulfill the contract between the User and the Administration regarding the preparation of the tender, p. 3.3.1 of the Administration's personal data. Current Agreement.</td>
        </tr>
        <tr height="40" style='height:30.00pt;'>
          <td class="xl76" height="40" style='height:30.00pt;'>3.5. Terms of personal data processing</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;'>3.5.1. The Administration, based on the assumption of the User's honesty, is guided by the fact that when submitting personal data on the Website, the User:</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl67" height="51" style='height:38.25pt;'>3.5.1.1. There is an active person. In the case of incapacity of such a person, consent to the processing of personal data is given by the legal representative of the User, who is familiar with the terms of processing of personal data specified in this Policy and agrees with them.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;'>3.5.1.2. Provide reliable information about yourself to the extent necessary to use the Website and constantly update the personal data provided.</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl67" height="51" style='height:38.25pt;'>3.5.1.3. By uploading his image through the Personal Account, he agrees to use this image without compensation for purposes not related to the identification of the User. The User undertakes not to provide photos of third parties as the User's image.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;'>3.5.1.4. Knows that the information about himself published by the User on the Website may become available to other Users of the Website, may be copied and distributed by such Users;</td>
        </tr>
        <tr height="85" style='height:63.75pt;'>
          <td class="xl67" height="85" style='height:63.75pt;'>3.5.1.5. Understands that the functionality of the Website allows the User to independently set public access (visibility mode) to some personal data for other Users. The User's creation of public access to his personal data is interpreted as the disclosure of the User's personal data on his own will and in his own interests. The User guarantees that he is familiar with the consequences of disclosing his personal data to other Users and will not have any claims against the Administration.</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl67" height="51" style='height:38.25pt;'>3.5.1.6. Understands that the processing of some personal data is based on the requirements of the current legislation of the Russian Federation, and the processing of personal data is necessary to fulfill the contract with such User.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>3.5.3. The User can clarify and change personal data independently, using the Personal Account.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;'>3.5.4. The User knows that he himself and in his own interests must independently check the relevance of personal data and make the necessary corrections and changes to his personal data in the Personal account.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>3.5.5. Personal data may be distributed only in the following cases:</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;'>3.5.5.1. Based on the will of the User, which is given by the User by setting public access (visibility mode) to his personal data, to display the User's profile, part of his personal data to other users of the Website.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>3.5.6. The administration has the right to transfer personal data to third parties for the following purposes:</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;'>3.5.6.1. Involvement of third parties in the process of execution of contracts concluded between the User and the Administration in order to improve the quality of execution of these contracts;</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl67" height="51" style='height:38.25pt;'>3.5.7. The administration has the right to transfer personal data to third parties, if such third parties ensure the confidentiality of personal data during their processing, and follow measures to ensure the security of personal data. It is prohibited to transfer and distribute the personal data of Users to a third party.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;'>3.5.8. Termination of the processing of the user's personal data, blocking and destruction of personal data is carried out in the following cases:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>a) Deletion of the user's personal data in the Personal Account at will;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>b) User requests;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>c) The Administration receives a request from the User to destroy or block personal data;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>d) After the expiration of the period allowing to manage the user's account;</td>
        </tr>
        <tr height="170" style='height:127.50pt;'>
          <td class="xl67" height="170" style='height:127.50pt;'>3.5.9. The administration takes necessary and sufficient legal, organizational and technical measures to protect personal data from illegal or accidental access, destruction, change, blocking, copying, distribution, as well as from other illegal actions of third parties directed at personal data. First of all, the Administration applies organizational and technical measures to ensure the security of personal data during their processing, control of the facts of illegal access to personal data and takes measures to prevent such incidents from recurring in the future, control of the measures taken to ensure the security of personal data and the level of personal data protection. To authorize access to the Personal Account, the User uses the User's login name (e-mail address) and password. The user is responsible for the security of this information. The user has no right to transfer his login name and password to third parties, and must take measures to ensure their confidentiality.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>3.6. The user has the right to:</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;'>3.6.1. To provide personal data to the Administration for their processing at its own discretion, of its own volition and in its own interests under the conditions specified in this Agreement;</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;'>3.6.2. Independently provide, change and delete personal data in the Personal account, if such changes and corrections contain the latest and reliable information;</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl67" height="51" style='height:38.25pt;'>3.6.3. Contact the Administration with requests, including regarding the destruction of personal data, cancellation of consent to processing, blocking of personal data. The request is submitted in the manner provided for in clause 3.6.2. current agreement.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;'>3.6.4. Delete the Personal Account independently or ask the Administration to delete the Personal Account in the manner specified in point 3.6.2;</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;'>3.6.5. Independently set the public access mode (visibility mode) of part of the personal data, cancel such mode.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>3.6.6. The user has the right to send his requirements and requests to the Administration in the following ways:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>3.6.7. in writing to the Administration postal address specified on the Website;</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl67" height="51" style='height:38.25pt;'>3.6.8. The document must be sent from the User's e-mail address, which he specified when registering on the Website or in the contract for using the Service, Administration's e-mail address. to the email address eu-info@foherb.com</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>3.6.9. Requests sent by the user must contain the following information:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>A) User name, surname;</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;'>B) User registration data on the Website (if the User is registered at the time of sending the request or request);</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>C) The essence of the User's requirement or request is described;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>D) User's signature.</td>
        </tr>
        <tr height="85" style='height:63.75pt;'>
          <td class="xl67" height="85" style='height:63.75pt;'>3.6.10 The Administration considers the requirements and requests received from the User regarding the availability of mandatory data, the validity of the request or appeal. If the User's request is justified, the Administration satisfies it within 30 days from the date of receipt. In any case, the Administration sends a response to the User no longer than 30 days from the date of receipt of the request or appeal. The response is sent to the User in a form that corresponds to the form of the User's request or appeal.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl71" height="18" style='height:13.50pt;'>3.7. Policy change</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;'>3.7.1. The Administration reserves the right to change the User Agreement. The User must familiarize himself with the text of the User Agreement every time he uses the Website.</td>
        </tr>
        <tr height="68" style='height:51.00pt;'>
          <td class="xl67" height="68" style='height:51.00pt;'>3.7.2. The new version of the User Agreement comes into force from its publication in the relevant section of the Website. Continued use of the Website or its services after the publication of a new version of the User Agreement means that the User agrees to the User Agreement and its terms. If you do not agree with the terms of the User Agreement, the User must immediately stop using the Website.</td>
        </tr>
      </table>
    </div>
    <div class="lt" v-show="this.language=='lt_LT' || this.language=='kk_KZ' || this.language=='tu_R' || this.language=='mn_MN'">
      <table width="774" border="0" cellpadding="0" cellspacing="0" style='width:580.50pt;border-collapse:collapse;table-layout:fixed;'>
        <col width="774" class="xl65" style='mso-width-source:userset;mso-width-alt:24768;'/>
        <tr height="37" style='height:27.75pt;'>
          <td class="xl66" height="37" width="774" style='height:27.75pt;width:580.50pt;' >NAUDOJIMO SĄLYGOS</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >Ši Vartotojo sutartis reglamentuoja santykius tarp savininko (toliau – Administracija ir (arba) KORDICEPSAS) ir svetainės naudotojo, iš kitos pusės.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;' >Naudodamasis svetaine Vartotojas sutinka su šios sutarties sąlygomis, išdėstytomis toliau.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >Administracija turi teisę bet kada ir be įspėjimo vienašališkai pakeisti šią sutartį.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >Draudžiama kopijuoti, perspausdinti ir kitaip naudoti medžiagą iš svetainės be išankstinio sutikimo su administracija.</td>
        </tr>
        <tr height="37" style='height:27.75pt;'>
          <td class="xl66" height="37" style='height:27.75pt;' >SUTARTIES TURINYS:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >1. Lojalumo programos sąlygos.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >2. Užsakymų pateikimo tvarka.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >3. Asmens duomenų tvarkymo politika</td>
        </tr>
        <tr height="37" style='height:27.75pt;'>
          <td class="xl66" height="37" style='height:27.75pt;' >1.LOJALUMO PROGRAMOS SĄLYGOS</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >Terminai ir žymėjimas</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >Šiame pasiūlyme naudojamų terminų ir pavadinimų sąrašas pateikiamas svetainėje.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >Lojalumo programa - nemokama elektroninė paslauga internete, esanti adresu https://www.whieda.org/#/, suteikianti Vartotojams galimybę grąžinti dalį lėšų, išleistų pirkiniams internetinėje parduotuvėje.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >Vartotojas – internetinės parduotuvės lankytojas, svetainėje užsiregistravęs asmuo.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >Cashback – grąžinama dalis lėšų, išleistų pirkiniams internetinėje parduotuvėje.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >Paskyra – Vartotojo paskyra, suteikianti prieigą prie visų internetinės parduotuvės funkcijų, įskaitant vidinę sąskaitą, į kurią įskaitomas pinigų grąžinimas.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >Administracija – internetinės parduotuvės darbuotojai, įgalioti atlikti bet kokias operacijas su Vartotojo paskyra pagal šį Pasiūlymą.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >Vidinė sąskaita - internetinės parduotuvės Vartotojo sąskaita, kurioje fiksuojamas sukauptas pinigų grąžinimas ir jo būsena.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >Reklaminė medžiaga - baneriai, rekomendacijų nuoroda ir kitos priemonės, skirtos naujų Vartotojų pritraukimui, su galimybe gauti atlygį už aktyvius nukreiptų ir registruotų rekomendacijų veiksmus (pirkimus).</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >Apgaulingi veiksmai - bet kokios rūšies sukčiavimas, kurio tikslas – neteisėtai gauti pinigų grąžinimą.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >SPAM – masinis reklaminio pobūdžio informacijos ar kitokio pobūdžio žinučių siuntimas neatsižvelgiant į gavėjų pageidavimus.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >1.1. Bendrosios nuostatos</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >1.1.1. Registruodamasis<span style='mso-spacerun:yes;'>&nbsp; </span>svetainėje, Vartotojas patvirtina, kad:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >a) Vartotojas yra ne jaunesnis kaip 18 metų;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >b) Naudotojas yra veiksnus, teisiškai veiksnus pagal savo valstybės įstatymus;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >c) Vartotojas įsipareigoja neleisti asmenims iki 18 metų naudotis Lojalumo programa;</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >d) Vartotojas įsipareigoja neleisti nedarbingiems, nekompetentingiems asmenims naudotis Lojalumo programa ir yra asmeniškai atsakingas už tai, kad tokie asmenys negalėtų naudotis Lojalumo programa;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >e) Paskyra bus naudojama pirkimams tik Sąskaitos turėtojo vardu;</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >f) Vartotojas patvirtina, kad jam buvo pranešta, ir sutinka, kad Administracija prireikus pakeis šio Pasiūlymo turinį; - Vartotojas patvirtina, kad susipažino su šiuo pasiūlymu ir besąlygiškai sutinka su jo sąlygomis;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >g) Vartotojas patvirtina, kad jis visiškai supranta visas savo teises ir pareigas.</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl67" height="51" style='height:38.25pt;' >1.1.2. Administratorius pagal Lojalumo programą Vartotojui sumoka pinigų grąžinimą, kuris yra suformuotas iš Lojalumo programos „Internetinės parduotuvės pinigų grąžinimo sistema“. Pinigų grąžinimas iškokamas jei vartotojas laikosi visų taisyklių ir rekomendacijų ir su sąlyga, kad prekė nebuvo sugrąžinta Pardavėjui (visa ir dalinai), arba buvo atsisakyta paslaugos.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >1.1.3. Grynieji pinigai bus gauti iš karto po užsakymo patvirtinimo dalyvaujant lojalumo programoje. Paprastai tai įvyksta per 1 minutę, tačiau kai kuriais atvejais lėšų įskaitymo terminai gali trukti iki 24 valandų.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >1.1.4. Sistemos gedimo atveju, atsisakius atlikti mokėjimo operaciją, pinigų grąžinimas nebus įskaitytas. Tokiais atvejais reikia kreiptis į įmonės kontaktinį asmenį.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >1.2. CASHBACK taisyklės</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >1.2.1. Norėdami gauti grąžinimą, Vartotojas turi būti užsiregistravęs svetainėje, dalyvauti lojalumo programoje ir įvykdyti jos sąlygas.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >1.3. CASHBACK išmokėjimai</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >1.3.1. Vartotojas gali palikti grynųjų pinigų grąžinimo užklausą, kai sąskaitoje esanti suma pasiekia minimalią išgryninimo ribą. Informaciją apie grynųjų pinigų grąžinimo būdus, taip pat minimalią išgryninimo sumą rasite Vartotojo paskyroje.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >1.3.2. Minimali vienkartinio išėmimo suma yra ne mažesnė kaip 150 eurų.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >1.3.3. Prašymas išmokėti lėšas išnagrinėjamas per 24 valandas. Maksimalus laikotarpis yra 72 valandos.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >1.3.4. Prašymas išmokėti lėšas gali būti atmestas arba atidėtas, jei kyla įtarimų, kad Vartotojas atliko nesąžiningus veiksmus, arba kyla įtarimas dėl neteisėtos prieigos prie Paskyros ir trečiųjų asmenų sąskaitos.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >1.3.5. Mokant grynųjų pinigų grąžinimą, metinė suminė suma, ne didesnė kaip 1800 eurų, Naudotojo gyvenamosios šalies mokesčiai nėra apmokestinami. Naudotojas privalo savarankiškai imtis veiksmų, kad sumokėtų mokestines prievoles.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >1.3.6 Išmokėjus grynųjų pinigų grąžinimą, apdorojimo mokestis, imamas arba nurašytas iš gavėjo (vartotojo) banko sąskaitos, tenka vartotojui.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >1.3.7. Administratorius turi teisę bet kada vienašališkai pakeisti pinigų grąžinimo sąlygas.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >1.4. Rekomendacijų programa</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >1.4.1. Užsiregistravęs Harmony svetainėje, Naudotojas gauna individualią nukreipimo nuorodą, kad pritrauktų naujus Naudotojus, kad gautų atlygį.</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl67" height="51" style='height:38.25pt;' >1.4.2. Reklaminę medžiagą, įskaitant nukreipimo nuorodą ir banerius, Vartotojas turi teisę talpinti savo svetainėje ar puslapyje socialiniuose tinkluose, siųsti savo draugams. Lankytojai, kurie seka Naudotojo persiuntimo nuorodą, bus skaičiuojami kaip jo persiuntimai.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >1.4.3. Atlygis už pritrauktus persiuntimus mokamas vadovaujantis Lojalumo programa „Internetinės parduotuvės Cashback sistema“ ir jos sąlygų įvykdymu.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >1.4.4. Vartotojui leidžiama registruoti kelias paskyras naudojant savo nukreipimo nuorodą. Tokie veiksmai nebus laikomi nesąžiningais.</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl67" height="51" style='height:38.25pt;' >1.4.5. Vartotojui draudžiama pritraukti anksčiau registruotus vartotojus, turinčius kitokios struktūros paskyrą su registracija svetainėje https://www.whieda.org/#/. Aptikus tokius veiksmus, Administracija turi teisę apriboti vartotojo prieigą prie Paskyros nemokant lėšų iš Vartotojo sąskaitos.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >1.4.6. Griežtai draudžiama pritraukti nukreipimus siunčiant SPAM žinutes arba per kontekstinę reklamą.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >1.5. Šalių atsakomybė</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl67" height="51" style='height:38.25pt;' >1.5.1. Vartotojui draudžiama pritraukti anksčiau registruotus vartotojus, turinčius kitokios struktūros paskyrą su registracija svetainėje https://www.whieda.org/#/. Aptikus tokius veiksmus, Administracija turi teisę apriboti vartotojo prieigą prie Paskyros nemokant lėšų iš Vartotojo sąskaitos.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >1.5.2. Vartotojas yra asmeniškai atsakingas už prisijungimo prie savo Paskyros duomenų (prisijungimo, slaptažodžio, el. pašto ir kt.) saugumą. Draudžiama suteikti prieigą prie Paskyros trečiosioms šalims arba padaryti jas viešai prieinamas trečiųjų šalių šaltiniuose.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >1.5.3. Vartotojas privalo informuoti Administraciją per techninės pagalbos tarnybą, jei jam kyla įtarimų dėl trečiųjų šalių neteisėtos prieigos prie Paskyros.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >1.5.4. Administratorius neatsako už galimą žalą, atsiradusią dėl trečiųjų šalių neteisėtos prieigos prie Vartotojo paskyros.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >1.5.5. Administratorius neatsako už sklandų svetainės veikimą.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >1.5.6. Vartotojas pripažįsta ir sutinka, kad galutinis naudojimosi Lojalumo programa rezultatas gali neatitikti Vartotojo lūkesčių.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >1.5.7. Administratorius jokiomis aplinkybėmis neatsako už žalą, gautą naudojant svetainę ar negalėjimą ja naudotis.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >1.5.8. Nustačius nesąžiningus vartotojo veiksmus, Administratorius turi teisę apriboti vartotojo prieigą prie Paskyros, nemokėdamas lėšų iš Vartotojo sąskaitos.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >1.5.9. Vartotojui atlikus veiksmus, dėl kurių pablogėja (ar prarandama) įmonės dalykinė reputacija, Administratorius turi teisę apriboti vartotojo prieigą prie Paskyros, nemokėdamas lėšų iš Vartotojo sąskaitos.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >1.6. Pinigų grąžinimo paslaugos funkcionavimas</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >1.6.1. Atsižvelgdama į galimus techninius nesklandumus, planuojamą ar neplanuotą techninio aptarniavimo atnaujinimą, Administracija negarantuoja Vartotojui nuolatinės prieigos prie Lojalumo programos duomenų.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >1.6.2. Negalima atmesti sistemos gedimų dėl trečiųjų šalių kenkėjiškų veiksmų ar techninių problemų. Tokiais atvejais Administracija pasilieka teisę sustabdyti paslaugos teikimą iki visiško techninių nesklandumų ar įvairaus pobūdžio grėsmių pašalinimo.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >1.6.3. Administracija įsipareigoja imtis visų būtinų veiksmų, kad užtikrintų stabilų svetainės veikimą.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >1.6.4. Administracija įsipareigoja kuo greičiau pašalinti visas iškilusias technines problemas, turinčias įtakos teisingam svetainės veikimui.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >1.7. Asmeninė informacija</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >1.7.1. Registruodamasis Harmony svetainėje, Vartotojas sutinka, kad Harmony svetainė naudotų ir tvarkytų jo asmens duomenis.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >1.7.2. Administratorius garantuoja Vartotojui, kad jo asmens duomenų bus naudojimą tik pagal asmens duomenų apsaugos įstatymą.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >1.7.3. Administratorius neperduoda vartotojo asmens duomenų Partnerių parduotuvėms, ar trečiajai šaliai.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >1.7.4. Tuo atveju, kai Vartotojas perduoda savo asmens duomenis kreipdamasis į techninės pagalbos tarnybą, tokie duomenys nebus saugomi ir bus naudojami tik Naudotojo iškeltai problemai išspręsti.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >1.8. E-MAIL persiuntimai</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >1.8.1. Registruodamasis svetainėje Vartotojas sutinka gauti iš įmonės laiškus registracijos metu nurodytu el.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >1.8.2. Jeigu vartotojas nori atsisakyti laiškų gavimo jis gali kreiptis į Administraciją su prašymu ištrinti Paskyrą arba pakeisti laiškų gavimo funkcijas Vartotojo paskyros nustatymuose.</td>
        </tr>
        <tr height="37" style='height:27.75pt;'>
          <td class="xl66" height="37" style='height:27.75pt;' >2.UŽSAKYMŲ ATLIKIMO TAISYKLĖS</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >2.1.Užsakymo pateikimas:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >2.1.1. Pasirinkite prekę, kurią norite įsigyti. Spustelėkite „Į krepšelį“, prekė bus automatiškai įtraukta į krepšelį.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >2.1.2. Įsitikinus, kad pirkinių sąrašas krepšelyje yra teisingas, spauskite mygtuką „Pirkti“. Įveskite informaciją apie Pirkėją: Vardas, pavardė, kontaktinis telefono numeris ir e-mail. Pasirinkite pristatymo būdą.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >2.1.3. Mūsų vadybininkas susisieks su Jumis, kad patvirtintų užsakymą ir jo pristatymo datą.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >2.2. Užsakymo apmokėjimas</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >2.2.1. Užsakymo apmokėjimo būdai:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >· Atsiskaitymas grynaisiais arba VISA, MASTERCARD ar PAYSERA kortelėmis atsiimant.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >· Mokėjimas grynaisiais arba VISA, MASTERCARD aarba PAYSERA kortelėmis (kai pristatoma ES viduje).</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >· Mokėjimas banko pavedimu internetu svetainėje VISA, MASTERCARD arba PAYSERA kortelėmis.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >2.2.2. Atsiskaitymo banko kortele taisyklės</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl67" height="51" style='height:38.25pt;' >2.2.2.1. Norėdami atsiskaityti už prekes banko kortele, pateikdami užsakymą internetinėje parduotuvėje pasirinkite mokėjimo būdą: banko kortele. Mokant už užsakymą banko kortele, mokėjimo apdorojimas vyksta banko autorizacijos puslapyje, kuriame reikia įvesti savo banko kortelės duomenis:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >1. kortelės tipas</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >2. kortelės numeris</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >3. kortelės galiojimo laikas (nurodytas kortelės priekinėje pusėje)</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >4. Kortelės turėtojo vardas ir pavardė (lotyniškomis raidėmis, tiksliai taip, kaip nurodyta kortelėje)</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >5. CVC2/CVV2 kodas</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl67" height="51" style='height:38.25pt;' >Jei jūsų kortelė yra prijungta prie 3D-Secure paslaugos, būsite automatiškai nukreipti į kortelę išdavusio banko puslapį, kad atliktumėte autentifikavimo procedūrą. Informacijos apie papildomo identifikavimo taisykles ir būdus teiraukitės banko kortelę išdavusiame banke.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >Internetinių mokėjimų apdorojimo per banko mokėjimo šliuzą saugumą garantuoja PCI DSS tarptautinis saugumo sertifikatas. Informacija perduodama naudojant TLS šifravimo technologiją. Ši informacija nėra prieinama trečiosioms šalims.</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl67" height="51" style='height:38.25pt;' >2.3. Prekę vartotojas įsigyja komerciniais tikslais, nesusijusiais su asmeniniais, šeimos, namų ar kitais poreikiais. Grąžinti tinkamos kokybės prekes neleidžiama. Netinkamos kokybės prekių grąžinimas vykdomas galiojančių valstybės, kurioje prekės buvo įsigytos, teisės aktų nustatyta tvarka.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >2.4. Draudžiama perparduoti prekes kitose prekyvietėse už kainą, kuri skiriasi nuo oficialios svetainės kainos. Tokių precedentų atveju „Vartotojų“ asmeninės paskyros bus išjungtos. Jei reikia, administracija pasilieka teisę šias situacijas išspręsti teisme.</td>
        </tr>
        <tr height="40" style='height:30.00pt;'>
          <td class="xl70" height="40" style='height:30.00pt;' >3. PRIVATUMO POLITIKA</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >3.1. Pagrindinės sąvokos</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >Asmens duomenys – bet kokia su Vartotoju susijusi informacija. Vartotojas – Svetaine besinaudojantis asmuo.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >Interneto svetainė – Administracijai priklausantis automatizuotų informacinių sistemų ir informacijos rinkinys, nepriklausomai nuo jos pateikimo formos, pasiekiamas internete tinklo adresais šiuose domenuose (įskaitant subdomenus): https://www.whieda.org/# /.</td>
        </tr>
        <tr height="68" style='height:51.00pt;'>
          <td class="xl67" height="68" style='height:51.00pt;' >Asmens duomenų tvarkymas – bet koks veiksmas (operacija) arba veiksmų (operacijų) visuma, atliekama naudojant automatizavimo priemones arba nenaudojant tokių priemonių su asmens duomenimis, įskaitant rinkimą, įrašymą, sisteminimą, kaupimą, saugojimą, išaiškinimą (atnaujinimą). , keitimas), asmens duomenų išgavimas, naudojimas, perdavimas (platinimas, teikimas, prieiga), nuasmeninimas, blokavimas, ištrynimas, sunaikinimas.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >Automatizuotas asmens duomenų tvarkymas – asmens duomenų tvarkymas kompiuterinių technologijų pagalba.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >Socialinis tinklas – trečiosioms šalims priklausanti svetainė informaciniame ir telekomunikacijų tinkle Internete, skirta nuotoliniam žmonių bendravimui.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >Paslauga – produktai, paslaugos, autorių teisių objektai, kuriuos Administracija teikia suinteresuotoms šalims įsigyti, naudoti per Svetainę civilinės teisės sutarčių sąlygomis.</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl67" height="51" style='height:38.25pt;' >Asmeninė paskyra – asmeninė Svetainės dalis ir papildomos Svetainės funkcijos, prie kurių Vartotojas įgyja prieigą prisiregistravęs ir (arba) autorizuodamas Svetainėje. Asmeninė paskyra skirta saugoti Vartotojo asmeninius duomenis, peržiūrėti ir valdyti turimas Svetainės funkcijas bei atitinkamas Svetainės naudojimo sąlygas, valdyti per Svetainę atliktas operacijas.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >Vartotojo sutartis – civilinės teisės sutartis dėl naudojimosi Svetaine.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >Užsakymas – automatiškai sugeneruotas duomenų rinkinys apie Vartotojo veiksmus, kuriais siekiama sudaryti su Administracija civilinę sutartį dėl naudojimosi Paslauga, įskaitant informaciją apie Vartotojo pasirinktą Paslaugą, Paslaugos kainą, datą ir laiką.</td>
        </tr>
        <tr height="68" style='height:51.00pt;'>
          <td class="xl67" height="68" style='height:51.00pt;' >Kasos kvitas yra pirminis apskaitos dokumentas, sugeneruojamas Naudotojui ir Administracijai atsiskaitant, susijusiu su sutarčių dėl naudojimosi Paslauga sudarymu, vykdymu ir nutraukimu. Atsiskaitymų sąvoka vartojama ta prasme, kuria ji apibrėžta federaliniame įstatyme „Dėl kasos aparatų naudojimo vykdant atsiskaitymus grynaisiais ir (ar) atsiskaitymus naudojant elektronines mokėjimo priemones“ .</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >Mokėjimo būdas – informacija apie banką, mokėjimo sistemą, mokėjimo priemones, kuriomis Vartotojas atsiskaito už Paslaugą.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >3.2 Sutikimas dėl asmens duomenys tvarkymo</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >3.2.1 Vartotojas nusprendžia pateikti savo asmens duomenis Administracijai, sutinka su Vartotojo sutarties sąlygomis ir sutinka, kad jo asmens duomenys būtų tvarkomi laisvai, savo noru ir jo interesais.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >3.2.1 Vartotojo sutikimas tvarkyti jo asmens duomenis laikomas pateiktu Administracijai, jeigu jis yra išsiųstas:</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >a) Registruodamiesi Svetainėje užpildydami Svetainėje esančią formą, paspaudę mygtuką „Registracija“. Laikoma, kad vartotojas davė sutikimą tvarkyti jo asmens duomenis tuo metu, kai paspaudžia mygtuką „Tęsti“.</td>
        </tr>
        <tr height="85" style='height:63.75pt;'>
          <td class="xl67" height="85" style='height:63.75pt;' >b) Įvedant ar keičiant asmens duomenis skiltyje „Profilio nustatymai“ poskyriuose „Keisti kontaktinę informaciją“, „Kontaktų sąrašas“, „Slaptažodis“, „Operacijos slaptažodis“, „Naujienlaiškis el. paštu“ – dėl asmens duomenų, kuriuos Vartotojas pateikia redaguodamas informaciją asmeninėje paskyroje. Laikoma, kad vartotojas davė sutikimą tvarkyti naujai įvestus ar pakeistus jo asmens duomenis mygtuko „Išsaugoti“ arba „Keisti“ paspaudimu arba sąsajos mygtuko, kuriame aiškiai nurodomas paaiškinimas, paspaudimo momentu, asmens duomenų keitimas, ištrynimas, taisymas.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >3.3. Asmens duomenys, kuriuos tvarko administracija</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >3.3.1 Administracija tvarko šiuos Vartotojų asmens duomenis:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >a) Registruodami vartotoją svetainėje:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Vardas;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Pavardė;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Elektroninio pašto adresas;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Telefono numeris;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Slapukai.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >b) Siųsdami Administracijai informacinius pranešimus, klausimus, atsiliepimus:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Elektroninio pašto adresas;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Vardas;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Pavardė;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Telefono numeris;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Slapukai.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >c) Įvesdami arba keisdami asmeninius duomenis skiltyje „Profilio nustatymai“:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Vardas;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Pavardė;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Elektroninio pašto adresas;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Telefono numeris;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Pašto adresas;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Slapukai.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >e) Kai registruotas vartotojas moka už Paslaugą:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Gavėjo adresas;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Elektroninio pašto adresas;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Vardas;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Pavardė;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Užsakymas;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >· Naudotojo įvykdyto finansinio įsipareigojimo data, laikas ir suma;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >· Vartotojo neįvykdyto finansinio įsipareigojimo dydis ir įvykdymo terminai;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Kasos čekis ir kasos čekio duomenys;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Mokėjimo metodas;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >· Naudotojui teikiamos nuolaidos ir nuolaidų pagrindas;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Slapukai.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >f) Registruojantis į administracijos rengiamus renginius, transliuojamus renginius:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Vardas;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Pavardė;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Elektroninio pašto adresas;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Slapukai.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >g) kai Administracija atlieka statistinius tyrimus:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Vardas;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Amžius;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Pareigos;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Elektroninio pašto adresas;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Slapukai.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >h) Gavus konsultavimo paslaugas telefonu: telefono numeris, iš kurio Vartotojas skambina;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Vardas;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Pavardė;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >·Vartotojo registracijos duomenys Svetainėje;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >·Kiti asmens duomenys, kuriuos Vartotojas savo valia ir interesais praneša Administracijai.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Slapukų identifikatoriai;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Naršyklės vartotojo agento terminas;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Skelbimų blokavimo priemonės naudojimas;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Sutrumpintas IP adresas;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Naršymo istorija;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Apsilankymų internete duomenys;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Einamas pareigas / darbo funkcija;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >· Duomenys apie žiūrėtas prekes, jų kaina, peržiūros data ir laikas;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Pseudonimizuoti elektroninio pašto adresai;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >· Geolokacija;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >· Techniniai duomenys apie naršyklę, įrenginį, nustatymus;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >· Apie sąveiką su reklama (paspaudimai, atmetimas, perėjimai ir kt.)</td>
        </tr>
        <tr height="68" style='height:51.00pt;'>
          <td class="xl67" height="68" style='height:51.00pt;' >Renkant šią informaciją, ji yra susieta su unikaliais identifikatoriais, būtent, slapukų identifikatoriais ir kitomis panašiomis technologijomis, ir neleidžia tiesiogiai identifikuoti Vartotojo (duomenų anonimizavimas). Vartotojas gali išjungti šios informacijos rinkimą savo naršyklėje Vartotojo naršyklės gamintojo aprašytu būdu. Administratorius turi teisę perduoti informaciją, gautą pagal šią dalį, tretiesiems asmenims.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >3.4. Asmens duomenų tvarkymo tikslai</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >3.4.2. Administracija tvarko Vartotojų asmens duomenis tik šiais tikslais:</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl67" height="51" style='height:38.25pt;' >a) Kai Naudotojas naudojasi Svetaine, tiek registruodamasis Svetainėje, tiek nesant, Administracija tvarko Vartotojo asmens duomenis, kad būtų įvykdyta Svetainės naudojimo sutartis (Naudotojo sutartis). . Šiuo tikslu Administracija tvarko asmens duomenis 3.3. Dabartinis susitarimas.</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl67" height="51" style='height:38.25pt;' >b) Siekiant įvykdyti Vartotojo sutartį, kai Vartotojas naudojasi Svetainės funkcijomis, susijusiomis su Vartotojo savanorišku asmens duomenų įvedimu, keitimu, patikslinimu, ištrynimu. Šiuo tikslu Administracija tvarko asmens duomenis Taisyklių 3.3.1. Dabartinis susitarimas.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >c) Siekdama sudaryti ir vykdyti sutartis dėl Vartotojo naudojimosi Paslauga be išankstinės Vartotojo registracijos Svetainėje, Administracija tvarko asmens duomenis pagal 3.3.1. Dabartinis susitarimas.</td>
        </tr>
        <tr height="68" style='height:51.00pt;'>
          <td class="xl67" height="68" style='height:51.00pt;' >d) Kad Naudotojas gautų informaciją iš Administracijos apie Svetainės, Paslaugų funkcionalumą, kad Naudotojas galėtų siųsti informacinius pranešimus, klausimus, atsiliepimus Administracijai, gauti patarimus ir teikti kitą informacinę pagalbą Naudotojui, vykdydama Vartotojo sutartį, taip pat sutartis dėl naudojimosi Paslauga, Administracija tvarko asmens duomenis, 3.3.1 p. Dabartinis susitarimas</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >e) Siekdama įvykdyti Vartotojo prašymą gauti naujienlaiškį, Administracija tvarko asmens duomenis, 3.3.1 p. Dabartinis susitarimas.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >f) Siekdama gerinti Paslaugos kokybę, tobulinti Svetainę, atlikti statistinius ir kitus tyrimus, pagrįstus nuasmeninta Vartotojų informacija, Administracija tvarko asmens duomenis, 3.3.1 p. Dabartinis susitarimas.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >g) Administracija, siekdama sudaryti ir vykdyti naudojimosi Paslauga sutartis, tvarko asmens duomenis, 3.3.1 p. Dabartinis susitarimas.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >h) Siekiant įvykdyti sutartį tarp Vartotojo ir Administracijos dėl konkurso rengimo, Administracijos asmens duomenų 3.3.1 p. Dabartinis susitarimas.</td>
        </tr>
        <tr height="40" style='height:30.00pt;'>
          <td class="xl70" height="40" style='height:30.00pt;' >3.5. Asmens duomenų tvarkymo sąlygos</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >3.5.1. Administracija, remdamasi Vartotojo sąžiningumo prielaida, vadovaujasi tuo, kad pateikdamas asmens duomenis Svetainėje, Vartotojas:</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >3.5.1.1. Yra veiksnus žmogus. Tokio asmens neveiksnumo atveju sutikimą dėl asmens duomenų tvarkymo duoda Naudotojo teisėtas atstovas, susipažinęs su šioje Politikoje nurodytomis asmens duomenų tvarkymo sąlygomis ir su jomis sutinkantis.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >3.5.1.2. Nurodo patikimą informaciją apie save tiek, kiek reikia norint naudotis Svetaine, ir nuolat atnaujina pateiktus asmens duomenis.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >3.5.1.3. Įkeldamas savo atvaizdą per Asmeninę paskyrą, jis sutinka neatligintinai naudoti šį atvaizdą su Vartotojo identifikavimu nesusijusiais tikslais. Vartotojas įsipareigoja neteikti trečiųjų asmenų nuotraukų kaip Vartotojo atvaizdo.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >3.5.1.4. Žino, kad Svetainėje Vartotojo paskelbta informacija apie save gali tapti prieinama kitiems Svetainės naudotojams, tokių Vartotojų gali būti kopijuojama ir platinama;</td>
        </tr>
        <tr height="68" style='height:51.00pt;'>
          <td class="xl67" height="68" style='height:51.00pt;' >3.5.1.5. Supranta, kad Svetainės funkcionalumas leidžia Vartotojui savarankiškai nustatyti viešą prieigą (matomumo režimą) prie dalies asmens duomenų kitiems Vartotojams. Naudotojo viešos prieigos prie savo asmens duomenų sukūrimas interpretuojamas kaip Naudotojo asmens duomenų atskleidimas savo valia ir jo paties interesais. Vartotojas garantuoja, kad yra susipažinęs su savo asmens duomenų atskleidimo kitiems Vartotojams pasekmes ir neturės pretenzijų Administracijai.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >3.5.1.6. Supranta, kad kai kurių asmens duomenų tvarkymas yra pagrįstas galiojančių Rusijos Federacijos teisės aktų reikalavimais, o asmens duomenų tvarkymas yra būtinas norint įvykdyti sutartį su tokiu Vartotoju.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >3.5.3. Asmens duomenų patikslinimą, keitimą Vartotojas gali atlikti savarankiškai, naudodamasis Asmenine paskyra.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >3.5.4. 3.5.4.Vartotojas žino, kad jis pats ir savo interesais privalo savarankiškai patikrinti asmens duomenų aktualumą ir atlikti reikiamus savo asmens duomenų patikslinimus, pakeitimus Asmens paskyroje.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >3.5.5. Asmens duomenys gali būti platinami tik šiais atvejais:</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >3.5.5.1. Remiantis Naudotojo valia, kurią suteikia Naudotojas, nustatydamas viešą prieigą (matomumo režimą) prie savo asmens duomenų, kad būtų rodomas Vartotojo profilis, dalis jo asmens duomenų kitiems Svetainės naudotojams.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >3.5.6. Administracija turi teisę perduoti asmens duomenis tretiesiems asmenims šiais tikslais:</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >3.5.6.1. Trečiųjų asmenų įtraukimas į tarp Vartotojo ir Administracijos sudarytų sutarčių vykdymo procesą, siekiant pagerinti šių sutarčių vykdymo kokybę;</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl67" height="51" style='height:38.25pt;' >3.5.7. Administracija turi teisę perduoti asmens duomenis tretiesiems asmenims, jeigu tokie tretieji asmenys užtikrina asmens duomenų konfidencialumą jų tvarkymo metu, laikosi priemonių asmens duomenų saugumui užtikrinti. Trečiajai šaliai draudžiama perduoti ir platinti Vartotojų asmens duomenis.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >3.5.8. Vartotojo asmens duomenų tvarkymo nutraukimas, asmens duomenų blokavimas ir sunaikinimas vykdomas šiais atvejais:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >a) Vartotojo asmens duomenų ištrynimas Asmeninėje paskyroje sava valia;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >b) Vartotoju prašimųl;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >c) Administracija gauna iš Vartotojo prašymą sunaikinti arba blokuoti asmens duomenis;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >d) Pasibaigus terminui leidžiančiam tvarkyti vartotojo paskyrą;</td>
        </tr>
        <tr height="136" style='height:102.00pt;'>
          <td class="xl67" height="136" style='height:102.00pt;' >3.5.9. Administracija imasi būtinų ir pakankamų teisinių, organizacinių ir techninių priemonių asmens duomenims apsaugoti nuo neteisėtos ar atsitiktinės prieigos, sunaikinimo, keitimo, blokavimo, kopijavimo, platinimo, taip pat nuo kitų neteisėtų trečiųjų asmenų veiksmų, nukreiptų į asmens duomenis. Visų pirma, Administracija taiko organizacines ir technines priemones asmens duomenų saugumui užtikrinti jų tvarkymo metu, neteisėtos prieigos prie asmens duomenų faktų kontrolę ir imasi priemonių, kad tokie incidentai ateityje nepasikartotų, kontrolė priemonių, kurių imamasi užtikrinti, asmens duomenų saugumą ir asmens duomenų apsaugos lygį. Prieigai prie Asmeninės Paskyros autorizuoti Vartotojas naudoja Vartotojo prisijungimo vardą (el. pašto adresą) ir slaptažodį. Vartotojas yra atsakingas už šios informacijos saugumą. Vartotojas neturi teisės perduoti savo prisijungimo vardo ir slaptažodžio tretiesiems asmenims, taip pat privalo imtis priemonių jų konfidencialumui užtikrinti.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >3.6. Vartotojas turi teisę:</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >3.6.1. Savo nuožiūra, savo noru ir savo interesais šioje Sutartyje nurodytomis sąlygomis Administracijai teikti asmens duomenis jų tvarkymui;</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >3.6.2. Savarankiškai teikti, keisti ir ištrinti asmens duomenis Asmens paskyroje, jeigu tokiuose pakeitimuose ir pataisymuose yra naujausia ir patikima informacija;</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >3.6.3. Kreiptis į Administraciją su prašymais, įskaitant dėl ​​asmens duomenų sunaikinimo, sutikimo tvarkyti atšaukimo, asmens duomenų blokavimo. Prašymas pateikiamas 3.6.2 punkte numatytu būdu. dabartinis susitarimas.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >3.6.4. Ištrinti Asmeninę Paskyrą savarankiškai arba paprašyti Administracijos ištrinti Asmeninę paskyrą 3.6.2 punkte nurodytu būdu;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >3.6.5. Savarankiškai nustatyti dalies asmens duomenų viešos prieigos režimą (matomumo režimą), atšaukti tokį režimą.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >3.6.6. Vartotojas turi teisę siųsti savo reikalavimus ir prašymus Administracijai šiais būdais:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >3.6.7. raštu Svetainėje nurodytu Administracijos pašto adresu;</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >3.6.8. Dokumentas turi būti siunčiamas iš Vartotojo elektroninio pašto adreso, kurį jis nurodė registruodamasis Svetainėje arba naudojimosi Paslauga sutartyje, Administracijos el. pašto adresu info@prioritet-zdorovye.ru.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >3.6.9. Vartotojo siunčiamuose prašymuose turi būti ši informacija:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >A) Vartotojo vardas, pavardė;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;' >B) Vartotojo registracijos Svetainėje duomenys (jei Vartotojas yra užsiregistravęs prašymo ar užklausos siuntimo metu);</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >C) Aprašyta Vartotojo reikalavimo ar prašymo esmė;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >D) Vartotojo parašas.</td>
        </tr>
        <tr height="68" style='height:51.00pt;'>
          <td class="xl67" height="68" style='height:51.00pt;' >3.6.10 Administracija svarsto iš Vartotojo gautus reikalavimus ir prašymus dėl privalomų duomenų prieinamumo, prašymo ar apeliacijos pagrįstumo. Jeigu Vartotojo prašymas yra pagrįstas, Administracija jį patenkina per 30 dienų nuo gavimo dienos. Bet kuriuo atveju Administracija išsiunčia Vartotojui atsakymą ne ilgiau kaip per 30 dienų nuo prašymo ar apeliacijos gavimo dienos. Atsakymas Vartotojui išsiunčiamas tokia forma, kuri atitinka Vartotojo prašymo ar kreipimosi formą.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;' >3.7. Politikos keitimas</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;' >3.7.1. Administracija pasilieka teisę keisti Vartotojo sutartį. Vartotojas privalo kiekvieną kartą, kai naudojasi Svetaine, susipažinti su Vartotojų sutarties tekstu.</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl67" height="51" style='height:38.25pt;' >3.7.2. Nauja Vartotojo sutarties versija įsigalioja nuo jos paskelbimo atitinkamoje Svetainės skiltyje. Tolesnis naudojimasis Svetaine ar jos paslaugomis po naujos Vartotojo sutarties versijos paskelbimo reiškia, kad Vartotojas sutinka su Vartotojo sutartimi ir jos sąlygomis. Nesutikdamas su Vartotojo sutarties sąlygomis, Vartotojas privalo nedelsdamas nustoti naudotis Svetaine.</td>
        </tr>
      </table>
    </div>
    <div class="rus" v-show="this.language=='ru_RU'">
      <table width="645" border="0" cellpadding="0" cellspacing="0" style='width:483.75pt;border-collapse:collapse;table-layout:fixed;'>
        <col width="645" class="xl65" style='mso-width-source:userset;mso-width-alt:20640;'/>
        <col width="805" span="16383" style='mso-width-source:userset;mso-width-alt:25760;'/>
        <tr height="40" style='height:30.00pt;'>
          <td class="xl66" height="40" width="645" style='height:30.00pt;width:483.75pt;'>ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>Настоящее Пользовательское Соглашение регулирует отношения между владельцем (далее – Администрация и (или) KORDICEPSAS) с одной стороны и пользователем сайта с другой.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl68" height="36" style='height:27.00pt;'>Используя сайт, Пользователь соглашается с условиями данного соглашения, изложенными ниже.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>Администрация имеет право в одностороннем порядке изменить это соглашение в любое время и без предупреждения.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>Запрещается копирование, перепечатка, и другое использование материалов с сайта, без предварительного согласования с Администрацией.</td>
        </tr>
        <tr height="40" style='height:30.00pt;'>
          <td class="xl66" height="40" style='height:30.00pt;'>СОДЕРЖАНИЕ СОГЛАШЕНИЯ:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>1.Условия программы лояльности.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>2.Порядок оформления заказов.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>3.Политика обработки персональных данных</td>
        </tr>
        <tr height="80" style='height:60.00pt;'>
          <td class="xl66" height="80" style='height:60.00pt;'>1.УСЛОВИЯ ПРОГРАММЫ ЛОЯЛЬНОСТИ</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>Термины и обозначения</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>Список терминов и обозначений, используемый в данной Оферте, на сайте.</td>
        </tr>
        <tr height="54" style='height:40.50pt;'>
          <td class="xl67" height="54" style='height:40.50pt;'>Программа лояльности – бесплатный электронный сервис в сети Интернет, расположенный по адресу https://www.whieda.org/#/, предоставляющий Пользователям услуги, позволяющие вернуть часть из потраченных средств на покупки в интернет-магазине.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>Пользователь – посетитель интернет-магазина, физическое лицо, зарегистрированное на сайте.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>Кэшбэк - возврат части из потраченных средств на покупки в интернет-магазине.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>Аккаунт – учетная запись Пользователя, дающая доступ ко всем функциям интернет-магазина, в том числе к внутреннему счету, на который начисляется кэшбэк.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>Администрация – сотрудники интернет-магазина, уполномоченные к выполнению любых операций с Аккаунтом Пользователя в рамках данной Оферты.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>Внутренний счет – счет Пользователя интернет-магазина, фиксирующий начисляемый кэшбэк и его статус.</td>
        </tr>
        <tr height="54" style='height:40.50pt;'>
          <td class="xl67" height="54" style='height:40.50pt;'>Рекламные материалы – баннеры, реферальная ссылка и другие инструменты для привлечения новых Пользователей, с возможностью получения вознаграждения за активные действия (покупки) приведенных и зарегистрированных рефералов.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>Обманное действие – мошенничество любого рода, цель которого – получение Кэшбэк незаконным путем.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>СПАМ – массовая рассылка информации рекламного характера либо иного рода сообщений без учета желаний получателей.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>1.1. Общие положения</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>1.1.1. Зарегистрировавшись на сайте, Пользователь подтверждает, что:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>a) Пользователю исполнилось полных 18 лет;</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>b) Пользователь является дееспособным, правоспособным в соответствии с законодательством своего государства;</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>c) Пользователь обязуется не допускать к пользованию Программой лояльности лиц, не достигших 18 лет;</td>
        </tr>
        <tr height="54" style='height:40.50pt;'>
          <td class="xl67" height="54" style='height:40.50pt;'>d) Пользователь обязуется не допускать к пользованию Программой лояльности недееспособных, неправоспособных лиц, и лично несет ответственность за не допуск таких людей к использованию Программы лояльности;</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>e) Аккаунт будет использоваться исключительно для совершения покупок от имени владельца Аккаунта;</td>
        </tr>
        <tr height="54" style='height:40.50pt;'>
          <td class="xl67" height="54" style='height:40.50pt;'>f) Пользователь подтверждает, что он уведомлен и дает согласие на изменение содержимого данной Оферты Администрацией в случае необходимости; - Пользователь подтверждает, что он ознакомился с данной Офертой, и он безоговорочно принимает ее условия;</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>g) Пользователь подтверждает, что ему понятны все его права и обязанности в полном объеме.</td>
        </tr>
        <tr height="72" style='height:54.00pt;'>
          <td class="xl67" height="72" style='height:54.00pt;'>1.1.2. Администратор выплачивает Пользователю кэшбэк по Программе лояльности, который формируется за счет бонусов Программы лояльности «Кэшбэк система Интернет-Магазина» в определенной сумме, при условии соблюдения всех правил и рекомендаций, и при условии отсутствия возврата товара Продавцу (полного или частичного), либо отказа от услуги</td>
        </tr>
        <tr height="54" style='height:40.50pt;'>
          <td class="xl67" height="54" style='height:40.50pt;'>1.1.3. Получение кэшбэка произойдет сразу после подтверждения заказа при участии в Программе лояльности. Обычно это происходит в течение 1 минуты, но в отдельных случаях сроки зачисления средств могут продлится до 24 часов.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>1.1.4. В случаях, возникновения системного сбоя, отказа проведения операции оплаты, кэшбэк начислен не будет. В таких случаях требуется обратиться на горячую линию компании.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>1.2. Правила начисления КЭШБЭК</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>1.2.1. Для начисления кэшбэка, Пользователь должен быть зарегистрирован и авторизирован на сайте, участвовать в Программе лояльности и выполнить её условия.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>1.3. Выплаты КЭШБЭК</td>
        </tr>
        <tr height="54" style='height:40.50pt;'>
          <td class="xl67" height="54" style='height:40.50pt;'>1.3.1. Пользователь может оставить заявку на вывод кэшбэк после того, как сумма на счете достигнет минимального порога для выплаты. Информация о способах вывода кэшбэк, а также минимальной сумме для вывода доступна в Аккаунте Пользователя.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>1.3.2. Минимальная разовая сумма для вывода средств составляет не меньше 150 евро.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>1.3.3. Заявка на выплату средств обрабатывается в течении 24 часов. Максимальный срок 72 часа.</td>
        </tr>
        <tr height="54" style='height:40.50pt;'>
          <td class="xl67" height="54" style='height:40.50pt;'>1.3.4. Заявка на выплату средств может быть отклонена либо задержана, если есть подозрение на совершение Пользователем Обманных действий, либо подозрение в несанкционированном доступе к Аккаунту и счету третьих лиц.</td>
        </tr>
        <tr height="54" style='height:40.50pt;'>
          <td class="xl67" height="54" style='height:40.50pt;'>1.3.5. При выплате кэшбэка годовой накопительный итог не более 1800 евро не взимаются налоги страны проживания Пользователя. Пользователь обязан самостоятельно совершать действия по уплате налоговых обязательств.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>1.3.6 При выплате кэшбэка комиссию за обработку, взимаемую или списываемую с банковского счета получателя (пользователя), несет пользователь.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>1.3.7. «Администрация» имеет право в одностороннем порядке менять условия и сроки выплаты кэшбэка в любой момент.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>1.4. Реферальная программа</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>1.4.1. После регистрации на сайте, Пользователь получает индивидуальную реферальную ссылку для привлечения новых Пользователей с целью получения вознаграждения.</td>
        </tr>
        <tr height="72" style='height:54.00pt;'>
          <td class="xl67" height="72" style='height:54.00pt;'>1.4.2. Рекламные материалы, в том числе реферальную ссылку и баннеры, Пользователь вправе размещать на своем сайте или странице в социальных сетях, отправлять своим знакомым. Посетители, перешедшие по реферальной ссылке Пользователя, будут учтены как его рефералы.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>1.4.3. Вознаграждение за привлеченных рефералов производится согласно Программе лояльности «Кэшбэк система Интернет-Магазина» и выполнению её условий.</td>
        </tr>
        <tr height="54" style='height:40.50pt;'>
          <td class="xl67" height="54" style='height:40.50pt;'>1.4.4. Пользователю разрешено регистрировать мультиаккаунты по своей реферальной ссылке. Такие действия не будут расцениваться как Обманные, и не повлекут за собой блокировку всех мультиаккаунтов без выплаты денежных средств, находящихся на их балансах.</td>
        </tr>
        <tr height="72" style='height:54.00pt;'>
          <td class="xl67" height="72" style='height:54.00pt;'>1.4.5. Пользователю запрещено привлекать ранее зарегистрированных пользователей, имеющих аккаунт с регистрацией на сайте https://www.whieda.org/#/ в другой структуре. В случае выявления подобных действий Администрация вправе ограничить пользователя в доступе к Аккаунту без выплаты средств со счета Пользователя.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>1.4.6. Категорически запрещается привлекать рефералов посредством рассылки СПАМ сообщений, либо через контекстную рекламу.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>1.5. Ответственность сторон</td>
        </tr>
        <tr height="72" style='height:54.00pt;'>
          <td class="xl67" height="72" style='height:54.00pt;'>1.5.1. Пользователю запрещено привлекать ранее зарегистрированных пользователей, имеющих аккаунт с регистрацией на сайте https://www.whieda.org/#/ в другой структуре. В случае выявления подобных действий Администрация вправе ограничить пользователя в доступе к Аккаунту без выплаты средств со счета Пользователя.</td>
        </tr>
        <tr height="54" style='height:40.50pt;'>
          <td class="xl67" height="54" style='height:40.50pt;'>1.5.2. Пользователь несет личную ответственность за сохранность данных для доступа к своему Аккаунту (логин, пароль, е-mail и тому подобное). Запрещается предоставлять доступ к Аккаунту третьим лицам или выставлять их в открытом доступе на сторонних ресурсах.</td>
        </tr>
        <tr height="54" style='height:40.50pt;'>
          <td class="xl67" height="54" style='height:40.50pt;'>1.5.3. Пользователь обязан сообщить Администрации через службу технической поддержки, если у него возникли подозрения касательно несанкционированного доступа к Аккаунту третьими лицами.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>1.5.4. Администратор не несет ответственности за возможный ущерб, причиненный несанкционированным доступом к Аккаунту пользователя третьими лицами.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>1.5.5. Администратор не несет ответственность за бесперебойную работу сайта.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>1.5.6. Пользователь признает и соглашается, что конечный результат использования Программы лояльности может не соответствовать ожиданиям Пользователя.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>1.5.7. Администратор ни при каких обстоятельствах не несет ответственность за любой ущерб, полученный в связи с использованием сайта, либо невозможностью его использования.</td>
        </tr>
        <tr height="54" style='height:40.50pt;'>
          <td class="xl67" height="54" style='height:40.50pt;'>1.5.8. В случае обнаружения Обманных действий со стороны пользователя, Администратор вправе ограничить пользователя в доступе к Аккаунту, без выплаты средств со счета Пользователя.</td>
        </tr>
        <tr height="54" style='height:40.50pt;'>
          <td class="xl67" height="54" style='height:40.50pt;'>1.5.9. В случае действий со стороны пользователя, повлекшие за собой снижение (или потерю) деловой репутации компании, Администратор вправе ограничить пользователя в доступе к Аккаунту, без выплаты средств со счета Пользователя.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>1.6. Функционирование кэшбэк cервиса</td>
        </tr>
        <tr height="54" style='height:40.50pt;'>
          <td class="xl67" height="54" style='height:40.50pt;'>1.6.1. В виду возможных технических неполадок, плановых или внеплановых работ с программным обеспечение сайта, Администрация не гарантирует постоянный доступ Пользователя к данным Программы лояльности.</td>
        </tr>
        <tr height="72" style='height:54.00pt;'>
          <td class="xl67" height="72" style='height:54.00pt;'>1.6.2. Не исключается вероятность возникновения сбоев в работе системы в связи с злоумышленными действиями со стороны третьих лиц либо технических неполадок. В таких случаях Администрация оставляет за собой право приостановить работу сервиса до полного устранения технических неполадок либо угроз разного рода.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>1.6.3. Администрация обязуется выполнять все необходимые действия по обеспечению стабильной работы сайта.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>1.6.4. Администрация обязуется в кратчайшие сроки устранять все возникнувшие технические неполадки, влияющие на корректную работу сайта.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>1.7. Персональные данные</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>1.7.1. Регистрируясь на сайте, Пользователь дает свое согласие на использование и обработку сайтом<span style='mso-spacerun:yes;'>&nbsp; </span>своих персональных данных.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>1.7.2. Администратор гарантирует Пользователю использование его персональных данных исключительно в соответствии с законом о защите персональных данных.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>1.7.3. Администратор не передает персональные данные пользователя Партнерским магазинам, либо третьей стороне.</td>
        </tr>
        <tr height="54" style='height:40.50pt;'>
          <td class="xl67" height="54" style='height:40.50pt;'>1.7.4. В случае передачи Пользователем своих персональных данных через обращение в службу технической поддержки, такие данные не будут сохранены, и будут использоваться исключительно для решения поставленного Пользователем вопроса.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>1.8. E-MAIL рассылка</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>1.8.1. Регистрируясь на сайте, Пользователь дает согласие на получение писем от компании на электронную почту, указанную при регистрации.</td>
        </tr>
        <tr height="54" style='height:40.50pt;'>
          <td class="xl67" height="54" style='height:40.50pt;'>1.8.2. В случае необходимости отказа от писем, Пользователь может обратиться к Администрации через форму обратной связи с просьбой удалить Аккаунт либо изменить возможность получения писем в настройках Аккаунта Пользователя.</td>
        </tr>
        <tr height="40" style='height:30.00pt;'>
          <td class="xl66" height="40" style='height:30.00pt;'>2. ПОРЯДОК ОФОРМЛЕНИЯ ЗАКАЗОВ</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>2.1.Оформление заказа:</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>2.1.1. Выберите товар, который вы желаете приобрести. Нажмите «Добавить в корзину», товар автоматически добавится в корзину.</td>
        </tr>
        <tr height="54" style='height:40.50pt;'>
          <td class="xl67" height="54" style='height:40.50pt;'>2.1.2. После того как вы удостоверились, что список покупок в корзине верный, нажмите кнопку &quot;Оформить заказ&quot;. Введите информацию о Покупателе: Фамилию, Контактный телефон и Email. Выберите способ доставки.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>2.1.3. Наш менеджер свяжется с Вами для подтверждения заказа и даты его доставки.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>2.2. Оплата заказа</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>2.2.1. Способы оплаты заказа:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· Оплата наличными или картами VISA, MASTERCARD или PAYSERA при самовывозе.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· Оплата наличными или картами VISA, MASTERCARD или PAYSERA (при доставке по EC).</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· Оплата безналичным способом онлайн на сайте картами VISA, MASTERCARD или PAYSERA.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>2.2.2. Правила оплаты банковской картой</td>
        </tr>
        <tr height="72" style='height:54.00pt;'>
          <td class="xl67" height="72" style='height:54.00pt;'>2.2.2.1. Для оплаты товара банковской картой при оформлении заказа в интернет-магазине выберите способ оплаты: банковской картой. При оплате заказа банковской картой обработка платежа происходит на авторизационной странице банка, где Вам необходимо ввести данные Вашей банковской карты:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>1. тип карты</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>2. номер карты</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>3.срок действия карты (указан на лицевой стороне карты)</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>4.Имя держателя карты (латинскими буквами, точно также как указано на карте)</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>5. CVC2/CVV2 код</td>
        </tr>
        <tr height="72" style='height:54.00pt;'>
          <td class="xl67" height="72" style='height:54.00pt;'>Если Ваша карта подключена к услуге 3D-Secure, Вы будете автоматически переадресованы на страницу банка, выпустившего карту, для прохождения процедуры аутентификации. Информацию о правилах и методах дополнительной идентификации уточняйте в Банке, выдавшем Вам банковскую карту.</td>
        </tr>
        <tr height="54" style='height:40.50pt;'>
          <td class="xl67" height="54" style='height:40.50pt;'>Безопасность обработки интернет-платежей через платежный шлюз банка гарантирована международным сертификатом безопасности PCI DSS. Передача информации происходит с применением технологии шифрования TLS. Эта информация недоступна посторонним лицам.</td>
        </tr>
        <tr height="72" style='height:54.00pt;'>
          <td class="xl67" height="72" style='height:54.00pt;'>2.3. Товар приобретается пользователем для коммерческих целей, не связанных с личными, семейными, домашними и иными нуждами. Возврат товара надлежащего качества не допускается. Возврат товара ненадлежащего качества производится в порядке, установленном действующим законодательством государства, где приобретался товар.</td>
        </tr>
        <tr height="72" style='height:54.00pt;'>
          <td class="xl67" height="72" style='height:54.00pt;'>2.4. Запрещается перепродажа товаров на других маркетплейсах по цене, отличающейся от цены официального сайта. В случае возникновения подобных прецедентов, личные кабинеты «Пользователей» будут дезактивированы. При необходимости администрация оставляет за собой возможность решения данных ситуаций в судебном порядке.</td>
        </tr>
        <tr height="40" style='height:30.00pt;'>
          <td class="xl66" height="40" style='height:30.00pt;'>3.ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>3.1. Основные понятия</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>Персональные данные — любая информация, относящаяся к Пользователю. Пользователь — физическое лицо, использующее Сайт.</td>
        </tr>
        <tr height="54" style='height:40.50pt;'>
          <td class="xl67" height="54" style='height:40.50pt;'>Сайт — принадлежащая Администрации совокупность автоматизированных информационных систем и информации вне зависимости от формы ее представления, доступных в сети Интернет по сетевым адресам в следующих доменах (включая поддомены): https://www.whieda.org/#/.</td>
        </tr>
        <tr height="108" style='height:81.00pt;'>
          <td class="xl67" height="108" style='height:81.00pt;'>Обработка персональных данных — любое действие (операция) или совокупность действий (операций), совершаемых с использованием средств автоматизации или без использования таких средств с персональными данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (распространение, предоставление, доступ), обезличивание, блокирование, удаление, уничтожение персональных данных.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>Автоматизированная обработка персональных данных — обработка персональных данных с помощью средств вычислительной техники.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>Социальная сеть — сайт в информационно-телекоммуникационной сети Интернет, принадлежащий третьим Лицам, предназначенный для дистанционной коммуникации людей.</td>
        </tr>
        <tr height="54" style='height:40.50pt;'>
          <td class="xl67" height="54" style='height:40.50pt;'>Сервис  — продукты, услуги, объекты авторского права, предоставляемые Администрацией заинтересованным лицам для приобретения, использования через Сайт на условиях гражданско-правовых договоров.</td>
        </tr>
        <tr height="108" style='height:81.00pt;'>
          <td class="xl67" height="108" style='height:81.00pt;'>Личный кабинет  — персональный раздел Сайта и дополнительные функциональные возможности Сайта, к которым Пользователь получает доступ после прохождения регистрации и/или авторизации на Сайте. Личный кабинет предназначен для хранения персональных данных Пользователя, просмотра и управления доступными функциональными возможностями Сайта и соответствующими условиями использования Сайта, управления сделками, совершаемыми посредством Сайта.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>Пользовательское соглашение — гражданско-правовой договор на использование Сайта.</td>
        </tr>
        <tr height="72" style='height:54.00pt;'>
          <td class="xl67" height="72" style='height:54.00pt;'>Заказ — автоматически сформированный набор данных о действиях Пользователя, направленных на заключение гражданско-правового договора с Администрацией на использование Сервиса, включающий в себя информацию о выбранном Пользователем Сервисе, стоимости Сервиса, дате и времени формирования такого Заказа.</td>
        </tr>
        <tr height="90" style='height:67.50pt;'>
          <td class="xl67" height="90" style='height:67.50pt;'>Кассовый чек — первичный учетный документ, формируемый при проведении расчетов между Пользователем и Администрацией в связи с заключением, исполнением и прекращением договоров на использование Сервиса. Понятие расчётов используется в том значении, в котором оно определено в  законе «О применении контрольно-кассовой техники при осуществлении наличных денежных расчетов и (или) расчетов с использованием электронных средств платежа» .</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>Способ платежа — информация о банке, платежной системе, средстве платежа, применяемых Пользователем для оплаты Сервиса.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>3.2 Согласие на обработку персональных данных</td>
        </tr>
        <tr height="54" style='height:40.50pt;'>
          <td class="xl67" height="54" style='height:40.50pt;'>3.2.1 Пользователь принимает решение о предоставлении своих персональных данных Администрации, принимает условия Пользовательского Соглашения и дает согласие на обработку своих персональных свободно, своей волей и в своем интересе.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>3.2.1 Согласие Пользователя на обработку его персональных данным считается предоставленным Администрации, если оно направлено:</td>
        </tr>
        <tr height="54" style='height:40.50pt;'>
          <td class="xl67" height="54" style='height:40.50pt;'>a)  При регистрации на Сайте путём заполнения формы, доступной на Сайте после нажатия кнопки «Регистрация». Пользователь считается предоставившим согласие на обработку своих персональных в момент нажатия кнопки «Продолжить».</td>
        </tr>
        <tr height="126" style='height:94.50pt;'>
          <td class="xl67" height="126" style='height:94.50pt;'>b) При внесении или изменении персональных данных в разделе «Настройка профиля» в подразделах «Изменить контактную информацию», «Список контактов», «Пароль», «Пароль транзакций», «E-mail рассылка»— для персональных данных, которые Пользователь предоставляет при редактировании информации в Личном кабинете. Пользователь считается предоставившим согласие на обработку своих вновь внесенных или измененных персональных данных в момент нажатия кнопки «Сохранить», либо «Сменить», либо в момент нажатия кнопки интерфейса, явно обозначающей уточнение, изменение, удаление, исправление персональных данных.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>3.3. Персональные данные, обрабатываемые администрацией</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>3.3.1 Администрация обрабатывает следующие персональные данные Пользователей:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>a)  При регистрации Пользователя на Сайте:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· Имя;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· Фамилия;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· Адрес электронной почты;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· Телефон;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· Файлы куки.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>b) При направлении в адрес Администрации информационных сообщений, вопросов, отзывов:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·   Адрес электронной почты;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·   Имя;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·   Фамилия;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·   Номер телефона;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·   Файлы куки.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>c) При внесении или изменении персональных данных в разделе «Настройка профиля:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·   Имя;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·   Фамилия;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·   Адрес электронной почты;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·   Номер телефона;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·   Почтовый адрес;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·   Файлы куки.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>e) При оплате Сервиса зарегистрированным Пользователем:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· Адрес получения;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· Адрес электронной почты;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· Имя;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· Фамилия;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· Заказ;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· Дата, время и сумма исполненного Пользователем денежного обязательства;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· Размер и сроки исполнения неисполненного денежного обязательства Пользователя;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· Кассовый чек и данные Кассового чека;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· Способ платежа;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· Скидки и основания скидок, предоставленных Пользователю;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· Файлы куки.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>f) При регистрации на мероприятия, трансляции мероприятий, проводимых Администрацией:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·   Имя;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·   Фамилия;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·   Адрес электронной почты;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·   Файлы куки.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>g) При проведении Администрацией статистических и (или) исследовательских опросов:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·     Имя;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·     Возраст;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·     Профессия и (или) хобби;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·     Адрес электронной почты;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·     Файлы куки.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>h)  При получении консультационных услуг посредством телефонной связи: номер телефона, с которого совершает звонок Пользователь;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·   Имя;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·   Фамилия;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· Регистрационные данные Пользователя на Сайте;</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>· Иные анкетные данные, которые Пользователь сообщает Администрации своей волей и в своём интересе.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>i)  При сборе информации о Пользователе в целях демонстрации Пользователю персонализированных информационных и рекламных сообщений:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·  Идентификаторы куки-файлов;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·  Срок агента пользователя браузера;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·  Использование блокировщика рекламы;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·  Усечённый IP-адрес;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·  История просмотров;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·  Данные об интернет-посещении;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·  Занимаемая должность/трудовая функция;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· Данные о просматриваемых товарах, их цене, дате и времени просмотра;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· Псевдонимизированные адреса электронной почты;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· Геолокация</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· Технические данные о браузере, устройстве, настройках;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· О взаимодействии с рекламой (клики, отклонение, переходы и т.п)</td>
        </tr>
        <tr height="108" style='height:81.00pt;'>
          <td class="xl67" height="108" style='height:81.00pt;'>При сборе указанной информации она привязывается к уникальным идентификаторам, а именно к идентификаторам куки-файлов и другим походим технологиям и не позволяет идентифицировать Пользователя напрямую (анонимизация данных). Пользователь может отключить возможность сбора указанной информации в своём браузере способом, описанным изготовителем браузера Пользователя. Администратор вправе передавать информацию, получаемую в соответствии с настоящим пунктом третьим лицам.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>3.4. Цели обработки персональных данных</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>3.4.2. Администрация обрабатывает персональные данные Пользователей исключительно в следующих целях:</td>
        </tr>
        <tr height="72" style='height:54.00pt;'>
          <td class="xl67" height="72" style='height:54.00pt;'>a) При использовании Сайта Пользователем, как при регистрации Пользователя на Сайте, так и в отсутствие таковой, Администрация обрабатывает персональные данные Пользователя в целях исполнения договора на использование Сайта (Пользовательское соглашение). С этой целью Администрация обрабатывает персональные данные п. 3.3. Настоящего Соглашения.</td>
        </tr>
        <tr height="72" style='height:54.00pt;'>
          <td class="xl67" height="72" style='height:54.00pt;'>b) В целях исполнения Пользовательского соглашения при использовании функциональных возможностей Сайта Пользователем, связанных с добровольным внесением, изменением, уточнением, удалением Пользователем персональных данных. С этой целью Администрация обрабатывает персональные данные п. 3.3.1. Настоящего Соглашения.</td>
        </tr>
        <tr height="54" style='height:40.50pt;'>
          <td class="xl67" height="54" style='height:40.50pt;'>c) В целях заключения и исполнения договоров на использование Сервиса Пользователем без предварительной регистрации Пользователя на Сайте Администрация обрабатывает персональные данные п. 3.3.1. Настоящего Соглашения.</td>
        </tr>
        <tr height="108" style='height:81.00pt;'>
          <td class="xl67" height="108" style='height:81.00pt;'>d) В целях получения Пользователем от Администрации информации о функциональных возможностях Сайта, Сервисах, направления Пользователем Администрации информационных сообщений, вопросов, отзывов, получения консультаций и осуществлении иной информационной поддержки Пользователя, направленной на исполнение Пользовательского Соглашения, а также договоров на использование Сервиса, Администрация обрабатывает персональные данные, п. 3.3.1. Настоящего Соглашения.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>e) В целях исполнения заявки Пользователя на получение информационной рассылки Администрация обрабатывает персональные данные, п. 3.3.1. Настоящего Соглашения.</td>
        </tr>
        <tr height="54" style='height:40.50pt;'>
          <td class="xl67" height="54" style='height:40.50pt;'>f) В целях повышение качества Сервиса, улучшения Сайта, проведения статистических и иных исследований на основе обезличенной информации Пользователей, Администрация обрабатывает персональные данные, п. 3.3.1. Настоящего Соглашения.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>g) В целях заключения и исполнения договоров на использование Сервиса Администрация обрабатывает персональные данные, п. 3.3.1. Настоящего Соглашения.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>h) В целях исполнения договора между Пользователем и Администрацией на проведение конкурса, Администрация персональные данные, п. 3.3.1. Настоящего Соглашения.</td>
        </tr>
        <tr height="80" style='height:60.00pt;'>
          <td class="xl66" height="80" style='height:60.00pt;'>3.5. Условия обработки персональных данных</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>3.5.1. Администрация, основываясь на презумпции добросовестности Пользователя, исходит из того, что при предоставлении персональных данных на Сайте Пользователь:</td>
        </tr>
        <tr height="72" style='height:54.00pt;'>
          <td class="xl67" height="72" style='height:54.00pt;'>3.5.1.1. Является дееспособным лицом. В случае недееспособности такого лица согласие на обработку персональных данных предоставляется законным представителем Пользователя, ознакомившемся и согласным с условиями обработки персональных данных, указанными в настоящей Политике.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>3.5.1.2. Указывает достоверную информацию о себе в объемах, необходимых для использования Сайта, и поддерживает предоставленные персональные данные в актуальном состоянии.</td>
        </tr>
        <tr height="72" style='height:54.00pt;'>
          <td class="xl67" height="72" style='height:54.00pt;'>3.5.1.3. В случае загрузки своего изображения через Личный кабинет — на безвозмездной основе дает согласие на использование данного изображения в целях, не связанных с установлением личности Пользователя. Пользователь обязуется не предоставлять фотографии третьих лиц в качестве изображения Пользователя.</td>
        </tr>
        <tr height="54" style='height:40.50pt;'>
          <td class="xl67" height="54" style='height:40.50pt;'>3.5.1.4. Осознает, что информация на Сайте, размещаемая Пользователем о себе, может становиться доступной для других Пользователей Сайта, может быть скопирована и распространена такими Пользователями;</td>
        </tr>
        <tr height="108" style='height:81.00pt;'>
          <td class="xl67" height="108" style='height:81.00pt;'>3.5.1.5. Осознает, что функциональные возможности Сайта позволяют Пользователю самостоятельно установить публичный доступ (режим видимости) к части персональных данных другим Пользователям. Установление Пользователем публичного доступа к его персональным данным толкуется как раскрытие персональных данных Пользователем своей волей и в своих интересах. Пользователь гарантирует, что осознает последствия раскрытия им своих персональных данных другим Пользователям и не будет иметь претензий к Администрации.</td>
        </tr>
        <tr height="54" style='height:40.50pt;'>
          <td class="xl67" height="54" style='height:40.50pt;'>3.5.1.6. Осознает, что обработка некоторых персональных данных основывается на требованиях действующего законодательства, также обработка персональных данных необходима в целях исполнения договора с таким Пользователем.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>3.5.3. Уточнение, изменение персональных данных может осуществляться Пользователем самостоятельно с использованием Личного кабинета.</td>
        </tr>
        <tr height="54" style='height:40.50pt;'>
          <td class="xl67" height="54" style='height:40.50pt;'>3.5.4. Пользователь осведомлён, что он своими силами и в своём интересе должен самостоятельно проверять актуальность персональных данных и вносить необходимые уточнения, изменения в свои персональные данные в Личном кабинете.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>3.5.5. Распространение персональных данных может осуществляться исключительно в следующих случаях:</td>
        </tr>
        <tr height="54" style='height:40.50pt;'>
          <td class="xl67" height="54" style='height:40.50pt;'>3.5.5.1. На основании волеизъявления Пользователя, данного путём установления Пользователем публичного доступа (режим видимости) его персональных данных с целью отображение профиля Пользователя, части его персональных данных для иных Пользователей Сайта.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>3.5.6. Администрация вправе осуществлять передачу персональных данных третьим лицам в целях:</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>3.5.6.1. Привлечения третьих лиц к процессу исполнения договоров, заключенных между Пользователем и Администрацией, для повышения качества исполнения указанных договоров;</td>
        </tr>
        <tr height="90" style='height:67.50pt;'>
          <td class="xl67" height="90" style='height:67.50pt;'>3.5.7. Администрация вправе осуществлять передачу персональных данных третьим лицам при условии, если такие третьи лица, обеспечивают конфиденциальность персональных данных при их обработке, соблюдают меры по обеспечению безопасности персональных данных. Третьему лицу запрещено осуществлять передачу и распространение персональных данных Пользователей.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>3.5.8. Прекращение обработки персональных данных Пользователя, блокировка и уничтожение персональных данных осуществляется в следующих случаях:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>a)  удаление Пользователем персональных данных в Личном кабинете;</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>b) получение Администрацией от Пользователя отзыва согласия на обработку персональных данных;</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>c) получение Администрацией от Пользователя требования об уничтожении или блокировке персональных данных;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>d)  истечение срока действия согласия Пользователя на обработку его персональных данных.</td>
        </tr>
        <tr height="234" style='height:175.50pt;'>
          <td class="xl67" height="234" style='height:175.50pt;'>3.5.9. Администрация принимает необходимые и достаточные правовые, организационные и технические меры для защиты персональных данных от неправомерного или случайного доступа, уничтожения, изменения, блокирования, копирования, распространения, а также от иных неправомерных действий третьих лиц, направленных в отношении персональных данных. В частности, Администрация применяет организационные и технические меры по обеспечению безопасности персональных данных при их обработке, контроль фактов несанкционированного доступа к персональным данным и принятие мер по недопущению подобных инцидентов в дальнейшем, контроль за принимаемыми мерами по обеспечению безопасности персональных данных и уровнем защищенности персональных данных. Для авторизации доступа к Личному кабинету Пользователь использует логин (адрес электронной почты) и пароль Пользователя. Ответственность за сохранность данной информации несет Пользователь. Пользователь не вправе передавать собственный логин и пароль третьим лицам, а также обязан предпринимать меры по обеспечению их конфиденциальности.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>3.6.Пользователь вправе:</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>3.6.1. По своему усмотрению, своей волей и в своём интересе предоставлять Администрации персональные данные для их обработки на условиях, указанных в настоящем Соглашении;</td>
        </tr>
        <tr height="54" style='height:40.50pt;'>
          <td class="xl67" height="54" style='height:40.50pt;'>3.6.2. Самостоятельно предоставлять, изменять и удалять персональные данные в Личном кабинете при условии, что такие изменения и исправления содержат актуальную и достоверную информацию;</td>
        </tr>
        <tr height="54" style='height:40.50pt;'>
          <td class="xl67" height="54" style='height:40.50pt;'>3.6.3. Обращаться к Администрации с требованиями, в том числе об уничтожении персональных данных, отзыве согласия на обработку, блокировке персональных данных. Требование предъявляется в порядке, предусмотренном в п. 3.6.2. настоящего Соглашения.</td>
        </tr>
        <tr height="54" style='height:40.50pt;'>
          <td class="xl67" height="54" style='height:40.50pt;'>3.6.4. Самостоятельно удалять Личный кабинет или обращаться с требованием к Администрации об удалении Личного кабинета силами Администрации в порядке, предусмотренном в п. 3.6.2. настоящего Соглашения;</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>3.6.5. Самостоятельно устанавливать режим публичного доступа (режим видимости) части персональных данных, отменять такой режим.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>3.6.6. Пользователь вправе направлять Администрации свои требования и запросы следующими способами:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>3.6.7. В письменной форме по почтовому адресу Администрации, указанному на Сайте;</td>
        </tr>
        <tr height="54" style='height:40.50pt;'>
          <td class="xl67" height="54" style='height:40.50pt;'>3.6.8. Документ должен быть направлен с адреса электронной почты Пользователя, указанного им при регистрации на Сайте или в договоре на использование Сервиса, по адресу электронной почты Администрации eu-info@foherb.com.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>3.6.9. Направляемые Пользователем требования и запросы должны содержать следующую информацию:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>А) Фамилия, имя, отчество Пользователя;</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl67" height="36" style='height:27.00pt;'>Б) Регистрационные данные Пользователя на Сайте (если Пользователь зарегистрирован на момент направления требования или запроса);</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>В) суть требования или запроса Пользователя;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>Г) подпись Пользователя.</td>
        </tr>
        <tr height="126" style='height:94.50pt;'>
          <td class="xl67" height="126" style='height:94.50pt;'>3.6.10 Администрация рассматривает полученные от Пользователя требования и запросы на предмет наличия обязательных реквизитов, обоснованности требования или обращения. В случае обоснованности требования Пользователя Администрация удовлетворяет его в течение 30 дней с даты поступления. В любом случае Администрация направляет ответ Пользователю в срок, не превышающий 30 дней с даты поступления требования или обращения. Ответ направляется Пользователю в форме, соответствующей форме требования или обращения Пользователя.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>3.7. Изменение Политики</td>
        </tr>
        <tr height="54" style='height:40.50pt;'>
          <td class="xl67" height="54" style='height:40.50pt;'>3.7.1. Администрация оставляет за собой право вносить изменения в Пользовательское Соглашение. На Пользователе лежит обязанность при каждом использовании Сайта ознакомиться с текстом Пользовательского Соглашения.</td>
        </tr>
        <tr height="108" style='height:81.00pt;'>
          <td class="xl67" height="108" style='height:81.00pt;'>3.7.2. Новая редакция Пользовательского Соглашения вступает в силу с момента ее размещения в соответствующем разделе Сайта. Продолжение пользования Сайтом или его сервисами после публикации новой редакции Пользовательского Соглашения означает принятие Пользовательского Соглашения и его условий Пользователем. В случае несогласия с условиями Пользовательского Соглашения Пользователь должен незамедлительно прекратить использование Сайта.</td>
        </tr>
      </table>
    </div>
    <div class="chinese" v-show="this.language=='ka_GE'">
      <table width="645" border="0" cellpadding="0" cellspacing="0" style='width:483.75pt;border-collapse:collapse;table-layout:fixed;'>
        <col width="645" class="xl65" style='mso-width-source:userset;mso-width-alt:20640;'/>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl66" height="36" width="645" style='height:27.00pt;width:483.75pt;'>მომხმარებლის ხელშეკრულება </td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>ეს მომხმარებლის ხელშეკრულება არეგულირებს ურთიერთობას მფლობელს (შემდგომში ადმინისტრაცია და (ან) KORDICEPSAS) ერთი მხრივ და მომხმარებელს შორის.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl68" height="18" style='height:13.50pt;'>საიტის გამოყენებით, მომხმარებელი ეთანხმება ამ შეთანხმების პირობებს, რომლებიც მოცემულია ქვემოთ.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>ადმინისტრაციას აქვს უფლება ცალმხრივად შეცვალოს ეს ხელშეკრულება ნებისმიერ დროს და გაფრთხილების გარეშე.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>აკრძალულია საიტიდან მასალების კოპირება, გადაბეჭდვა და სხვა სახის გამოყენება ადმინისტრაციასთან წინასწარი შეთანხმების გარეშე.</td>
        </tr>
        <tr height="36" style='height:27.00pt;'>
          <td class="xl66" height="36" style='height:27.00pt;'>ხელშეკრულების შინაარსი:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1. <font class="font3">ლოიალობის პროგრამის პირობები.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>2. <font class="font3">შეკვეთების გაფორმების წესი.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3. <font class="font3">პერსონალური მონაცემების დამუშავების პოლიტიკა</font></td>
        </tr>
        <tr height="37" style='height:27.75pt;'>
          <td class="xl70" height="37" style='height:27.75pt;'>1.<font class="font2">ლოიალობის პროგრამის პირობები</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>ტერმინები და განმარტებები</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>ამ ვებგვერდზე გამოყენებული ტერმინებისა, განმარტებების და აღნიშვნების სია </td>
        </tr>
        <tr height="32" style='height:24.00pt;'>
          <td class="xl67" height="32" style='height:24.00pt;'>ლოიალობის პროგრამა არის უფასო ელექტრონული სერვისი ინტერნეტში, რომელიც მდებარეობს https://www.eu.whieda.org/#/, რომელიც მომხმარებლებს სთავაზობს სერვისებს, რომლებიც საშუალებას აძლევს მათ დიაბრუნონ ონლაინ მაღაზიაში შესყიდვებზე დახარჯული თანხის ნაწილი.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>მომხმარებელი <font class="font1"> - </font><font class="font3">ონლაინ მაღაზიის ვიზიტორი, ფიზიკური პირი. რომელიც საიტზეა რეგისტრირებული</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>Cashback (ქეშბეკი)<font class="font1"> - </font><font class="font3">ონლაინ მაღაზიაში შესყიდვებზე დახარჯული თანხის ნაწილის დაბრუნება.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>(Account) ანგარიში<font class="font1"> - </font><font class="font3">მომხმარებლის ანგარიში, რომელიც იძლევა წვდომას ონლაინ მაღაზიის ყველა ფუნქციაზე, მათ შორის შიდა ანგარიშზე, რომელზეც ირიცხება ქეშბექი (Cashback)</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>ადმინისტრაცია<font class="font1"> - </font><font class="font3">ონლაინ მაღაზიის თანამშრომლები, რომლებსაც უფლება აქვთ შეასრულონ ნებისმიერი ოპერაცია მომხმარებლის ანგარიშში ამ შეთავაზების შესაბამისად.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>შიდა ანგარიში<font class="font1"> - </font><font class="font3">ონლაინ მაღაზიის მომხმარებლის ანგარიში, რომელიც აფიქსირებს დარიცხულ ქეშბექს და მის სტატუსს.</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl67" height="33" style='height:24.75pt;'>სარეკლამო მასალები<font class="font1">——</font><font class="font3">ბანერები, რეფერალური ბმული და სხვა ინსტრუმენტები ახალი მომხმარებლების მოსაზიდად, რეგისტრირებული და რეგისტრირებული რეფერალების აქტიური ქმედებებისთვის (შესყიდვებისთვის) ჯილდოს მიღების შესაძლებლობით.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>თაღლითური ქმედება არის ნებისმიერი სახის თაღლითობა, რომლის მიზანია ქეშბექის უკანონოდ მოპოვება.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>სპამი<font class="font1"> - </font><font class="font3">სარეკლამო ხასიათის ინფორმაციის ან სხვა სახის შეტყობინებების მასობრივი გაგზავნა მიმღებთა სურვილის გათვალისწინების გარეშე.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.1. <font class="font3">საერთო, ზოგადი დებულებები</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.1.1. <font class="font3">საიტზე დარეგისტრირებით მომხმარებელი ადასტურებს, რომ:</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>a) <font class="font3">მომხმარებელი არის მინიმუმ </font><font class="font1"> 18 </font><font class="font3">წლის;</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>b) <font class="font3"> მომხმარებელი არის ქმედუნარიანი, ქმედუნარიანი მისი სახელმწიფოს კანონმდებლობის შესაბამისად;</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>c) <font class="font3">მომხმარებელი იღებს ვალდებულებას არ დაუშვას</font><font class="font1">18</font><font class="font3">წლამდე ასაკის პირებს ლოიალობის პროგრამით სარგებლობა；</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>d) <font class="font3">მომხმარებელი იღებს ვალდებულებას, არ დაუშვას ქმედუუნარო, არაკომპეტენტურ პირების მიერ ლოიალობის პროგრამით სარგებლობის უფლება და პირადად არის პასუხისმგებელი, რომ არ დაუშვას ასეთ ადამიანებს ლოიალობის პროგრამით სარგებლობა;</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>e) <font class="font3">ანგარიში გამოყენებული იქნება მხოლოდ ანგარიშის მფლობელის სახელით შესყიდვების განსახორციელებლად;</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>f) <font class="font3">მომხმარებელი ადასტურებს, რომ მას აცნობეს და თანახმაა შეიცვალოს ამ შეთავაზების შინაარსი, ადმინისტრაციის მიერ, საჭიროების შემთხვევაში;
          </font><font class="font1"> - </font><font class="font3">მომხმარებელი ადასტურებს, რომ წაიკითხა ეს შეთავაზება და უპირობოდ ეთანხმება მის პირობებს;</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>g) <font class="font3">მომხმარებელი ადასტურებს, რომ მისთვის სრულიად გასაგებია მისი ყველა უფლება და მოვალეობა.</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.1.2. <font class="font3">ადმინისტრატორი მომხმარებელს უხდის ქეშბექს ლოიალობის პროგრამის ფარგლებში, რომელიც ყალიბდება ლოიალობის პროგრამის „ონლაინ მაღაზიის ქეშბექი სისტემის“ ბონუსებიდან გარკვეული ოდენობით, ყველა წესისა და რეკომენდაციის დაცვით და იმ პირობით,
            რომ საქონელი არ დაუბრუნდა გამყიდველს (სრულად ან ნაწილობრივ), ან უარი თქვა მომსახურებაზე</font></td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>1.1.3. <font class="font3">ქეშბექი მიიღება ხდება შეკვეთის დადასტურებისთანავე ლოიალობის პროგრამაში მონაწილეობისას.
            როგორც წესი, ეს ხდება 1 წუთში, მაგრამ ზოგიერთ შემთხვევაში, სახსრების  ჩარიცხვის ვადა შეიძლება გაგრძელდეს 24 საათამდე.</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.1.4. <font class="font3">სისტემის გაუმართაობის დროს, გადახდის ოპერაციის განხორციელებაზე უარის თქმის შემთხვევაში, ქეშბექი არ ჩაირიცხება. ასეთ შემთხვევებში, თქვენ უნდა დაუკავშირდეთ კომპანიას და დარეკოთ ცხელ ხაზზე.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.2. <font class="font3">ქეშბექის-ის (CASHBACK) დარიცხვის წესები</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.2.1. <font class="font3">ქეშბექის დასარიცხად მომხმარებელი უნდა იყოს დარეგისტრირებული და ავტორიზებული საიტზე, მონაწილეობა მიიღოს ლოიალობის პროგრამაში და შეასრულოს მისი პირობები.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.3. <font class="font3">ქეშბექის (CASHBACK) გადახდები</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.3.1. <font class="font3">მომხმარებელს შეუძლია დატოვოს მოთხოვნა ქეშბექის განაღდებაზე მას შემდეგ, რაც ანგარიშზე არსებული თანხა მიაღწევს განაღდების მინიმალურ ზღვარს.
            ინფორმაცია ნაღდი ფულის გამოტანის მეთოდების შესახებ, ისევე როგორც მინიმალური თანხის განაღდება, ხელმისაწვდომია მომხმარებლის ანგარიშში.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.3.2. <font class="font3">მინიმალური ერთჯერადი განაღდების თანხა არის მინიმუმ 150 ევრო.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.3.3. <font class="font3">გადახდის მოთხოვნა განიხილება 24 საათის განმავლობაში. მაქსიმალური ვადა 72 საათია.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.3.4. <font class="font3">თანხების გადახდის მოთხოვნა შეიძლება უარყოფილ იქნას ან შეჩერდეს, თუ არსებობს მომხმარებლის თაღლითური ქმედების ეჭვი, ან მესამე მხარის ანგარიშზე  არასანქციონირებული წვდომის ეჭვი.</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.3.5. <font class="font3">ქეშბექის გადახდისას, წლიური კუმულაციური (საერთო) ჯამი, რომელიც არ აღემატება 1800 ევროს, არ აწესებს გადასახადებს მომხმარებლის საცხოვრებელი ქვეყნიდან. მომხმარებელი ვალდებულია დამოუკიდებლად განახორციელოს ქმედებები საგადასახადო ვალდებულებების გადასახდელად.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.3.6. <font class="font3">ქეშბექის გადახდისას, მიმღების (მომხმარებლის) საბანკო ანგარიშიდან ჩამოწერილი, დარიცხული ან ჩარიცხული თანხის დამუშავების საფასური ეკისრება მომხმარებელს.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.3.7. “<font class="font3"> „ადმინისტრაციას“ უფლება აქვს ნებისმიერ დროს ცალმხრივად შეცვალოს ქეშბექ-ის გადახდის პირობები.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.4. <font class="font3">რეფერალური (რეკომენდაციის) პროგრამა</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.4.1. <font class="font3">ვებგვერდზე დარეგისტრირების შემდეგ, მომხმარებელი იღებს პერსონალიზებულ რეფერალურ ბმულს, რათა მოიზიდოს ახალი მომხმარებლები ჯილდოს მისაღებად.</font></td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>1.4.2. <font class="font3">სარეკლამო მასალები, მათ შორის რეფერალური (რეკომენდაციის) ბმული და ბანერები, მომხმარებელს უფლება აქვს განათავსოს საკუთარ ვებსაიტზე ან გვერდზე სოციალურ ქსელებში, გაუგზავნოს მეგობრებს. ვიზიტორები,
            რომლებიც მიჰყვებიან მომხმარებლის რეფერალურ (რეკომენდაციის) ბმულს, ჩაითვლებიან მის რეფერალებად (რეკომენდირებულად).</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.4.3. <font class="font3">მოზიდული რეფერალებისთვის (რეკომენდირებულებისათვის) ჯილდო ხდება ლოიალობის პროგრამის „ონლაინ მაღაზიის ქეშბექი სისტემის“ და მისი პირობების შესრულების შესაბამისად.</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.4.4. <font class="font3">მომხმარებელს უფლება აქვს დაარეგისტრიროს მრავალ ანგარიშები მისი რეფერალური ბმულის გამოყენებით. ასეთი ქმედებები არ ჩაითვლება თაღლითობად და არ გამოიწვევს ყველა ანგარიშის (აკაუნტის) დაბლოკვას და მათ ბალანსზე არსებული თანხების არგადახდას.</font></td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>1.4.5. <font class="font26">მომხმარებელს ეკრძალება ადრე დარეგისტრირებული მომხმარებლების მოწვევა, რომლებსაც უკვე აქვთ ანგარიში რეგისტრირებული საიტზე http://eu.whieda.org/#/ ან https://www.whieda.org/#/ სხვა სტრუქტურაში. ასეთი ქმედებების აღმოჩენის შემთხვევაში ადმინისტრაციას უფლება აქვს შეუზღუდოს მომხმარებელს წვდომა ანგარიშზე და მომხმარებლის ბალანსზე არსებული თანხების არგადახდას.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.4.6. <font class="font3">კატეგორიულად აკრძალულია რეფერალების მოზიდვა SPAM შეტყობინებების გაგზავნით, ან კონტექსტური რეკლამით.。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.5. <font class="font3"> მხარეთა პასუხისმგებლობა</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.5.1. <font class="font3">მომხმარებელს ეკრძალება ადრე უკვე  დარეგისტრირებული მომხმარებლების მოზიდვა, რომლებსაც აქვთ ანგარიში რეგისტრირებული საიტზე https://www.whieda.org/#/ ან http://eu.whieda.org/#/ სხვა სტრუქტურაში. ასეთი ქმედებების აღმოჩენის შემთხვევაში ადმინისტრაციას
            უფლება აქვს შეზღუდოს მომხმარებლის წვდომა ანგარიშზე მომხმარებლის ანგარიშზე არსებული თანხის გადახდის გარეშე.</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.5.2. <font class="font3">მომხმარებელი პირადად არის პასუხისმგებელი მის ანგარიშზე წვდომის მონაცემების უსაფრთხოებაზე (შესვლა, პაროლი, ელ. ფოსტა და ა.შ.)
            . აკრძალულია ანგარიშზე წვდომის გადაცემა მესამე მხარისთვის ან მათი საჯაროდ გამოქვეყნება მესამე მხარის რესურსებზე.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.5.3. <font class="font3">მომხმარებელი ვალდებულია აცნობოს ადმინისტრაციას ტექნიკური მხარდაჭერის სერვისის მეშვეობით,
            თუ მას აქვს რაიმე ეჭვი მესამე მხარის მიერ ანგარიშზე არაავტორიზებული წვდომის შესახებ.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.5.4. <font class="font3">ადმინისტრატორი არ არის პასუხისმგებელი მესამე მხარის მიერ მომხმარებლის ანგარიშზე არაავტორიზებული წვდომით გამოწვეული შესაძლო ზიანის.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.5.5.<span style='mso-spacerun:yes;'>&nbsp; </span><font class="font3">ადმინისტრატორი არ არის პასუხისმგებელი საიტის გამართულ მუშაობაზე.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.5.6. <font class="font3">მომხმარებელი აღიარებს და ეთანხმება, რომ ლოიალობის პროგრამის გამოყენების საბოლოო შედეგი შეიძლება არ აკმაყოფილებდეს მომხმარებლის მოლოდინებს.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.5.7. <font class="font3">მომხმარებელი აღიარებს და ეთანხმება, რომ ლოიალობის პროგრამის გამოყენების საბოლოო შედეგი შეიძლება არ შეესაბამებიდეს მომხმარებლის მოლოდინებს.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.5.8.<span style='mso-spacerun:yes;'>&nbsp; </span><font class="font3">მომხმარებლის მხრიდან თაღლითური ქმედებების გამოვლენის შემთხვევაში, ადმინისტრატორს უფლება აქვს შეზღუდოს მომხმარებლის წვდომა ანგარიშზე, მომხმარებლის ანგარიშიდან თანხის გადახდის გარეშე.</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.5.9. <font class="font3">მომხმარებლის მხრიდან ქმედებების შემთხვევაში, რაც გამოიწვევს კომპანიის საქმიანი რეპუტაციის შემცირებას (ან დაკარგვას), ადმინისტრატორს უფლება აქვს შეზღუდოს მომხმარებლის წვდომა ანგარიშზე, მომხმარებლის ანგარიშიდან თანხის გადახდის გარეშე.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.6. <font class="font3">ქეშბექ სერვისის ფუნქციონირება</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.6.1. <font class="font3">შესაძლო ტექნიკური პრობლემების, საიტის პროგრამულ უზრუნველყოფასთან დაგეგმილი ან დაუგეგმავი მუშაობის გათვალისწინებით, ადმინისტრაცია არ იძლევა გარანტიას მომხმარებლის მუდმივ წვდომაზე ლოიალობის პროგრამის მონაცემებზე.</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.6.2. <font class="font3"> არ არის გამორიცხული მესამე მხარის მავნე ქმედებების ან ტექნიკური პრობლემების გამო სისტემის გაუმართაობის შესაძლებლობა. ასეთ შემთხვევაში ადმინისტრაცია იტოვებს უფლებას შეაჩეროს მომსახურება ტექნიკური პრობლემების ან სხვადასხვა სახის საფრთხეების სრულ აღმოფხვრამდე.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.6.3. <font class="font3">ადმინისტრაცია იღებს ვალდებულებას განახორციელოს ყველა საჭირო ქმედება საიტის სტაბილურად მუშაობის უზრუნველსაყოფად.。</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.6.4. <font class="font3">ადმინისტრაცია იღებს ვალდებულებას, დროულად აღმოფხვრას ყველა ტექნიკური პრობლემა, რომელიც წარმოიშვა, რაც გავლენას ახდენს საიტის სწორ მუშაობაზე.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.7. <font class="font3"> პერსონალური ინფორმაცია</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.7.1. <font class="font3">საიტზე დარეგისტრირებით მომხმარებელი თანახმაა საიტის მიერ მისი პირადი მონაცემების გამოყენებასა და დამუშავებაზე.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.7.2. <font class="font3">ადმინისტრატორი გარანტიას აძლევს მომხმარებელს მისი პერსონალური მონაცემების გამოყენებაში მხოლოდ პერსონალური მონაცემების დაცვის შესახებ კანონის შესაბამისად.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.7.3. <font class="font3">ადმინისტრატორი არ გადასცემს მომხმარებლის პერსონალურ მონაცემებს პარტნიორ მაღაზიებში ან მესამე მხარეს.</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.7.4. <font class="font3">იმ შემთხვევაში, თუ მომხმარებელი გადასცემს თავის პერსონალურ მონაცემებს ტექნიკური დახმარების სერვისთან დაკავშირების გზით, ასეთი მონაცემები არ შეინახება და გამოყენებული იქნება მხოლოდ მომხმარებლის მიერ წამოჭრილი პრობლემის გადასაჭრელად.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.8. <font class="font3"> E-MAIL ელექტრონული ფოსტით შეტყობინებების გაგზავნა</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.8.1. <font class="font3"> საიტზე დარეგისტრირებით მომხმარებელი თანახმაა მიიღოს კომპანიისგან წერილები რეგისტრაციისას მითითებულ ელ.ფოსტაზე.</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>1.8.2. <font class="font3">წერილებზე უარის თქმის აუცილებლობის შემთხვევაში, მომხმარებელს შეუძლია დაუკავშირდეს ადმინისტრაციას გამოხმაურების ფორმის საშუალებით, ანგარიშის წაშლის თხოვნით ან წერილების მიღების შესაძლებლობისთვის მომხმარებლის
            ანგარიშის პარამეტრებში შესაძლო ცვლილებების შესატანად..</font></td>
        </tr>
        <tr height="37" style='height:27.75pt;'>
          <td class="xl70" height="37" style='height:27.75pt;'>2. <font class="font2">შეკვეთის გაფორმების პროცედურა</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>2.1.<font class="font3">შეკვეთის გაფორმება:</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>2.1.1. <font class="font3">აირჩიეთ საქონელი, რომლის შეძენაც გსურთ. დააწკაპუნეთ (დააჭირეთ ღილაკს) "კალათაში დამატება", პროდუქტი ავტომატურად დაემატება თქვენს კალათას.</font></td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>2.1.2. <font class="font3">მას შემდეგ რაც დარწმუნდებით, რომ კალათაში შესყიდვების ჩამონათვალი სწორია, დააჭირეთ ღილაკს "შეკვეთის გაფორმება".
            შეიყვანეთ ინფორმაცია მყიდველის შესახებ: გვარი, საკონტაქტო ტელეფონის ნომერი და ელ.ფოსტა. აირჩიეთ გადაზიდვის მეთოდი.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>2.1.3. <font class="font3">ჩვენი მენეჯერი დაგიკავშირდებათ შეკვეთისა და მიწოდების თარიღის დასადასტურებლად.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>2.2. <font class="font3">შეკვეთის გადახდა</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>2.2.1. <font class="font3">შეკვეთის გადახდის მეთოდები:</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>a) <font class="font3">VISA, MASTERCARD ან PAYSERA ბარათებით  ან ნაღდი ანგარიშსწორებით თვითგატანის შემთხვევაში</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· <font class="font3">გადახდა ნაღდი ანგარიშსწორებით ან VISA, MASTERCARD ან PAYSERA ბარათებით (ევროკავშირის ფარგლებში მიწოდებისას).</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· <font class="font3">გადახდა საბანკო გადარიცხვით ონლაინ ვებგვერდზე VISA, MASTERCARD ან PAYSERA ბარათებით.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>2.2.2. <font class="font3">საბანკო ბარათით გადახდის წესები</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>2.2.2.1. <font class="font3">საქონლის საბანკო ბარათით გადასახდელად, ონლაინ მაღაზიაში შეკვეთის განთავსებისას აირჩიეთ გადახდის მეთოდი: საბანკო ბარათით. საბანკო ბარათით შეკვეთის გადახდისას, გადახდის დამუშავება ხდება ბანკის ავტორიზაციის გვერდზე, სადაც უნდა შეიყვანოთ თქვენი საბანკო ბარათის დეტალები:</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>1.<font class="font3"> საბანკო ბარათის ტიპი</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>2.<font class="font3"> საბანკო ბარათის ნომერი</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.<font class="font3"> საბანკო ბარათის მოქმედების ვადა (მითითებულია ბარათის წინა მხარეს)</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>4. <font class="font3">ბარათის მფლობელის დასახელება (ლათინური ასოებით, ზუსტად ისე, როგორც ბარათზეა მითითებული)</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>5.CVC2/CVV2 კოდი</td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl67" height="33" style='height:24.75pt;'>თუ თქვენი ბარათი დაკავშირებულია 3D-Secure სერვისთან, თქვენ ავტომატურად გადამისამართდებით ბანკის გვერდზე, რომელმაც ბარათი გასცა,
            რათა გაიაროთ ავტორიზაციის პროცედურა. დამატებითი იდენტიფიკაციის წესებისა და მეთოდების შესახებ ინფორმაციისთვის მიმართეთ ბანკს, რომელმაც გასცა თქვენი საბანკო ბარათი.</td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl67" height="33" style='height:24.75pt;'>ბანკის გადახდის კარიბჭის მეშვეობით ინტერნეტ გადახდების დამუშავების უსაფრთხოება გარანტირებულია PCI DSS უსაფრთხოების საერთაშორისო სერტიფიკატით. ინფორმაცია გადაიცემა TLS დაშიფვრის ტექნოლოგიის გამოყენებით. ეს ინფორმაცია არ არის ხელმისაწვდომი მესამე მხარისთვის.</td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>2.3. <font class="font3">მომხმარებელი ყიდულობს პროდუქტს კომერციული მიზნებისთვის, რომელიც არ არის დაკავშირებული პირად, ოჯახურ, საყოფაცხოვრებო ან სხვა საჭიროებებთან. კარგი ხარისხის საქონელზე დაბრუნება დაუშვებელია.
            შეუსაბამო ხარისხის საქონლის დაბრუნება ხორციელდება იმ ქვეყნის სამართლებრივი აქტებით დადგენილი წესით, სადაც შეძენილია საქონელი.</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>2.4. <font class="font3">აკრძალულია საქონლის გადაყიდვა სხვა ბაზრებზე ოფიციალური ვებგვერდის ფასისგან განსხვავებული ფასით. ასეთი პრეცედენტების შემთხვევაში „მომხმარებლების“ პირადი ანგარიშები გაუქმდება. საჭიროების შემთხვევაში, ადმინისტრაცია იტოვებს შესაძლებლობას ამ სიტუაციების სასამართლოში გადაჭრა.</font><font class="font3">
            如有必要，政府保留在法庭上解决这些情况的可能性。</font></td>
        </tr>
        <tr height="37" style='height:27.75pt;'>
          <td class="xl70" height="37" style='height:27.75pt;'>3.<font class="font2">კონფიდენციალურობის პოლიტიკა</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.1. <font class="font3">საბაზისო ცნებები</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>პერსონალური მონაცემები - ნებისმიერი ინფორმაცია, რომელიც ეხება მომხმარებელს. მომხმარებელი - ფიზიკური პირი, რომელიც იყენებს საიტს.</td>
        </tr>
        <tr height="32" style='height:24.00pt;'>
          <td class="xl67" height="32" style='height:24.00pt;'>საიტი - ავტომატური საინფორმაციო სისტემებისა და ინფორმაციის ნაკრები, რომელიც ეკუთვნის ადმინისტრაციას, მიუხედავად მისი პრეზენტაციის ფორმისა, ხელმისაწვდომია ინტერნეტში ქსელის მისამართებზე შემდეგ დომენებში (მათ შორის ქვედომეინებში): http://eu.whieda.org/#/ ან https://www.whieda.org/# </td>
        </tr>
        <tr height="49" style='height:36.75pt;'>
          <td class="xl67" height="49" style='height:36.75pt;'>პერსონალური მონაცემების დამუშავება - ნებისმიერი ქმედება (ოპერაცია) ან მოქმედებების (ოპერაციების) ნაკრები, რომელიც შესრულებულია ავტომატიზაციის ხელსაწყოების გამოყენებით ან პერსონალური მონაცემებით ასეთი ხელსაწყოების გამოყენების გარეშე, მათ შორის შეგროვება, ჩაწერა, სისტემატიზაცია, დაგროვება, შენახვა, განმარტება (განახლება). , შეცვლა), მოპოვება, გამოყენება, გადაცემა (გავრცელება
            , უზრუნველყოფა, წვდომა), დეპერსონალიზაცია, დაბლოკვა, წაშლა, პერსონალური მონაცემების განადგურება.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>პერსონალური მონაცემების ავტომატური დამუშავება - პერსონალური მონაცემების დამუშავება კომპიუტერული ტექნოლოგიების დახმარებით.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>სოციალური ქსელი - საიტი საინფორმაციო და სატელეკომუნიკაციო ქსელში ინტერნეტში, რომელიც ეკუთვნის მესამე პირებს, რომელიც განკუთვნილია ადამიანების დისტანციური კომუნიკაციისთვის.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>სერვისი - პროდუქტები, მომსახურება, საავტორო უფლებების ობიექტები, რომლებიც უზრუნველყოფილია
            ადმინისტრაციის მიერ დაინტერესებულ მხარეებზე შესაძენად, გამოყენება საიტის მეშვეობით სამოქალაქო სამართლის ხელშეკრულებების პირობებით.</td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl67" height="33" style='height:24.75pt;'>პირადი ანგარიში - საიტის პირადი განყოფილება და საიტის დამატებითი ფუნქციონირება, რომელზედაც მომხმარებელი იღებს წვდომას საიტზე რეგისტრაციის ან/და ავტორიზაციის შემდეგ. პერსონალური ანგარიში შექმნილია მომხმარებლის პერსონალური მონაცემების შესანახად,
            საიტის ხელმისაწვდომი ფუნქციონირებისა და საიტის გამოყენების შესაბამისი პირობების სანახავად და მართვისთვის, საიტის მეშვეობით განხორციელებული ტრანზაქციების სამართავად.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>მომხმარებლის შეთანხმება - სამოქალაქო სამართლის ხელშეკრულება საიტის გამოყენების შესახებ.</td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl67" height="33" style='height:24.75pt;'>შეკვეთა - ავტომატურად გენერირებული მონაცემთა ნაკრები მომხმარებლის ქმედებების შესახებ, რომელიც მიზნად ისახავს ადმინისტრაციასთან სამოქალაქო სამართლის ხელშეკრულების დადებას სერვისით
            სარგებლობის შესახებ, მომხმარებლის მიერ შერჩეული სერვისის შესახებ ინფორმაციის ჩათვლით, მომსახურების ღირებულება, თარიღი და დრო. ასეთი შეკვეთის ჩამოყალიბებისას.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl67" height="34" style='height:25.50pt;'>სალაროს ქვითარი არის პირველადი სააღრიცხვო დოკუმენტი, რომელიც წარმოიქმნება მომხმარებელსა და ადმინისტრაციას შორის ანგარიშსწორების დროს, სერვისით სარგებლობის ხელშეკრულებების დადებასთან, შესრულებასთან და შეწყვეტასთან დაკავშირებით. ანგარიშსწორების ცნება გამოიყენება იმ გაგებით, რომლითაც იგი განსაზღვრულია კანონში "სალარო აპარატების გამოყენების შესახებ ფულადი ანგარიშსწორების და (ან)
            გადახდის ელექტრონული საშუალებების გამოყენებით ანგარიშსწორების განხორციელებისას" .</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>გადახდის მეთოდი - ინფორმაცია ბანკის, გადახდის სისტემის, გადახდის საშუალებების შესახებ, რომელსაც მომხმარებელი იყენებს სერვისის გადასახდელად.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.2 <font class="font3">თანხმობა პერსონალური მონაცემების დამუშავებაზე</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>3.2.1 <font class="font3"> მომხმარებელი ღებულობს გადაწყვეტილებას გადასცეს თავისი პერსონალური მონაცემები ადმინისტრაციას, ეთანხმება მომხმარებლის ხელშეკრულების პირობებს და თანახმაა მისი
            პერსონალური მონაცემების თავისუფლად დამუშავებაზე, საკუთარი ნებით და მისი ინტერესებიდან გამომდინარე.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.2.1 <font class="font3">მომხმარებლის თანხმობა მისი პერსონალური მონაცემების დამუშავებაზე ითვლება ადმინისტრაციისთვის მიწოდებულად, თუ იგი გაიგზავნება:</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>a) <font class="font3">საიტზე რეგისტრაციისას ღილაკზე „რეგისტრაცია“ დაჭერის შემდეგ საიტზე არსებული
            ფორმის შევსებით. ღილაკზე „გაგრძელება“ დაწკაპუნების მომენტში ითვლება, რომ მან, მომხმარებელმა, თანხმობა მისცა მისი პერსონალური მონაცემების დამუშავებისთვის.</font></td>
        </tr>
        <tr height="50" style='height:37.50pt;'>
          <td class="xl69" height="50" style='height:37.50pt;'>b) <font class="font3"> "პროფილის პარამეტრების" განყოფილებაში "კონტაქტის ინფორმაციის შეცვლა", "კონტაქტების სია", "პაროლი", "ტრანზაქციის პაროლი", "ელ. ფოსტის საინფორმაციო ბიულეტენი" ქვესექციებში "პროფილის პარამეტრები" პერსონალური მონაცემების შეყვანისას ან შეცვლისას - პერსონალური მონაცემები, რომლებიც მომხმარებელი უზრუნველყოფს პირადი ანგარიშის ინფორმაციის რედაქტირებისას. ითვლება, რომ მომხმარებელმა თანხმობა მისცა მისი ახლად შეყვანილი ან შეცვლილი პერსონალური მონაცემების დამუშავებას ღილაკზე "შენახვა" ან
            "შეცვლა" დაჭერის მომენტში, ან ინტერფეისის ღილაკზე დაჭერის მომენტში, რაც ცალსახად მიუთითებს განმარტებაზე. პერსონალური მონაცემების შეცვლა, წაშლა, კორექტირება.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.3. <font class="font3"> ადმინისტრაციის მიერ დამუშავებული პერსონალური მონაცემები</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.3.1 <font class="font3"> ადმინისტრაცია ამუშავებს მომხმარებლების შემდეგ პერსონალურ მონაცემებს:</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>a) <font class="font3"> საიტზე მომხმარებლის რეგისტრაციისას:</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· სახელი;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· გვარი;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· ელექტრონული ფოსტის მისამართი;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· ტელეფონის ნომერი;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· Cookies. კუკის ფაილები</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>b) <font class="font3">ადმინისტრაციისთვის საინფორმაციო შეტყობინებების, კითხვების, გამოხმაურების გაგზავნისას:</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· ელექტრონული ფოსტის მისამართი;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· სახელი;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· გვარი;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· ტელეფონი ნომერი;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· Cookie <font class="font3">კუკის ფაილები</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>გ) „პროფილის პარამეტრების“ განყოფილებაში პერსონალური მონაცემების შეყვანისას ან შეცვლისას:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· სახელი;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· გვარი;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· ელექტრონული ფოსტის მისამართი;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· ტელეფონი ნომერი;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>·  <font class="font3">· ფოსტის მისამართი</font><font class="font1">;</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· Cookie <font class="font3">კუკის ფაილები</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>ე) რეგისტრირებული მომხმარებლის მიერ მომსახურების საფასურის გადახდისას:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· მისამართი, სადაც გინდათ რომ მიიღოთ</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· <font class="font3">· ელექტრონული ფოსტის მისამართი;</font><font class="font1">;</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· სახელი;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·გვარი</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· <font class="font3">შეკვეთა；</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·მომხმარებლის მიერ შესრულებული ფინანსური ვალდებულების თარიღი, დრო და ოდენობა;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·მომხმარებლის შეუსრულებელი ფინანსური ვალდებულების ოდენობა და შესრულების ვადები;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· <font class="font3"> სალაროს ჩეკი და სალარო ჩეკის მონაცემები;</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· <font class="font3">გადახდის ხერხი;</font><font class="font1">;</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·მომხმარებლისთვის მიწოდებული ფასდაკლებები და ფასდაკლების საფუძველი;；</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>·  <font class="font3">Cookies. კუკის ფაილები</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>f) <font class="font3">ადმინისტრაციის მიერ ჩატარებულ ღონისძიებებზე და ღონისძიებების ტრანსლიაციის რეგისტრაციისას:</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·ელი</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·გვარი</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· <font class="font3">ელექტრონული ფოსტის მისამართი;</font><font class="font1">;</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· Cookie <font class="font3"> კუკის ფაილები</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>ზ) როდესაც ადმინისტრაცია ატარებს სტატისტიკურ და (ან) კვლევით გამოკითხვას:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·სახელი</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·გვარი</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·პროფესია და (ან) ჰობი;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· <font class="font3"> ელექტრონული ფოსტის მისამართი;</font><font class="font1">;</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· Cookie <font class="font3"> კუკის ფაილები</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>თ) სატელეფონო საკონსულტაციო მომსახურების მიღებისას: ტელეფონის ნომერი, საიდანაც მომხმარებელი რეკავს;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·სახელი</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·გვარი</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·საიტზე მომხმარებლის რეგისტრაციის მონაცემები;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·სხვა პერსონალური მონაცემები, რომლებსაც მომხმარებელი აცნობებს ადმინისტრაციას თავისი ნებით და ინტერესებიდან გამომდინარე.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>ი) მომხმარებლის შესახებ ინფორმაციის შეგროვებისას მომხმარებლისთვის პერსონალიზებული საინფორმაციო და სარეკლამო შეტყობინებების ჩვენების მიზნით:</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· Cookie <font class="font3">კუკის ფაილების იდენტიფიკატორები；</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· <font class="font3">ბრაუზერის მომხმარებლის აგენტის ვადა;；</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· რეკლამის შემღუდველი ბლოკერის გამოყენება;；</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· შეკვეცილი IP მისამართი;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· დათვალიერების ისტორია;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·ინტერნეტ ვიზიტების მონაცემები;；</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·დაკავებული თანამდებობა / შრომითი ფუნქცია;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·ნახული პროდუქტების მონაცემები, მათი ფასის, ნახვის თარიღისა და დროის შესახებ;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·ფსევდონიმიზებული ელექტრონული ფოსტის მისამართები;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>· გეოლოკაცია</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>· ბრაუზერის ტექნიკური მონაცემები, მოწყობილობის, პარამეტრების შესახებ;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl67" height="18" style='height:13.50pt;'>·关于与广告的互动（点击、拒绝、转换等）</td>
        </tr>
        <tr height="50" style='height:37.50pt;'>
          <td class="xl67" height="50" style='height:37.50pt;'>ამ ინფორმაციის შეგროვებისას ის დაკავშირებულია უნიკალურ იდენტიფიკატორებთან, კერძოდ, კუკის ფაილების იდენტიფიკატორებთან და სხვა მსგავს ტექნოლოგიებთან და არ იძლევა მომხმარებლის პირდაპირ იდენტიფიკაციის საშუალებას (მონაცემთა ანონიმიზაცია). მომხმარებელს შეუძლია გამორთოს ამ ინფორმაციის შეგროვება
            თავის ბრაუზერში მომხმარებლის ბრაუზერის მწარმოებლის მიერ აღწერილი წესით. ადმინისტრატორს უფლება აქვს ამ პუნქტის შესაბამისად მიღებული ინფორმაცია გადასცეს მესამე პირებს</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.4. <font class="font3"> პერსონალური მონაცემების დამუშავების მიზნები</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.4.2. <font class="font3">ადმინისტრაცია ამუშავებს მომხმარებლის პერსონალურ მონაცემებს მხოლოდ შემდეგი მიზნებისთვის:</font></td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>ა) მომხმარებლის მიერ საიტის გამოყენებისას, როგორც საიტზე მომხმარებლის რეგისტრაციისას, ასევე არარსებობის შემთხვევაში, ადმინისტრაცია ამუშავებს მომხმარებლის პერსონალურ მონაცემებს საიტის გამოყენების შესახებ ხელშეკრულების შესასრულებლად (მომხმარებლის შეთანხმება) . ამ მიზნით ადმინისტრაცია ამუშავებს პერსონალურ მონაცემებს
            3.3 პუნქტში. წინამდებარე შეთანხმება.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>ბ) მომხმარებლის ხელშეკრულების შესასრულებლად, მომხმარებლის მიერ საიტის ფუნქციონალური გამოყენებისას, რომელიც დაკავშირებულია მომხმარებლის მიერ პერსონალური მონაცემების ნებაყოფლობით შემოტანასთან
            , შეცვლასთან, დაზუსტებასთან, წაშლასთან. ამ მიზნით ადმინისტრაცია ამუშავებს პერსონალურ მონაცემებს 3.3.1 პუნქტში. წინამდებარე შეთანხმება.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>გ) მომხმარებლის მიერ სერვისით სარგებლობის შესახებ კონტრაქტების გაფორმებისა და გასაფორმებლად
            საიტზე მომხმარებლის წინასწარი რეგისტრაციის გარეშე, ადმინისტრაცია ამუშავებს პერსონალურ მონაცემებს 3.3.1 პუნქტში. წინამდებარე შეთანხმება.</td>
        </tr>
        <tr height="50" style='height:37.50pt;'>
          <td class="xl69" height="50" style='height:37.50pt;'>დ) იმისათვის, რომ მომხმარებელმა მიიღოს ინფორმაცია ადმინისტრაციისგან საიტის, სერვისების ფუნქციონირების შესახებ, გაუგზავნოს საინფორმაციო შეტყობინებები, კითხვები, გამოხმაურება ადმინისტრაციას, მიიღოს რჩევა და უზრუნველყოს მომხმარებლისთვის სხვა საინფორმაციო მხარდაჭერა, რომელიც მიმართულია მომხმარებლის ხელშეკრულების და ასევე სერვისით სარგებლობის ხელშეკრულების შესასრულებლად,
            ადმინისტრაცია ამუშავებს პერსონალურ მონაცემებს, პუნქტი 3.3.1. წინამდებარე შეთანხმების შესაბამისად.</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>ე) მომხმარებლის მოთხოვნის შესრულების მიზნით საინფორმაციო ბიულეტენის მიღების  შესახებ ადმინისტრაცია ამუშავებს პერსონალურ მონაცემებს,
            პუნქტი 3.3.1. წინამდებარე შეთანხმების შესაბამისად.</td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>ვ) სერვისის ხარისხის გაუმჯობესების მიზნით, საიტის გაუმჯობესების, მომხმარებლების დეპერსონალიზებული ინფორმაციის საფუძველზე სტატისტიკური და სხვა კვლევების ჩატარების მიზნით,
            ადმინისტრაცია ამუშავებს პერსონალურ მონაცემებს, პუნქტი 3.3.1. წინამდებარე შეთანხმების შესაბამისად</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>ზ) სერვისით სარგებლობის ხელშეკრულებების გაფორმებისა და შესრულების მიზნით ადმინისტრაცია ამუშავებს პერსონალურ მონაცემებს, პუნქტი 3.3.1. წინამდებარე შეთანხმების შესაბამისად</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>თ) ტენდერის მომზადების მიზნით მომხმარებელსა და ადმინისტრაციას შორის ხელშეკრულების შესასრულებლად, ადმინისტრაცია ამუშავებს პერსონალურ მონაცემებს 3.3.1. მიმდინარე ხელშეკრულების შესაბამისად.</td>
        </tr>
        <tr height="37" style='height:27.75pt;'>
          <td class="xl70" height="37" style='height:27.75pt;'>3.5. <font class="font2">პერსონალური მონაცემების დამუშავების პირობები</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.5.1. <font class="font3">ადმინისტრაცია, მომხმარებლის კეთილსინდისიერების პრეზუმფციიდან გამომდინარე, გამომდინარეობს იქიდან, რომ საიტზე პერსონალური მონაცემების მიწოდებისას მომხმარებელი:</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>3.5.1.1<font class="font3"> კომპეტენტური პიროვნებაა. ასეთი პირის ქმედუუნარობის შემთხვევაში, პერსონალური მონაცემების დამუშავებაზე თანხმობას
            იძლევა მომხმარებლის კანონიერი წარმომადგენელი, რომელმაც წაიკითხა და ეთანხმება ამ პოლიტიკაში მითითებულ პერსონალური მონაცემების დამუშავების პირობებს.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.5.1.2. <font class="font3">მიუთითებს სანდო ინფორმაციას მის შესახებ, რამდენადაც ეს აუცილებელია საიტის გამოსაყენებლად და განაახლებს მოწოდებულ პერსონალურ მონაცემებს.</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>3.5.1.3. <font class="font3">პერსონალური ანგარიშის მეშვეობით მისი სურათის ატვირთვის შემთხვევაში, იგი ეთანხმება ამ სურათის გამოყენებას იმ მიზნებისთვის, რომლებიც არ არის დაკავშირებული მომხმარებლის იდენტიფიკაციასთან.
            მომხმარებელი იღებს ვალდებულებას არ მიაწოდოს მესამე მხარის ფოტოები, როგორც მომხმარებლის გამოსახულება.</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>3.5.1.4<font class="font3">。</font><font class="font1"> </font><font class="font3">იცის, რომ საიტზე განთავსებული ინფორმაცია მომხმარებლის მიერ მის შესახებ შეიძლება გახდეს ხელმისაწვდომი საიტის სხვა
            მომხმარებლებისთვის, შეიძლება დაკოპირდეს და გავრცელდეს ასეთი მომხმარებლების მიერ;</font></td>
        </tr>
        <tr height="50" style='height:37.50pt;'>
          <td class="xl69" height="50" style='height:37.50pt;'>3.5.1.5<font class="font3">。</font><font class="font1"> </font><font class="font3">აცნობიერებს, რომ საიტის ფუნქციონირება საშუალებას აძლევს მომხმარებელს დამოუკიდებლად დაამყაროს საჯარო წვდომა (ხილვადობის რეჟიმი) პერსონალური მონაცემების ნაწილზე სხვა მომხმარებლებისთვის. მომხმარებლის მიერ მის პერსონალურ მონაცემებზე საჯარო წვდომის დადგენა განმარტებულია, როგორც მომხმარებლის მიერ პერსონალური მონაცემების გამჟღავნება მისი ნებით და საკუთარი ინტერესებიდან გამომდინარე. მომხმარებელი გარანტიას იძლევა, რომ იცის მისი პერსონალური
            მონაცემების სხვა მომხმარებლებისთვის გამჟღავნების შედეგები და არ ექნება პრეტენზია ადმინისტრაციის მიმართ.</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>3.5.1.6. <font class="font3">აცნობიერებს, რომ ზოგიერთი პერსონალური მონაცემების დამუშავება ეფუძნება მოქმედი კანონმდებლობის მოთხოვნებს და
            პერსონალური მონაცემების დამუშავება აუცილებელია ასეთ მომხმარებელთან ხელშეკრულების შესასრულებლად.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.5.3. <font class="font3">დაზუსტება, პერსონალური მონაცემების შეცვლა მომხმარებელს შეუძლია დამოუკიდებლად განახორციელოს პირადი ანგარიშის გამოყენებით.</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>3.5.4. <font class="font3"> მომხმარებელმა იცის, რომ მან დამოუკიდებლად და საკუთარი ინტერესებიდან გამომდინარე უნდა შეამოწმოს პერსონალური მონაცემების
            შესაბამისობა და გააკეთოს საჭირო დაზუსტებები, ცვლილებები მის პერსონალურ მონაცემებში პერსონალურ ანგარიშში.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.5.5. <font class="font3">პერსონალური მონაცემების გავრცელება შეიძლება განხორციელდეს მხოლოდ შემდეგ შემთხვევებში:</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>3.5.5.1<font class="font3">。</font><font class="font1"> </font><font class="font3">
            მომხმარებლის ნებაზე დაყრდნობით, რომელიც მიცემულია მომხმარებლის მიერ, ადგენს მის პერსონალურ მონაცემებზე საჯარო წვდომას (ხილვადობის რეჟიმს), რათა აჩვენოს მომხმარებლის პროფილი, მისი პერსონალური მონაცემების ნაწილი საიტის სხვა მომხმარებლებისთვის.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.5.6. <font class="font3"> ადმინისტრაციას უფლება აქვს გადასცეს პერსონალური მონაცემები მესამე პირებს შემდეგი მიზნებისთვის:</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.5.6.1. <font class="font3"> მესამე მხარის ჩართვა მომხმარებელსა და ადმინისტრაციას შორის დადებული ხელშეკრულებების გაფორმების პროცესში ამ ხელშეკრულებების შესრულების ხარისხის გაუმჯობესების მიზნით;</font></td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>3.5.7. <font class="font3">ადმინისტრაციას უფლება აქვს გადასცეს პერსონალური მონაცემები მესამე პირებს, იმ პირობით, რომ ასეთი მესამე მხარეები უზრუნველყოფენ პერსონალური მონაცემების კონფიდენციალურობას მათი დამუშავების დროს,
            დაიცვან ზომები პერსონალური მონაცემების უსაფრთხოების უზრუნველსაყოფად. მესამე მხარეს ეკრძალება მომხმარებლების პერსონალური მონაცემების გადაცემა და გავრცელება.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.5.8. <font class="font3">მომხმარებლის პერსონალური მონაცემების დამუშავების შეწყვეტა, პერსონალური მონაცემების დაბლოკვა და განადგურება ხორციელდება შემდეგ შემთხვევებში:</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>ა) მომხმარებლის მიერ პირად ანგარიშში არსებული პერსონალური მონაცემების წაშლა;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>ბ) ადმინისტრაციის მიერ მომხმარებლისგან პერსონალური მონაცემების დამუშავების თანხმობის გაუქმების შეტყობინების მიღებისას;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>გ) ადმინისტრაცია იღებს მომხმარებლისგან მოთხოვნას პერსონალური მონაცემების განადგურების ან დაბლოკვის შესახებ;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>დ) პერსონალური მონაცემების დამუშავების შეთანხმების ვადის გასვლის შემდეგ;</td>
        </tr>
        <tr height="100" style='height:75.00pt;'>
          <td class="xl69" height="100" style='height:75.00pt;'>3.5.9. <font class="font3">ადმინისტრაცია იღებს აუცილებელ და საკმარის სამართლებრივ, ორგანიზაციულ და ტექნიკურ ზომებს, რათა დაიცვას პერსონალური მონაცემები არაავტორიზებული ან შემთხვევითი წვდომისგან, განადგურებისგან, მოდიფიკაციისგან, დაბლოკვისგან, კოპირებისგან, გავრცელებისგან, აგრეთვე მესამე მხარის სხვა უკანონო ქმედებებისგან, რომლებიც მიმართულია პერსონალურ მონაცემებთან დაკავშირებით. კერძოდ, ადმინისტრაცია მიმართავს ორგანიზაციულ და ტექნიკურ ზომებს პერსონალური მონაცემების დამუშავების დროს უსაფრთხოების უზრუნველსაყოფად, პერსონალურ მონაცემებზე არასანქცირებული წვდომის ფაქტების კონტროლისა და მომავალში მსგავსი ინციდენტების აღსაკვეთად ზომების მიღების მიზნით. პერსონალური მონაცემების უსაფრთხოება და პერსონალური მონაცემების დაცვის დონე. პერსონალურ ანგარიშზე წვდომის ავტორიზაციისთვის, მომხმარებელი იყენებს მომხმარებლის შესვლას (ელ. ფოსტის მისამართს) და პაროლს. მომხმარებელი პასუხისმგებელია ამ ინფორმაციის უსაფრთხოებაზე.
            მომხმარებელს არ აქვს უფლება გადასცეს საკუთარი შესვლა და პაროლი მესამე პირებს და ასევე ვალდებულია მიიღოს ზომები მათი კონფიდენციალურობის უზრუნველსაყოფად.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.6. <font class="font3"> მომხმარებელს უფლება აქვს:</font></td>
        </tr>
        <tr height="33" style='height:24.75pt;'>
          <td class="xl69" height="33" style='height:24.75pt;'>3.6.1. <font class="font3">საკუთარი შეხედულებისამებრ, საკუთარი ნებით და საკუთარი ინტერესებიდან გამომდინარე, მიაწოდოს ადმინისტრაციას პერსონალური მონაცემები მათი დამუშავებისთვის წინამდებარე ხელშეკრულებით განსაზღვრული პირობებით;</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.6.2. <font class="font3">დამოუკიდებლად მიაწოდოს, შეცვალოს და წაშალოს პერსონალური მონაცემები პერსონალურ ანგარიშში, იმ პირობით, რომ ასეთი ცვლილებები და შესწორებები შეიცავს განახლებულ და სანდო ინფორმაციას;</font></td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>3.6.3. <font class="font3">დაუკავშირდით ადმინისტრაციას მოთხოვნებით, მათ შორის პერსონალური მონაცემების განადგურების, დამუშავებაზე თანხმობის გაუქმების,
            პერსონალური მონაცემების დაბლოკვის შესახებ. მოთხოვნა შესრულებულია 3.6.2 პუნქტით გათვალისწინებული წესით. წინამდებარე შეთანხმების საპუძველზე</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.6.4. <font class="font3"> წაშალეთ პირადი ანგარიში დამოუკიდებლად ან სთხოვეთ ადმინისტრაციას ადმინისტრაციის მიერ პირადი ანგარიშის წაშლა
            3.6.2 პუნქტით გათვალისწინებული წესით. წინამდებარე ხელშეკრულების შესაბამისად</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.6.5. <font class="font3">დამოუკიდებლად დააწესეთ პერსონალური მონაცემების ნაწილის საჯარო წვდომის რეჟიმი (ხილვადობის რეჟიმი), გააუქმეთ ასეთი რეჟიმი.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.6.6. <font class="font3">მომხმარებელს უფლება აქვს თავისი თხოვნები და მოთხოვნები გაუგზავნოს ადმინისტრაციას შემდეგი გზებით:</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.6.7. <font class="font3">წერილობით საიტზე მითითებულ ადმინისტრაციის საფოსტო მისამართზე;</font></td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>3.6.8. <font class="font3">დოკუმენტი უნდა გაიგზავნოს მომხმარებლის ელექტრონული ფოსტის მისამართიდან, რომელიც მითითებულია მის
            მიერ საიტზე რეგისტრაციისას ან სერვისით სარგებლობის ხელშეკრულებაში, ადმინისტრაციის ელექტრონული ფოსტის მისამართზე uabkordicepsas@gmail.com.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.6.9. <font class="font3"> მომხმარებლის მიერ გაგზავნილი თხოვნები და მოთხოვნები უნდა შეიცავდეს შემდეგ ინფორმაციას:</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>ა) მომხმარებლის სახელი, გვარი (მამის სახელი)</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>ბ) საიტზე მომხმარებლის რეგისტრაციის მონაცემები (თუ მომხმარებელი რეგისტრირებულია მოთხოვნის ან მოთხოვნის გაგზავნის დროს);</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>გ) მომხმარებლის მოთხოვნის ან მოთხოვნის არსი;</td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>დ) მომხმარებლის ხელმოწერა</td>
        </tr>
        <tr height="51" style='height:38.25pt;'>
          <td class="xl69" height="51" style='height:38.25pt;'>3.6.10 <font class="font3"> ადმინისტრაცია განიხილავს მომხმარებლისგან მიღებულ მოთხოვნებს და თხოვნებს სავალდებულო დეტალების ხელმისაწვდომობის, მოთხოვნის ან გასაჩივრების მართებულობის შესახებ. თუ მომხმარებლის მოთხოვნა გამართლებულია, ადმინისტრაცია დააკმაყოფილებს მას მიღებიდან 30 დღის განმავლობაში. ნებისმიერ შემთხვევაში, ადმინისტრაცია პასუხს უგზავნის მომხმარებელს მოთხოვნის ან გასაჩივრების დღიდან არაუმეტეს 30 დღის განმავლობაში
            . პასუხი ეგზავნება მომხმარებელს მომხმარებლის მოთხოვნის ან მიმართვის ფორმის შესაბამისი ფორმით.</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.7. <font class="font3">პოლიტიკის შეცვლა</font></td>
        </tr>
        <tr height="18" style='height:13.50pt;'>
          <td class="xl69" height="18" style='height:13.50pt;'>3.7.1. <font class="font3">ადმინისტრაცია იტოვებს უფლებას შეიტანოს ცვლილებები მომხმარებლის ხელშეკრულებაში. მომხმარებელი ვალდებულია გაეცნოს მომხმარებლის შეთანხმების ტექსტს ყოველ ჯერზე, როცა ის იყენებს საიტს.</font></td>
        </tr>
        <tr height="34" style='height:25.50pt;'>
          <td class="xl69" height="34" style='height:25.50pt;'>3.7.2. <font class="font3">მომხმარებლის შეთანხმების ახალი ვერსია ძალაში შედის საიტის შესაბამის განყოფილებაში განთავსების მომენტიდან. საიტის ან მისი სერვისების გაგრძელება მომხმარებლის შეთანხმების ახალი ვერსიის გამოქვეყნების შემდეგ ნიშნავს მომხმარებლის შეთანხმებისა და მისი პირობების მიღებას
            მომხმარებლის მიერ. მომხმარებლის შეთანხმების პირობებთან შეუთანხმებლობის შემთხვევაში, მომხმარებელმა დაუყოვნებლივ უნდა შეწყვიტოს საიტის გამოყენება.</font></td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
export default {
  name: 'PublicOfferingAgreement',
  data() {
    return {}
  },
  computed: {
    ...mapGetters([
      'language',
    ]),
  },
  watch: {},
  mounted() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.publicofferingagreement {
  width: 660px;
  margin:auto;
  text-align: justify;
}
</style>
<!--英文的CSS-->
<style lang="scss" scoped>
.english{
tr
{mso-height-source:auto;
mso-ruby-visibility:none;}
col
{mso-width-source:auto;
mso-ruby-visibility:none;}
br
{mso-data-placement:same-cell;}
.font0
{color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:134;}
.font1
{color:windowtext;
font-size:10.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:"Arial";
mso-generic-font-family:swiss;
mso-font-charset:0;}
.font2
{color:windowtext;
font-size:22.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:"Avenir Black";
mso-generic-font-family:swiss;
mso-font-charset:0;}
.font3
{color:windowtext;
font-size:10.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:"Times New Roman Regular";
mso-generic-font-family:swiss;
mso-font-charset:0;}
.font4
{color:windowtext;
font-size:22.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:"Avenir Heavy";
mso-generic-font-family:swiss;
mso-font-charset:0;}
.font5
{color:windowtext;
font-size:24.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:"Avenir Heavy";
mso-generic-font-family:swiss;
mso-font-charset:0;}
.font6
{color:windowtext;
font-size:24.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:"Avenir Black";
mso-generic-font-family:swiss;
mso-font-charset:0;}
.font7
{color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font8
{color:#3F3F76;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font9
{color:#9C0006;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font10
{color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font11
{color:#0000FF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:underline;
text-underline-style:single;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font12
{color:#800080;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:underline;
text-underline-style:single;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font13
{color:#44546A;
font-size:11.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:134;}
.font14
{color:#FF0000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font15
{color:#44546A;
font-size:18.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:134;}
.font16
{color:#7F7F7F;
font-size:11.0pt;
font-weight:400;
font-style:italic;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font17
{color:#44546A;
font-size:15.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:134;}
.font18
{color:#44546A;
font-size:13.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:134;}
.font19
{color:#3F3F3F;
font-size:11.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font20
{color:#FA7D00;
font-size:11.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font21
{color:#FFFFFF;
font-size:11.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font22
{color:#FA7D00;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font23
{color:#000000;
font-size:11.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font24
{color:#006100;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font25
{color:#9C6500;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.style0
{mso-number-format:"General";
text-align:general;
vertical-align:middle;
white-space:nowrap;
mso-rotate:0;
mso-pattern:auto;
mso-background-source:auto;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:134;
border:none;
mso-protection:locked visible;
mso-style-name:"常规";
mso-style-id:0;}
.style16
{mso-number-format:"_ \0022\00A5\0022* \#\,\#\#0_ \;_ \0022\00A5\0022* \\-\#\,\#\#0_ \;_ \0022\00A5\0022* \0022-\0022_ \;_ \@_ ";
mso-style-name:"货币[0]";
mso-style-id:7;}
.style17
{mso-pattern:auto none;
background:#EDEDED;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"20% - 强调文字颜色 3";}
.style18
{mso-pattern:auto none;
background:#FFCC99;
color:#3F3F76;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
border:.5pt solid #7F7F7F;
mso-style-name:"输入";}
.style19
{mso-number-format:"_ \0022\00A5\0022* \#\,\#\#0\.00_ \;_ \0022\00A5\0022* \\-\#\,\#\#0\.00_ \;_ \0022\00A5\0022* \0022-\0022??_ \;_ \@_ ";
mso-style-name:"货币";
mso-style-id:4;}
.style20
{mso-number-format:"_ * \#\,\#\#0_ \;_ * \\-\#\,\#\#0_ \;_ * \0022-\0022_ \;_ \@_ ";
mso-style-name:"千位分隔[0]";
mso-style-id:6;}
.style21
{mso-pattern:auto none;
background:#DBDBDB;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"40% - 强调文字颜色 3";}
.style22
{mso-pattern:auto none;
background:#FFC7CE;
color:#9C0006;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"差";}
.style23
{mso-number-format:"_ * \#\,\#\#0\.00_ \;_ * \\-\#\,\#\#0\.00_ \;_ * \0022-\0022??_ \;_ \@_ ";
mso-style-name:"千位分隔";
mso-style-id:3;}
.style24
{mso-pattern:auto none;
background:#C9C9C9;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"60% - 强调文字颜色 3";}
.style25
{color:#0000FF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:underline;
text-underline-style:single;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"超链接";
mso-style-id:8;}
.style26
{mso-number-format:"0%";
mso-style-name:"百分比";
mso-style-id:5;}
.style27
{color:#800080;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:underline;
text-underline-style:single;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"已访问的超链接";
mso-style-id:9;}
.style28
{mso-pattern:auto none;
background:#FFFFCC;
border:.5pt solid #B2B2B2;
mso-style-name:"注释";}
.style29
{mso-pattern:auto none;
background:#F4B084;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"60% - 强调文字颜色 2";}
.style30
{color:#44546A;
font-size:11.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:134;
mso-style-name:"标题 4";}
.style31
{color:#FF0000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"警告文本";}
.style32
{color:#44546A;
font-size:18.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:134;
mso-style-name:"标题";}
.style33
{color:#7F7F7F;
font-size:11.0pt;
font-weight:400;
font-style:italic;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"解释性文本";}
.style34
{color:#44546A;
font-size:15.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:134;
border-bottom:1.0pt solid #5B9BD5;
mso-style-name:"标题 1";}
.style35
{color:#44546A;
font-size:13.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:134;
border-bottom:1.0pt solid #5B9BD5;
mso-style-name:"标题 2";}
.style36
{mso-pattern:auto none;
background:#9BC2E6;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"60% - 强调文字颜色 1";}
.style37
{color:#44546A;
font-size:11.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:134;
border-bottom:1.0pt solid #ACCCEA;
mso-style-name:"标题 3";}
.style38
{mso-pattern:auto none;
background:#FFD966;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"60% - 强调文字颜色 4";}
.style39
{mso-pattern:auto none;
background:#F2F2F2;
color:#3F3F3F;
font-size:11.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
border:.5pt solid #3F3F3F;
mso-style-name:"输出";}
.style40
{mso-pattern:auto none;
background:#F2F2F2;
color:#FA7D00;
font-size:11.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
border:.5pt solid #7F7F7F;
mso-style-name:"计算";}
.style41
{mso-pattern:auto none;
background:#A5A5A5;
color:#FFFFFF;
font-size:11.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
border:2.0pt double #3F3F3F;
mso-style-name:"检查单元格";}
.style42
{mso-pattern:auto none;
background:#E2EFDA;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"20% - 强调文字颜色 6";}
.style43
{mso-pattern:auto none;
background:#ED7D31;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"强调文字颜色 2";}
.style44
{color:#FA7D00;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
border-bottom:2.0pt double #FF8001;
mso-style-name:"链接单元格";}
.style45
{color:#000000;
font-size:11.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
border-top:.5pt solid #5B9BD5;
border-bottom:2.0pt double #5B9BD5;
mso-style-name:"汇总";}
.style46
{mso-pattern:auto none;
background:#C6EFCE;
color:#006100;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"好";}
.style47
{mso-pattern:auto none;
background:#FFEB9C;
color:#9C6500;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"适中";}
.style48
{mso-pattern:auto none;
background:#D9E1F2;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"20% - 强调文字颜色 5";}
.style49
{mso-pattern:auto none;
background:#5B9BD5;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"强调文字颜色 1";}
.style50
{mso-pattern:auto none;
background:#DDEBF7;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"20% - 强调文字颜色 1";}
.style51
{mso-pattern:auto none;
background:#BDD7EE;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"40% - 强调文字颜色 1";}
.style52
{mso-pattern:auto none;
background:#FCE4D6;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"20% - 强调文字颜色 2";}
.style53
{mso-pattern:auto none;
background:#F8CBAD;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"40% - 强调文字颜色 2";}
.style54
{mso-pattern:auto none;
background:#A5A5A5;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"强调文字颜色 3";}
.style55
{mso-pattern:auto none;
background:#FFC000;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"强调文字颜色 4";}
.style56
{mso-pattern:auto none;
background:#FFF2CC;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"20% - 强调文字颜色 4";}
.style57
{mso-pattern:auto none;
background:#FFE699;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"40% - 强调文字颜色 4";}
.style58
{mso-pattern:auto none;
background:#4472C4;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"强调文字颜色 5";}
.style59
{mso-pattern:auto none;
background:#B4C6E7;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"40% - 强调文字颜色 5";}
.style60
{mso-pattern:auto none;
background:#8EA9DB;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"60% - 强调文字颜色 5";}
.style61
{mso-pattern:auto none;
background:#70AD47;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"强调文字颜色 6";}
.style62
{mso-pattern:auto none;
background:#C6E0B4;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"40% - 强调文字颜色 6";}
.style63
{mso-pattern:auto none;
background:#A9D08E;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"60% - 强调文字颜色 6";}
td
{mso-style-parent:style0;
padding-top:1px;
padding-right:1px;
padding-left:1px;
mso-ignore:padding;
mso-number-format:"General";
text-align:general;
vertical-align:middle;
white-space:nowrap;
mso-rotate:0;
mso-pattern:auto;
mso-background-source:auto;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:134;
border:none;
mso-protection:locked visible;}
.xl65
{mso-style-parent:style0;
vertical-align:bottom;
color:windowtext;
font-size:10.0pt;
font-family:Arial;
mso-generic-font-family:swiss;
mso-font-charset:0;}
.xl66
{mso-style-parent:style0;
text-align:center;
white-space:normal;
color:windowtext;
font-size:22.0pt;
font-weight:700;
font-family:Avenir Black;
mso-generic-font-family:swiss;
mso-font-charset:0;}
.xl67
{mso-style-parent:style0;
text-align:left;
vertical-align:top;
white-space:normal;
color:windowtext;
font-size:10.0pt;
font-family:Times New Roman Regular;
mso-generic-font-family:swiss;
mso-font-charset:0;}
.xl68
{mso-style-parent:style0;
vertical-align:bottom;
white-space:normal;
color:windowtext;
font-size:10.0pt;
font-family:Times New Roman Regular;
mso-generic-font-family:swiss;
mso-font-charset:0;}
.xl69
{mso-style-parent:style0;
text-align:left;
white-space:normal;
color:windowtext;
font-size:10.0pt;
font-family:Times New Roman Regular;
mso-generic-font-family:swiss;
mso-font-charset:0;}
.xl70
{mso-style-parent:style0;
text-align:center;
vertical-align:bottom;
white-space:normal;
color:windowtext;
font-size:22.0pt;
font-weight:700;
font-family:Avenir Heavy;
mso-generic-font-family:swiss;
mso-font-charset:0;}
.xl71
{mso-style-parent:style0;
vertical-align:bottom;
color:windowtext;
font-size:10.0pt;
font-family:Times New Roman Regular;
mso-generic-font-family:swiss;
mso-font-charset:0;}
.xl72
{mso-style-parent:style0;
vertical-align:top;
white-space:normal;
color:windowtext;
font-size:10.0pt;
font-family:Times New Roman Regular;
mso-generic-font-family:swiss;
mso-font-charset:0;}
.xl73
{mso-style-parent:style0;
text-align:left;
vertical-align:bottom;
white-space:normal;
color:windowtext;
font-size:10.0pt;
font-family:Times New Roman Regular;
mso-generic-font-family:swiss;
mso-font-charset:0;}
.xl74
{mso-style-parent:style0;
white-space:normal;
color:windowtext;
font-size:10.0pt;
font-family:Times New Roman Regular;
mso-generic-font-family:swiss;
mso-font-charset:0;}
.xl75
{mso-style-parent:style0;
text-align:center;
white-space:normal;
color:windowtext;
font-size:24.0pt;
font-weight:700;
font-family:Avenir Heavy;
mso-generic-font-family:swiss;
mso-font-charset:0;}
.xl76
{mso-style-parent:style0;
text-align:center;
white-space:normal;
color:windowtext;
font-size:24.0pt;
font-weight:700;
font-family:Avenir Black;
mso-generic-font-family:swiss;
mso-font-charset:0;}
}
</style>
<!--中文的CSS-->
<style lang="scss" scoped>
.chinese {
tr
{mso-height-source:auto;
mso-ruby-visibility:none;}
col
{mso-width-source:auto;
mso-ruby-visibility:none;}
br
{mso-data-placement:same-cell;}
.font0
{color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:134;}
.font1
{color:windowtext;
font-size:10.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:"Arial";
mso-generic-font-family:swiss;
mso-font-charset:0;}
.font2
{color:windowtext;
font-size:22.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:"宋体-简";
mso-generic-font-family:auto;
mso-font-charset:134;}
.font3
{color:windowtext;
font-size:10.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:"宋体-简";
mso-generic-font-family:auto;
mso-font-charset:134;}
.font4
{color:windowtext;
font-size:10.0pt;
font-weight:400;
font-style:normal;
text-decoration:underline;
text-underline-style:single;
font-family:"宋体-简";
mso-generic-font-family:auto;
mso-font-charset:134;}
.font5
{color:windowtext;
font-size:22.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:"Arial";
mso-generic-font-family:swiss;
mso-font-charset:0;}
.font6
{color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font7
{color:#3F3F76;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font8
{color:#9C0006;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font9
{color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font10
{color:#0000FF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:underline;
text-underline-style:single;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font11
{color:#800080;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:underline;
text-underline-style:single;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font12
{color:#44546A;
font-size:11.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:134;}
.font13
{color:#FF0000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font14
{color:#44546A;
font-size:18.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:134;}
.font15
{color:#7F7F7F;
font-size:11.0pt;
font-weight:400;
font-style:italic;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font16
{color:#44546A;
font-size:15.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:134;}
.font17
{color:#44546A;
font-size:13.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:134;}
.font18
{color:#3F3F3F;
font-size:11.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font19
{color:#FA7D00;
font-size:11.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font20
{color:#FFFFFF;
font-size:11.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font21
{color:#FA7D00;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font22
{color:#000000;
font-size:11.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font23
{color:#006100;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font24
{color:#9C6500;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font25
{color:windowtext;
font-size:10.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:"Times New Roman Regular";
mso-generic-font-family:swiss;
mso-font-charset:0;}
.font26
{color:windowtext;
font-size:10.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:swiss;
mso-font-charset:0;}
.style0
{mso-number-format:"General";
text-align:general;
vertical-align:middle;
white-space:nowrap;
mso-rotate:0;
mso-pattern:auto;
mso-background-source:auto;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:134;
border:none;
mso-protection:locked visible;
mso-style-name:"常规";
mso-style-id:0;}
.style16
{mso-number-format:"_ \0022\00A5\0022* \#\,\#\#0_ \;_ \0022\00A5\0022* \\-\#\,\#\#0_ \;_ \0022\00A5\0022* \0022-\0022_ \;_ \@_ ";
mso-style-name:"货币[0]";
mso-style-id:7;}
.style17
{mso-pattern:auto none;
background:#EDEDED;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"20% - 强调文字颜色 3";}
.style18
{mso-pattern:auto none;
background:#FFCC99;
color:#3F3F76;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
border:.5pt solid #7F7F7F;
mso-style-name:"输入";}
.style19
{mso-number-format:"_ \0022\00A5\0022* \#\,\#\#0\.00_ \;_ \0022\00A5\0022* \\-\#\,\#\#0\.00_ \;_ \0022\00A5\0022* \0022-\0022??_ \;_ \@_ ";
mso-style-name:"货币";
mso-style-id:4;}
.style20
{mso-number-format:"_ * \#\,\#\#0_ \;_ * \\-\#\,\#\#0_ \;_ * \0022-\0022_ \;_ \@_ ";
mso-style-name:"千位分隔[0]";
mso-style-id:6;}
.style21
{mso-pattern:auto none;
background:#DBDBDB;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"40% - 强调文字颜色 3";}
.style22
{mso-pattern:auto none;
background:#FFC7CE;
color:#9C0006;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"差";}
.style23
{mso-number-format:"_ * \#\,\#\#0\.00_ \;_ * \\-\#\,\#\#0\.00_ \;_ * \0022-\0022??_ \;_ \@_ ";
mso-style-name:"千位分隔";
mso-style-id:3;}
.style24
{mso-pattern:auto none;
background:#C9C9C9;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"60% - 强调文字颜色 3";}
.style25
{color:#0000FF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:underline;
text-underline-style:single;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"超链接";
mso-style-id:8;}
.style26
{mso-number-format:"0%";
mso-style-name:"百分比";
mso-style-id:5;}
.style27
{color:#800080;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:underline;
text-underline-style:single;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"已访问的超链接";
mso-style-id:9;}
.style28
{mso-pattern:auto none;
background:#FFFFCC;
border:.5pt solid #B2B2B2;
mso-style-name:"注释";}
.style29
{mso-pattern:auto none;
background:#F4B084;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"60% - 强调文字颜色 2";}
.style30
{color:#44546A;
font-size:11.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:134;
mso-style-name:"标题 4";}
.style31
{color:#FF0000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"警告文本";}
.style32
{color:#44546A;
font-size:18.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:134;
mso-style-name:"标题";}
.style33
{color:#7F7F7F;
font-size:11.0pt;
font-weight:400;
font-style:italic;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"解释性文本";}
.style34
{color:#44546A;
font-size:15.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:134;
border-bottom:1.0pt solid #5B9BD5;
mso-style-name:"标题 1";}
.style35
{color:#44546A;
font-size:13.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:134;
border-bottom:1.0pt solid #5B9BD5;
mso-style-name:"标题 2";}
.style36
{mso-pattern:auto none;
background:#9BC2E6;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"60% - 强调文字颜色 1";}
.style37
{color:#44546A;
font-size:11.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:134;
border-bottom:1.0pt solid #ACCCEA;
mso-style-name:"标题 3";}
.style38
{mso-pattern:auto none;
background:#FFD966;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"60% - 强调文字颜色 4";}
.style39
{mso-pattern:auto none;
background:#F2F2F2;
color:#3F3F3F;
font-size:11.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
border:.5pt solid #3F3F3F;
mso-style-name:"输出";}
.style40
{mso-pattern:auto none;
background:#F2F2F2;
color:#FA7D00;
font-size:11.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
border:.5pt solid #7F7F7F;
mso-style-name:"计算";}
.style41
{mso-pattern:auto none;
background:#A5A5A5;
color:#FFFFFF;
font-size:11.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
border:2.0pt double #3F3F3F;
mso-style-name:"检查单元格";}
.style42
{mso-pattern:auto none;
background:#E2EFDA;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"20% - 强调文字颜色 6";}
.style43
{mso-pattern:auto none;
background:#ED7D31;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"强调文字颜色 2";}
.style44
{color:#FA7D00;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
border-bottom:2.0pt double #FF8001;
mso-style-name:"链接单元格";}
.style45
{color:#000000;
font-size:11.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
border-top:.5pt solid #5B9BD5;
border-bottom:2.0pt double #5B9BD5;
mso-style-name:"汇总";}
.style46
{mso-pattern:auto none;
background:#C6EFCE;
color:#006100;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"好";}
.style47
{mso-pattern:auto none;
background:#FFEB9C;
color:#9C6500;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"适中";}
.style48
{mso-pattern:auto none;
background:#D9E1F2;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"20% - 强调文字颜色 5";}
.style49
{mso-pattern:auto none;
background:#5B9BD5;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"强调文字颜色 1";}
.style50
{mso-pattern:auto none;
background:#DDEBF7;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"20% - 强调文字颜色 1";}
.style51
{mso-pattern:auto none;
background:#BDD7EE;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"40% - 强调文字颜色 1";}
.style52
{mso-pattern:auto none;
background:#FCE4D6;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"20% - 强调文字颜色 2";}
.style53
{mso-pattern:auto none;
background:#F8CBAD;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"40% - 强调文字颜色 2";}
.style54
{mso-pattern:auto none;
background:#A5A5A5;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"强调文字颜色 3";}
.style55
{mso-pattern:auto none;
background:#FFC000;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"强调文字颜色 4";}
.style56
{mso-pattern:auto none;
background:#FFF2CC;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"20% - 强调文字颜色 4";}
.style57
{mso-pattern:auto none;
background:#FFE699;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"40% - 强调文字颜色 4";}
.style58
{mso-pattern:auto none;
background:#4472C4;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"强调文字颜色 5";}
.style59
{mso-pattern:auto none;
background:#B4C6E7;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"40% - 强调文字颜色 5";}
.style60
{mso-pattern:auto none;
background:#8EA9DB;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"60% - 强调文字颜色 5";}
.style61
{mso-pattern:auto none;
background:#70AD47;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"强调文字颜色 6";}
.style62
{mso-pattern:auto none;
background:#C6E0B4;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"40% - 强调文字颜色 6";}
.style63
{mso-pattern:auto none;
background:#A9D08E;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"60% - 强调文字颜色 6";}
td
{mso-style-parent:style0;
padding-top:1px;
padding-right:1px;
padding-left:1px;
mso-ignore:padding;
mso-number-format:"General";
text-align:general;
vertical-align:middle;
white-space:nowrap;
mso-rotate:0;
mso-pattern:auto;
mso-background-source:auto;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:134;
border:none;
mso-protection:locked visible;}
.xl65
{mso-style-parent:style0;
text-align:left;
color:windowtext;
font-size:10.0pt;
font-family:Arial;
mso-generic-font-family:swiss;
mso-font-charset:0;}
.xl66
{mso-style-parent:style0;
text-align:center;
white-space:normal;
color:windowtext;
font-size:22.0pt;
font-weight:700;
font-family:宋体-简;
mso-font-charset:134;}
.xl67
{mso-style-parent:style0;
text-align:left;
white-space:normal;
color:windowtext;
font-size:10.0pt;
font-family:宋体-简;
mso-font-charset:134;}
.xl68
{mso-style-parent:style0;
text-align:left;
color:windowtext;
font-size:10.0pt;
text-decoration:underline;
text-underline-style:single;
font-family:宋体-简;
mso-font-charset:134;}
.xl69
{mso-style-parent:style0;
text-align:left;
white-space:normal;
color:windowtext;
font-size:10.0pt;
font-family:Arial;
mso-generic-font-family:swiss;
mso-font-charset:0;}
.xl70
{mso-style-parent:style0;
text-align:center;
white-space:normal;
color:windowtext;
font-size:22.0pt;
font-weight:700;
font-family:Arial;
mso-generic-font-family:swiss;
mso-font-charset:0;}
}
</style>
<!--立陶宛语的CSS-->
<style lang="scss" scoped>
.lt {
tr
{mso-height-source:auto;
  mso-ruby-visibility:none;}
col
{mso-width-source:auto;
  mso-ruby-visibility:none;}
br
{mso-data-placement:same-cell;}
.font0
{color:#000000;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:"宋体";
  mso-generic-font-family:auto;
  mso-font-charset:134;}
.font1
{color:#FF0000;
  font-size:10.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:"Arial";
  mso-generic-font-family:swiss;
  mso-font-charset:0;}
.font2
{color:windowtext;
  font-size:22.0pt;
  font-weight:700;
  font-style:normal;
  text-decoration:none;
  font-family:"Times New Roman Regular";
  mso-generic-font-family:swiss;
  mso-font-charset:0;}
.font3
{color:windowtext;
  font-size:10.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:"Times New Roman Regular";
  mso-generic-font-family:swiss;
  mso-font-charset:0;}
.font4
{color:windowtext;
  font-size:10.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:underline;
  text-underline-style:single;
  font-family:"Times New Roman Regular";
  mso-generic-font-family:swiss;
  mso-font-charset:0;}
.font5
{color:windowtext;
  font-size:24.0pt;
  font-weight:700;
  font-style:normal;
  text-decoration:none;
  font-family:"Times New Roman Regular";
  mso-generic-font-family:swiss;
  mso-font-charset:0;}
.font6
{color:windowtext;
  font-size:10.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:"Arial";
  mso-generic-font-family:swiss;
  mso-font-charset:0;}
.font7
{color:#000000;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:"宋体";
  mso-generic-font-family:auto;
  mso-font-charset:0;}
.font8
{color:#3F3F76;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:"宋体";
  mso-generic-font-family:auto;
  mso-font-charset:0;}
.font9
{color:#9C0006;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:"宋体";
  mso-generic-font-family:auto;
  mso-font-charset:0;}
.font10
{color:#FFFFFF;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:"宋体";
  mso-generic-font-family:auto;
  mso-font-charset:0;}
.font11
{color:#0000FF;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:underline;
  text-underline-style:single;
  font-family:"宋体";
  mso-generic-font-family:auto;
  mso-font-charset:0;}
.font12
{color:#800080;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:underline;
  text-underline-style:single;
  font-family:"宋体";
  mso-generic-font-family:auto;
  mso-font-charset:0;}
.font13
{color:#44546A;
  font-size:11.0pt;
  font-weight:700;
  font-style:normal;
  text-decoration:none;
  font-family:"宋体";
  mso-generic-font-family:auto;
  mso-font-charset:134;}
.font14
{color:#FF0000;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:"宋体";
  mso-generic-font-family:auto;
  mso-font-charset:0;}
.font15
{color:#44546A;
  font-size:18.0pt;
  font-weight:700;
  font-style:normal;
  text-decoration:none;
  font-family:"宋体";
  mso-generic-font-family:auto;
  mso-font-charset:134;}
.font16
{color:#7F7F7F;
  font-size:11.0pt;
  font-weight:400;
  font-style:italic;
  text-decoration:none;
  font-family:"宋体";
  mso-generic-font-family:auto;
  mso-font-charset:0;}
.font17
{color:#44546A;
  font-size:15.0pt;
  font-weight:700;
  font-style:normal;
  text-decoration:none;
  font-family:"宋体";
  mso-generic-font-family:auto;
  mso-font-charset:134;}
.font18
{color:#44546A;
  font-size:13.0pt;
  font-weight:700;
  font-style:normal;
  text-decoration:none;
  font-family:"宋体";
  mso-generic-font-family:auto;
  mso-font-charset:134;}
.font19
{color:#3F3F3F;
  font-size:11.0pt;
  font-weight:700;
  font-style:normal;
  text-decoration:none;
  font-family:"宋体";
  mso-generic-font-family:auto;
  mso-font-charset:0;}
.font20
{color:#FA7D00;
  font-size:11.0pt;
  font-weight:700;
  font-style:normal;
  text-decoration:none;
  font-family:"宋体";
  mso-generic-font-family:auto;
  mso-font-charset:0;}
.font21
{color:#FFFFFF;
  font-size:11.0pt;
  font-weight:700;
  font-style:normal;
  text-decoration:none;
  font-family:"宋体";
  mso-generic-font-family:auto;
  mso-font-charset:0;}
.font22
{color:#FA7D00;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:"宋体";
  mso-generic-font-family:auto;
  mso-font-charset:0;}
.font23
{color:#000000;
  font-size:11.0pt;
  font-weight:700;
  font-style:normal;
  text-decoration:none;
  font-family:"宋体";
  mso-generic-font-family:auto;
  mso-font-charset:0;}
.font24
{color:#006100;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:"宋体";
  mso-generic-font-family:auto;
  mso-font-charset:0;}
.font25
{color:#9C6500;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:"宋体";
  mso-generic-font-family:auto;
  mso-font-charset:0;}
.style0
{mso-number-format:"General";
  text-align:general;
  vertical-align:middle;
  white-space:nowrap;
  mso-rotate:0;
  mso-pattern:auto;
  mso-background-source:auto;
  color:#000000;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:134;
  border:none;
  mso-protection:locked visible;
  mso-style-name:"常规";
  mso-style-id:0;}
.style16
{mso-number-format:"_ \0022\00A5\0022* \#\,\#\#0_ \;_ \0022\00A5\0022* \\-\#\,\#\#0_ \;_ \0022\00A5\0022* \0022-\0022_ \;_ \@_ ";
  mso-style-name:"货币[0]";
  mso-style-id:7;}
.style17
{mso-pattern:auto none;
  background:#EDEDED;
  color:#000000;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  mso-style-name:"20% - 强调文字颜色 3";}
.style18
{mso-pattern:auto none;
  background:#FFCC99;
  color:#3F3F76;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  border:.5pt solid #7F7F7F;
  mso-style-name:"输入";}
.style19
{mso-number-format:"_ \0022\00A5\0022* \#\,\#\#0\.00_ \;_ \0022\00A5\0022* \\-\#\,\#\#0\.00_ \;_ \0022\00A5\0022* \0022-\0022??_ \;_ \@_ ";
  mso-style-name:"货币";
  mso-style-id:4;}
.style20
{mso-number-format:"_ * \#\,\#\#0_ \;_ * \\-\#\,\#\#0_ \;_ * \0022-\0022_ \;_ \@_ ";
  mso-style-name:"千位分隔[0]";
  mso-style-id:6;}
.style21
{mso-pattern:auto none;
  background:#DBDBDB;
  color:#000000;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  mso-style-name:"40% - 强调文字颜色 3";}
.style22
{mso-pattern:auto none;
  background:#FFC7CE;
  color:#9C0006;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  mso-style-name:"差";}
.style23
{mso-number-format:"_ * \#\,\#\#0\.00_ \;_ * \\-\#\,\#\#0\.00_ \;_ * \0022-\0022??_ \;_ \@_ ";
  mso-style-name:"千位分隔";
  mso-style-id:3;}
.style24
{mso-pattern:auto none;
  background:#C9C9C9;
  color:#FFFFFF;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  mso-style-name:"60% - 强调文字颜色 3";}
.style25
{color:#0000FF;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:underline;
  text-underline-style:single;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  mso-style-name:"超链接";
  mso-style-id:8;}
.style26
{mso-number-format:"0%";
  mso-style-name:"百分比";
  mso-style-id:5;}
.style27
{color:#800080;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:underline;
  text-underline-style:single;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  mso-style-name:"已访问的超链接";
  mso-style-id:9;}
.style28
{mso-pattern:auto none;
  background:#FFFFCC;
  border:.5pt solid #B2B2B2;
  mso-style-name:"注释";}
.style29
{mso-pattern:auto none;
  background:#F4B084;
  color:#FFFFFF;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  mso-style-name:"60% - 强调文字颜色 2";}
.style30
{color:#44546A;
  font-size:11.0pt;
  font-weight:700;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:134;
  mso-style-name:"标题 4";}
.style31
{color:#FF0000;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  mso-style-name:"警告文本";}
.style32
{color:#44546A;
  font-size:18.0pt;
  font-weight:700;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:134;
  mso-style-name:"标题";}
.style33
{color:#7F7F7F;
  font-size:11.0pt;
  font-weight:400;
  font-style:italic;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  mso-style-name:"解释性文本";}
.style34
{color:#44546A;
  font-size:15.0pt;
  font-weight:700;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:134;
  border-bottom:1.0pt solid #5B9BD5;
  mso-style-name:"标题 1";}
.style35
{color:#44546A;
  font-size:13.0pt;
  font-weight:700;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:134;
  border-bottom:1.0pt solid #5B9BD5;
  mso-style-name:"标题 2";}
.style36
{mso-pattern:auto none;
  background:#9BC2E6;
  color:#FFFFFF;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  mso-style-name:"60% - 强调文字颜色 1";}
.style37
{color:#44546A;
  font-size:11.0pt;
  font-weight:700;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:134;
  border-bottom:1.0pt solid #ACCCEA;
  mso-style-name:"标题 3";}
.style38
{mso-pattern:auto none;
  background:#FFD966;
  color:#FFFFFF;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  mso-style-name:"60% - 强调文字颜色 4";}
.style39
{mso-pattern:auto none;
  background:#F2F2F2;
  color:#3F3F3F;
  font-size:11.0pt;
  font-weight:700;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  border:.5pt solid #3F3F3F;
  mso-style-name:"输出";}
.style40
{mso-pattern:auto none;
  background:#F2F2F2;
  color:#FA7D00;
  font-size:11.0pt;
  font-weight:700;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  border:.5pt solid #7F7F7F;
  mso-style-name:"计算";}
.style41
{mso-pattern:auto none;
  background:#A5A5A5;
  color:#FFFFFF;
  font-size:11.0pt;
  font-weight:700;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  border:2.0pt double #3F3F3F;
  mso-style-name:"检查单元格";}
.style42
{mso-pattern:auto none;
  background:#E2EFDA;
  color:#000000;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  mso-style-name:"20% - 强调文字颜色 6";}
.style43
{mso-pattern:auto none;
  background:#ED7D31;
  color:#FFFFFF;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  mso-style-name:"强调文字颜色 2";}
.style44
{color:#FA7D00;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  border-bottom:2.0pt double #FF8001;
  mso-style-name:"链接单元格";}
.style45
{color:#000000;
  font-size:11.0pt;
  font-weight:700;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  border-top:.5pt solid #5B9BD5;
  border-bottom:2.0pt double #5B9BD5;
  mso-style-name:"汇总";}
.style46
{mso-pattern:auto none;
  background:#C6EFCE;
  color:#006100;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  mso-style-name:"好";}
.style47
{mso-pattern:auto none;
  background:#FFEB9C;
  color:#9C6500;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  mso-style-name:"适中";}
.style48
{mso-pattern:auto none;
  background:#D9E1F2;
  color:#000000;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  mso-style-name:"20% - 强调文字颜色 5";}
.style49
{mso-pattern:auto none;
  background:#5B9BD5;
  color:#FFFFFF;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  mso-style-name:"强调文字颜色 1";}
.style50
{mso-pattern:auto none;
  background:#DDEBF7;
  color:#000000;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  mso-style-name:"20% - 强调文字颜色 1";}
.style51
{mso-pattern:auto none;
  background:#BDD7EE;
  color:#000000;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  mso-style-name:"40% - 强调文字颜色 1";}
.style52
{mso-pattern:auto none;
  background:#FCE4D6;
  color:#000000;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  mso-style-name:"20% - 强调文字颜色 2";}
.style53
{mso-pattern:auto none;
  background:#F8CBAD;
  color:#000000;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  mso-style-name:"40% - 强调文字颜色 2";}
.style54
{mso-pattern:auto none;
  background:#A5A5A5;
  color:#FFFFFF;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  mso-style-name:"强调文字颜色 3";}
.style55
{mso-pattern:auto none;
  background:#FFC000;
  color:#FFFFFF;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  mso-style-name:"强调文字颜色 4";}
.style56
{mso-pattern:auto none;
  background:#FFF2CC;
  color:#000000;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  mso-style-name:"20% - 强调文字颜色 4";}
.style57
{mso-pattern:auto none;
  background:#FFE699;
  color:#000000;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  mso-style-name:"40% - 强调文字颜色 4";}
.style58
{mso-pattern:auto none;
  background:#4472C4;
  color:#FFFFFF;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  mso-style-name:"强调文字颜色 5";}
.style59
{mso-pattern:auto none;
  background:#B4C6E7;
  color:#000000;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  mso-style-name:"40% - 强调文字颜色 5";}
.style60
{mso-pattern:auto none;
  background:#8EA9DB;
  color:#FFFFFF;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  mso-style-name:"60% - 强调文字颜色 5";}
.style61
{mso-pattern:auto none;
  background:#70AD47;
  color:#FFFFFF;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  mso-style-name:"强调文字颜色 6";}
.style62
{mso-pattern:auto none;
  background:#C6E0B4;
  color:#000000;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  mso-style-name:"40% - 强调文字颜色 6";}
.style63
{mso-pattern:auto none;
  background:#A9D08E;
  color:#FFFFFF;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:0;
  mso-style-name:"60% - 强调文字颜色 6";}
td
{mso-style-parent:style0;
  padding-top:1px;
  padding-right:1px;
  padding-left:1px;
  mso-ignore:padding;
  mso-number-format:"General";
  text-align:general;
  vertical-align:middle;
  white-space:nowrap;
  mso-rotate:0;
  mso-pattern:auto;
  mso-background-source:auto;
  color:#000000;
  font-size:11.0pt;
  font-weight:400;
  font-style:normal;
  text-decoration:none;
  font-family:宋体;
  mso-generic-font-family:auto;
  mso-font-charset:134;
  border:none;
  mso-protection:locked visible;}
.xl65
{mso-style-parent:style0;
  text-align:left;
  color:#FF0000;
  font-size:10.0pt;
  font-family:Arial;
  mso-generic-font-family:swiss;
  mso-font-charset:0;}
.xl66
{mso-style-parent:style0;
  text-align:center;
  white-space:normal;
  color:windowtext;
  font-size:22.0pt;
  font-weight:700;
  font-family:Times New Roman Regular;
  mso-generic-font-family:swiss;
  mso-font-charset:0;}
.xl67
{mso-style-parent:style0;
  text-align:left;
  white-space:normal;
  color:windowtext;
  font-size:10.0pt;
  font-family:Times New Roman Regular;
  mso-generic-font-family:swiss;
  mso-font-charset:0;}
.xl68
{mso-style-parent:style0;
  text-align:left;
  white-space:normal;
  color:windowtext;
  font-size:10.0pt;
  text-decoration:underline;
  text-underline-style:single;
  font-family:Times New Roman Regular;
  mso-generic-font-family:swiss;
  mso-font-charset:0;}
.xl69
{mso-style-parent:style0;
  text-align:left;
  color:windowtext;
  font-size:10.0pt;
  font-family:Times New Roman Regular;
  mso-generic-font-family:swiss;
  mso-font-charset:0;}
.xl70
{mso-style-parent:style0;
  text-align:center;
  white-space:normal;
  color:windowtext;
  font-size:24.0pt;
  font-weight:700;
  font-family:Times New Roman Regular;
  mso-generic-font-family:swiss;
  mso-font-charset:0;}
.xl71
{mso-style-parent:style0;
  text-align:left;
  color:windowtext;
  font-size:10.0pt;
  font-family:Arial;
  mso-generic-font-family:swiss;
  mso-font-charset:0;}

}
</style>
<!--俄语的CSS-->
<style lang="scss" scoped>
.rus{
tr
{mso-height-source:auto;
mso-ruby-visibility:none;}
col
{mso-width-source:auto;
mso-ruby-visibility:none;}
br
{mso-data-placement:same-cell;}
.font0
{color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:134;}
.font1
{color:windowtext;
font-size:10.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:"Arial";
mso-generic-font-family:swiss;
mso-font-charset:0;}
.font2
{color:windowtext;
font-size:24.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:"Times New Roman Regular";
mso-generic-font-family:swiss;
mso-font-charset:0;}
.font3
{color:windowtext;
font-size:10.5pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:"Times New Roman Regular";
mso-generic-font-family:swiss;
mso-font-charset:0;}
.font4
{color:windowtext;
font-size:10.5pt;
font-weight:400;
font-style:normal;
text-decoration:underline;
text-underline-style:single;
font-family:"Times New Roman Regular";
mso-generic-font-family:swiss;
mso-font-charset:0;}
.font5
{color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font6
{color:#3F3F76;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font7
{color:#9C0006;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font8
{color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font9
{color:#0000FF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:underline;
text-underline-style:single;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font10
{color:#800080;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:underline;
text-underline-style:single;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font11
{color:#44546A;
font-size:11.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:134;}
.font12
{color:#FF0000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font13
{color:#44546A;
font-size:18.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:134;}
.font14
{color:#7F7F7F;
font-size:11.0pt;
font-weight:400;
font-style:italic;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font15
{color:#44546A;
font-size:15.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:134;}
.font16
{color:#44546A;
font-size:13.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:134;}
.font17
{color:#3F3F3F;
font-size:11.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font18
{color:#FA7D00;
font-size:11.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font19
{color:#FFFFFF;
font-size:11.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font20
{color:#FA7D00;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font21
{color:#000000;
font-size:11.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font22
{color:#006100;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.font23
{color:#9C6500;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:"宋体";
mso-generic-font-family:auto;
mso-font-charset:0;}
.style0
{mso-number-format:"General";
text-align:general;
vertical-align:middle;
white-space:nowrap;
mso-rotate:0;
mso-pattern:auto;
mso-background-source:auto;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:134;
border:none;
mso-protection:locked visible;
mso-style-name:"常规";
mso-style-id:0;}
.style16
{mso-number-format:"_ \0022\00A5\0022* \#\,\#\#0_ \;_ \0022\00A5\0022* \\-\#\,\#\#0_ \;_ \0022\00A5\0022* \0022-\0022_ \;_ \@_ ";
mso-style-name:"货币[0]";
mso-style-id:7;}
.style17
{mso-pattern:auto none;
background:#EDEDED;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"20% - 强调文字颜色 3";}
.style18
{mso-pattern:auto none;
background:#FFCC99;
color:#3F3F76;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
border:.5pt solid #7F7F7F;
mso-style-name:"输入";}
.style19
{mso-number-format:"_ \0022\00A5\0022* \#\,\#\#0\.00_ \;_ \0022\00A5\0022* \\-\#\,\#\#0\.00_ \;_ \0022\00A5\0022* \0022-\0022??_ \;_ \@_ ";
mso-style-name:"货币";
mso-style-id:4;}
.style20
{mso-number-format:"_ * \#\,\#\#0_ \;_ * \\-\#\,\#\#0_ \;_ * \0022-\0022_ \;_ \@_ ";
mso-style-name:"千位分隔[0]";
mso-style-id:6;}
.style21
{mso-pattern:auto none;
background:#DBDBDB;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"40% - 强调文字颜色 3";}
.style22
{mso-pattern:auto none;
background:#FFC7CE;
color:#9C0006;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"差";}
.style23
{mso-number-format:"_ * \#\,\#\#0\.00_ \;_ * \\-\#\,\#\#0\.00_ \;_ * \0022-\0022??_ \;_ \@_ ";
mso-style-name:"千位分隔";
mso-style-id:3;}
.style24
{mso-pattern:auto none;
background:#C9C9C9;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"60% - 强调文字颜色 3";}
.style25
{color:#0000FF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:underline;
text-underline-style:single;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"超链接";
mso-style-id:8;}
.style26
{mso-number-format:"0%";
mso-style-name:"百分比";
mso-style-id:5;}
.style27
{color:#800080;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:underline;
text-underline-style:single;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"已访问的超链接";
mso-style-id:9;}
.style28
{mso-pattern:auto none;
background:#FFFFCC;
border:.5pt solid #B2B2B2;
mso-style-name:"注释";}
.style29
{mso-pattern:auto none;
background:#F4B084;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"60% - 强调文字颜色 2";}
.style30
{color:#44546A;
font-size:11.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:134;
mso-style-name:"标题 4";}
.style31
{color:#FF0000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"警告文本";}
.style32
{color:#44546A;
font-size:18.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:134;
mso-style-name:"标题";}
.style33
{color:#7F7F7F;
font-size:11.0pt;
font-weight:400;
font-style:italic;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"解释性文本";}
.style34
{color:#44546A;
font-size:15.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:134;
border-bottom:1.0pt solid #5B9BD5;
mso-style-name:"标题 1";}
.style35
{color:#44546A;
font-size:13.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:134;
border-bottom:1.0pt solid #5B9BD5;
mso-style-name:"标题 2";}
.style36
{mso-pattern:auto none;
background:#9BC2E6;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"60% - 强调文字颜色 1";}
.style37
{color:#44546A;
font-size:11.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:134;
border-bottom:1.0pt solid #ACCCEA;
mso-style-name:"标题 3";}
.style38
{mso-pattern:auto none;
background:#FFD966;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"60% - 强调文字颜色 4";}
.style39
{mso-pattern:auto none;
background:#F2F2F2;
color:#3F3F3F;
font-size:11.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
border:.5pt solid #3F3F3F;
mso-style-name:"输出";}
.style40
{mso-pattern:auto none;
background:#F2F2F2;
color:#FA7D00;
font-size:11.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
border:.5pt solid #7F7F7F;
mso-style-name:"计算";}
.style41
{mso-pattern:auto none;
background:#A5A5A5;
color:#FFFFFF;
font-size:11.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
border:2.0pt double #3F3F3F;
mso-style-name:"检查单元格";}
.style42
{mso-pattern:auto none;
background:#E2EFDA;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"20% - 强调文字颜色 6";}
.style43
{mso-pattern:auto none;
background:#ED7D31;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"强调文字颜色 2";}
.style44
{color:#FA7D00;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
border-bottom:2.0pt double #FF8001;
mso-style-name:"链接单元格";}
.style45
{color:#000000;
font-size:11.0pt;
font-weight:700;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
border-top:.5pt solid #5B9BD5;
border-bottom:2.0pt double #5B9BD5;
mso-style-name:"汇总";}
.style46
{mso-pattern:auto none;
background:#C6EFCE;
color:#006100;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"好";}
.style47
{mso-pattern:auto none;
background:#FFEB9C;
color:#9C6500;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"适中";}
.style48
{mso-pattern:auto none;
background:#D9E1F2;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"20% - 强调文字颜色 5";}
.style49
{mso-pattern:auto none;
background:#5B9BD5;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"强调文字颜色 1";}
.style50
{mso-pattern:auto none;
background:#DDEBF7;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"20% - 强调文字颜色 1";}
.style51
{mso-pattern:auto none;
background:#BDD7EE;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"40% - 强调文字颜色 1";}
.style52
{mso-pattern:auto none;
background:#FCE4D6;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"20% - 强调文字颜色 2";}
.style53
{mso-pattern:auto none;
background:#F8CBAD;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"40% - 强调文字颜色 2";}
.style54
{mso-pattern:auto none;
background:#A5A5A5;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"强调文字颜色 3";}
.style55
{mso-pattern:auto none;
background:#FFC000;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"强调文字颜色 4";}
.style56
{mso-pattern:auto none;
background:#FFF2CC;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"20% - 强调文字颜色 4";}
.style57
{mso-pattern:auto none;
background:#FFE699;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"40% - 强调文字颜色 4";}
.style58
{mso-pattern:auto none;
background:#4472C4;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"强调文字颜色 5";}
.style59
{mso-pattern:auto none;
background:#B4C6E7;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"40% - 强调文字颜色 5";}
.style60
{mso-pattern:auto none;
background:#8EA9DB;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"60% - 强调文字颜色 5";}
.style61
{mso-pattern:auto none;
background:#70AD47;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"强调文字颜色 6";}
.style62
{mso-pattern:auto none;
background:#C6E0B4;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"40% - 强调文字颜色 6";}
.style63
{mso-pattern:auto none;
background:#A9D08E;
color:#FFFFFF;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:0;
mso-style-name:"60% - 强调文字颜色 6";}
td
{mso-style-parent:style0;
padding-top:1px;
padding-right:1px;
padding-left:1px;
mso-ignore:padding;
mso-number-format:"General";
text-align:general;
vertical-align:middle;
white-space:nowrap;
mso-rotate:0;
mso-pattern:auto;
mso-background-source:auto;
color:#000000;
font-size:11.0pt;
font-weight:400;
font-style:normal;
text-decoration:none;
font-family:宋体;
mso-generic-font-family:auto;
mso-font-charset:134;
border:none;
mso-protection:locked visible;}
.xl65
{mso-style-parent:style0;
text-align:left;
color:windowtext;
font-size:10.0pt;
font-family:Arial;
mso-generic-font-family:swiss;
mso-font-charset:0;}
.xl66
{mso-style-parent:style0;
text-align:left;
white-space:normal;
color:windowtext;
font-size:24.0pt;
font-weight:700;
font-family:Times New Roman Regular;
mso-generic-font-family:swiss;
mso-font-charset:0;}
.xl67
{mso-style-parent:style0;
text-align:left;
white-space:normal;
color:windowtext;
font-size:10.5pt;
font-family:Times New Roman Regular;
mso-generic-font-family:swiss;
mso-font-charset:0;}
.xl68
{mso-style-parent:style0;
text-align:left;
white-space:normal;
color:windowtext;
font-size:10.5pt;
text-decoration:underline;
text-underline-style:single;
font-family:Times New Roman Regular;
mso-generic-font-family:swiss;
mso-font-charset:0;}
}
</style>
